import ButtonInstance from "../components/ButtonInstance";
import ChatWithDocsFlow from "../components/ChatWithDocsFlow";
import {
  getChatDocIdsByLoan,
  getChatDocKey,
  getDocsMissingText,
  groupDocsByLoan,
  loadChatDocsByChatId,
  removeChatDoc,
  replaceLoanChatDocs,
  saveChatDocsForChat,
  setChatDocsForChat,
  toChatDoc,
  toCitationSourceDocuments,
  toInlineChatDocuments,
} from "../helpers/chatDocs";
import { enrichCitations } from "../helpers/citationEnrichment";
import {
  buildCitationViewerRequest,
  getCitationTargetOrigin,
  mergeCitations,
} from "../helpers/citations";
import LoanDocs from "../models/loanDocsModel";
import { getLoanRoleSuggestions } from "../helpers/loanRoleSuggestions";
import {
  extractPreviousUserQuestions,
  shouldGenerateFollowUps,
} from "../helpers/askAddyFollowUps";
import { getComposerOverlapPaddingPx } from "../helpers/composerReservedSpace";
import { markLatestResponseCanceled } from "../helpers/canceledResponse";
import {
  isDocumentPortalMode,
  normalizeCompareGuidelinesMode,
  useChatWithDocsCapability,
} from "../helpers/chatWithDocsCapability";
import {
  requestDocumentPortalIdToken,
  resolveEmbeddedSidebarIdToken,
} from "../helpers/documentPortalAuth";
import { getInternalNavigationLayout } from "../helpers/internalNavigation";
import { appendCanceledNotice } from "../helpers/responseCanceledNotice";
import AskAddyFollowUpModel from "../models/askAddyFollowUpModel";
import "./Chat.css";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ChatAssistantDropDown2 from "./ChatAssistantDropdown2";
import MessageText from "../components/MessageText";
import UserModel from "../models/userModel";
import User from "../models/user";
import Assistant from "../models/assistantModel";
import AskAddyV2, { newThreadId } from "../models/askAddyV2";
import LendyHeader from "../askAddyV2/LendyHeader";
import { useClientChatLink } from "../askAddyV2/useClientChatLink";
import LendyIcon from "../components/lendy/LendyIcon";
import WindowControls from "../components/WindowControls";
import { useSidebarWindow } from "../hooks/useSidebarWindow";
import useWideSidebar from "../askAddyV2/useWideSidebar";
import AskAddyV2Chat from "../askAddyV2/AskAddyV2Chat";
import { preloadImages } from "../askAddyV2/imagePreload";
import AutopilotPanel from "../askAddyV2/AutopilotPanel";
import AgentMenu from "../askAddyV2/AgentMenu";
import { cacheAssistant, readCachedAssistant } from "../askAddyV2/assistantCache";
// eslint-disable-next-line no-unused-vars
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import EmailActionNavigationBreadCrumbs from "../components/EmailActionNavigationBreadCrumbs";
import IframeContainer from "../components/IframeContainer";
import React from "react";

import { v4 as uuidv4 } from "uuid";
import ChatHistoryDropdown from "../components/ChatHistoryDropdown";
import { V2ChatsRail } from "../askAddyV2/V2ChatsDrawer";
import V2ChatSearch from "../askAddyV2/V2ChatSearch";
import AppsPage from "../askAddyV2/apps/AppsPage";
import { readConnectedAppLanding } from "../askAddyV2/apps/connectedAppLanding";
import { OPEN_PROFILE_EVENT } from "../askAddyV2/agentNews";
import { compareGuidelinesLoadingStatements } from "../helpers/loadingStatements";
import BackgroundSearch from "./BackgroundSearch";
import sampleHtml from "./sampleHtml";
import InjectHTML from "../components/InjectHTML";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Tooltip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Drawer, Button, Box } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import BarChartIcon from "@mui/icons-material/BarChart";
import RequireUpgradeModal from "../components/RequireUpgradeModal";

import { useVoiceSession } from "../hooks/useVoiceSession";
import {
  getStreamEventKind,
  useStreamStallWatchdog,
} from "../hooks/useStreamStallWatchdog";
import { useOrganization, applyQueryBrandCssVariables } from "../contexts/OrganizationContext";
import GlobalVariables from "../models/globalVariables";
import { resolvePreferredFallbackAssistant } from "../helpers/assistantFallback";
import {
  appendLocalBrowserHistory,
  assertLocalBrowserResult,
  buildLocalBrowserMemoryCommand,
  buildLocalBrowserRunCommand,
  createConfirmationGate,
  createLocalBrowserRpc,
  getLocalBrowserExecutorAction,
  getLocalBrowserTaskIntent,
  collectListingObservation,
  getBlockedAddToCartScrollError,
  getUnverifiedCartDoneError,
  getUnverifiedCompareDoneError,
  getUnverifiedEmailDraftDoneError,
  getBlockedDraftSendError,
  getUnverifiedFilingDoneError,
  abortLocalBrowserTask,
  probeLocalBrowserAgent,
  CHALLENGE_ALTERNATE_ERROR,
  isChallengeAsk,
  isRetryableLocalBrowserFailure,
  lastActionNeedsVisual,
  requestLocalBrowserStep,
} from "../helpers/localBrowserAgent";
import {
  GUIDE_PROGRESS_MESSAGE_KEY,
  formatGuideProgressMessage,
} from "../utils/guidedWalkthrough";
import {
  getOrganizationWhiteLabelAssistantName,
  getOrganizationAvatarUrl,
  getWhiteLabeledAssistantName,
  resolveSidebarLogoUrl,
  truncateAssistantName,
} from "../helpers/whiteLabelAssistantName";
import { ChatBubbleOutline, GradingOutlined, KeyboardArrowDown } from "@mui/icons-material";
import SidebarChatHistoryModel from "../models/sidebarChatHistoryModel";
import { readScopedChatId } from "../helpers/scopedChat";
import { readOpenThreadId } from "../helpers/openThread";
import { notifyScenarioChatMessage, scenarioIdFromChatId } from "../helpers/scenarioChatMessage";
import { readScenarioQuestions } from "../helpers/scenarioQuestions";
import { resolveLinkReferences } from "../utils/linkReferences";
import { getProvisionalChatName } from "../utils/chatNaming";

// How long a conversation the web app asked to open waits for its loan to be the open one.
const OPEN_THREAD_REQUEST_TTL_MS = 10_000;

const getBrowserHostName = () =>
  typeof window !== "undefined" ? window.location.host : "";

const isBrowserWideScreen = () =>
  typeof window !== "undefined" ? window.innerWidth >= 768 : true;

const REQUEST_TIMEOUT_MESSAGE =
  "The agent took too long to respond, so I stopped that run. Please try again.";

const isRequestTimeoutMessage = (text) =>
  typeof text === "string" && text.toLowerCase().includes("request timed out");

const AUTO_RETRY_MAX_ATTEMPTS = 2;

/**
 * Detect gobbled AI responses — clusters of random letter/digit tokens that
 * look nothing like natural language. Used by onSendButtonClick to decide
 * whether to auto-retry a bad response.
 *
 * Design:
 *   1. Strip non-prose (code blocks, inline code, URLs, markdown links/images)
 *      so legitimate structured content can't false-flag.
 *   2. Classify each remaining whitespace-separated token as "garbage" if it
 *      matches EITHER signal and contains no structural characters:
 *        (a) mixed letters+digits with length >= 9 (hash-like noise)
 *        (b) pure-letter token with an impossibly long consonant run (>= 5)
 *            OR a very low vowel ratio (< 0.20) — implicit bigram signals
 *            catching gibberish whose character transitions don't match English.
 *   3. Flag the response only if a streak of 3+ consecutive garbage tokens
 *      appears — requiring a cluster (not a scattered count) eliminates the
 *      "prose happens to mention one identifier" false-positive class.
 *
 * Intentionally conservative: we'd rather miss some gobbled responses than
 * retry a clean one.
 */
const looksLikeGibberishResponse = (text) => {
  if (typeof text !== "string" || text.length < 60) return false;

  // Step 1: Strip legitimate structured content.
  const prose = text
    .replace(/```[\s\S]*?```/g, " ")             // fenced code blocks
    .replace(/`[^`]*`/g, " ")                     // inline code
    .replace(/https?:\/\/\S+/gi, " ")             // http(s) URLs
    .replace(/ftp:\/\/\S+/gi, " ")                // ftp URLs
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, " ")      // markdown images
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1");     // markdown links → link text

  const tokens = prose.split(/\s+/).filter(Boolean);
  if (tokens.length < 10) return false;

  // Strip leading/trailing punctuation (unicode-aware).
  const stripPunct = (raw) =>
    raw.replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, "");

  // Reject tokens containing structural chars — these are tool calls, paths,
  // URLs, versions, slugs, snake_case, kebab-case identifiers, etc. `;` and
  // `:` are the only inner "noise" chars allowed.
  const hasStructuralChar = (t) => /[^\p{L}\p{N};:]/u.test(t);

  // Signal A — mixed-alphanumeric hash-like noise (e.g., "paystUbseA1rX0l").
  const isMixedAlnumGarbage = (t) => {
    if (t.length < 9) return false;
    if (!/\p{L}/u.test(t)) return false;
    if (!/\p{N}/u.test(t)) return false;
    return true;
  };

  // Signal B — pure-letter linguistic anomaly. Catches consonant-heavy or
  // vowel-starved gibberish (real English almost never has 5+ consonants in
  // a row, and 7+ char words almost always exceed 20% vowels).
  const isLinguisticallyBadLetterToken = (t) => {
    if (t.length < 7) return false;
    if (!/^\p{L}+$/u.test(t)) return false;
    const consRuns = t.match(
      /[bcdfghjklmnpqrstvwxyzBCDFGHJKLMNPQRSTVWXYZ]+/g,
    ) || [];
    const maxConsRun = consRuns.reduce(
      (m, s) => Math.max(m, s.length),
      0,
    );
    if (maxConsRun >= 5) return true;
    const vowels = (t.match(/[aeiouAEIOU]/g) || []).length;
    if (vowels / t.length < 0.20) return true;
    return false;
  };

  const isGarbageToken = (raw) => {
    const t = stripPunct(raw);
    if (!t) return false;
    if (hasStructuralChar(t)) return false;
    return isMixedAlnumGarbage(t) || isLinguisticallyBadLetterToken(t);
  };

  // Step 3: Find the longest streak of CONSECUTIVE garbage tokens.
  let longestStreak = 0;
  let currentStreak = 0;
  for (const raw of tokens) {
    if (isGarbageToken(raw)) {
      currentStreak++;
      if (currentStreak > longestStreak) longestStreak = currentStreak;
    } else {
      currentStreak = 0;
    }
  }

  return longestStreak >= 3;
};

const CHAT_BOTTOM_THRESHOLD_PX = 64;

// Loan-scoped chat storage key - maps loanId to chatId
const LOAN_CHATS_KEY = "addy-ai-loan-chats";
const ASK_ADDY_QUERY_QUEUED_MESSAGE =
  "Queued. Addy will answer this after the current response.";

const normalizeAskAddyContextDocuments = (contextDocuments) =>
  Array.isArray(contextDocuments)
    ? contextDocuments.map((document, index) => ({
        name: document?.name || `Addy screen context ${index + 1}.txt`,
        textContent: document?.textContent || "",
        type: document?.type || "text/plain",
      }))
    : [];

const normalizeExternalAskAddyQueryPayload = (value) => {
  if (typeof value === "string") {
    const query = value.trim();
    if (!query) return null;
    return {
      query,
      displayQuery: query,
      contextDocuments: [],
      pricingContext: false,
      startNewConversation: false,
    };
  }

  if (!value || typeof value !== "object" || !value.query) {
    return null;
  }

  return {
    query: value.query,
    displayQuery: value.displayQuery || value.query,
    contextDocuments: normalizeAskAddyContextDocuments(value.contextDocuments),
    pricingContext: !!value.pricingContext,
    startNewConversation: !!value.startNewConversation,
  };
};

const BRAND_QUERY_PARAM_KEYS = [
  "brandPrimaryColor",
  "brandSelectedColor",
  "brandLabelColor",
  "brandGradientMiddle",
  "brandGradientEnd",
  "brandLogoUrl",
  "brandAppName",
  "brandAssistantName",
  "brandFaviconUrl",
  "brandingSlug",
];

const appendBrandParamsToUrl = (url, sourceParams) => {
  try {
    const nextUrl = new URL(url);
    BRAND_QUERY_PARAM_KEYS.forEach((key) => {
      const value = sourceParams.get(key);
      if (value && !nextUrl.searchParams.has(key)) {
        nextUrl.searchParams.set(key, value);
      }
    });
    return nextUrl.toString();
  } catch (error) {
    const brandParams = BRAND_QUERY_PARAM_KEYS
      .map((key) => [key, sourceParams.get(key)])
      .filter(([, value]) => value)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join("&");

    if (!brandParams) return url;
    return `${url}${url.includes("?") ? "&" : "?"}${brandParams}`;
  }
};

// The chats drawer collapsed to its icon rail (v2). The rail shows from this sidebar width up;
// narrower, the chat keeps every pixel and the drawer slides over it.
const V2_RAIL_WIDTH = 56;
const V2_RAIL_MIN_SIDEBAR_WIDTH = 520;
// The panel the rail opens beside itself: the chats list or Lendy's profile.
const V2_PANEL_WIDTH = 320;
// Addy's built-in agents have no instructions or knowledge of their own: the new Ask Addy
// answers as itself for them. "Addy AI" stands for it in the agent menu.
const DEFAULT_AGENT_ID_PREFIX = "addy-default-assistant";
const ADDY_DEFAULT_AGENT_ID = "addy-default-assistant-c66e0609-371e-49b2-bb4a-5186526b2a9d";
const getAgentId = (agent) => agent?.appID || agent?.appName || "";

const Chat = () => {
  // Get URL search params, uid, email, token, name.
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const hostName = getBrowserHostName();

  const uid = urlParams.get("uid");
  const organizationId = urlParams.get("organizationId");
  const loanId = urlParams.get("loanId"); // Current loan context for Ask Addy queries
  const initialScopedChatId = readScopedChatId(urlParams.get("chatId"));
  const email = urlParams.get("email");
  const { selectedOrganizationId, selectedOrganization, queryBrandSettings, setSelectedOrganizationId } = useOrganization();
  
  // Debug: Log loanId from URL on component load
  // State to track current loan context (can be updated via postMessage)
  const [currentLoanId, setCurrentLoanId] = useState(loanId);
  const [currentOrganizationId, setCurrentOrganizationId] = useState(organizationId);
  // Ask Addy v2 (local testing): the open conversation. null = the loan's default conversation.
  // The web app links straight to one of the person's conversations: Scenario Home to a recent one,
  // a notification to the one it is about (on its loan when it has one).
  const [v2ThreadId, setV2ThreadId] = useState(() =>
    readOpenThreadId(urlParams.get("threadId"), { organizationId, userId: uid, loanId }),
  );
  // A conversation the web app asked to open while the sidebar was already open (a notification).
  const [v2RequestedThreadId, setV2RequestedThreadId] = useState(null);
  // The agent the new Ask Addy answers as: picked in the agent menu (null = the organization's
  // default). The menu opens under the header's name.
  const [v2AgentId, setV2AgentId] = useState(null);
  const [agentMenuAnchor, setAgentMenuAnchor] = useState(null);
  // v2: the chat, the assistant's profile (Autopilot, opened from the header: identity and scheduled
  // tasks) or the Apps & MCP page ("apps", which fills the chat's place). With room, the profile opens in
  // the left panel; a narrow sidebar shows it over the chat.
  // Back from an app's sign-in, the web app opens the sidebar on Apps & MCP to show it connected.
  const [v2AppsLanding, setV2AppsLanding] = useState(() =>
    readConnectedAppLanding({ connectedApp: urlParams.get("connectedApp"), connectStatus: urlParams.get("connectStatus") })
  );
  const [v2View, setV2View] = useState(() => (v2AppsLanding ? "apps" : "chat"));
  // Counts chats picked in the list, so picking the one already open still reloads it.
  const [v2OpenCount, setV2OpenCount] = useState(0);
  // What the assistant is doing (the header's dot), also shown on the rail's assistant.
  const [v2StatusTone, setV2StatusTone] = useState("");
  // A new chat's welcome shows the assistant (and its agent switcher), so the header doesn't.
  const [isV2NewChat, setIsV2NewChat] = useState(false);
  // The profile tab Autopilot opens on.
  const [v2ProfileTab, setV2ProfileTab] = useState("identity");
  useEffect(() => {
    if (v2View === "chat") setV2ProfileTab("identity");
  }, [v2View]);
  // What the assistant is doing in the chat (running, waiting on you), for the header's dot.
  const [v2Run, setV2Run] = useState({});
  // A question from the web app's Ask box, waiting for its v2 conversation to open.
  const [v2AskAddyQuery, setV2AskAddyQuery] = useState(null);
  // The open scenario's follow-ups from the page, with the origin they came from to answer to.
  const [v2ScenarioQuestions, setV2ScenarioQuestions] = useState(null);
  const isWideSidebar = useWideSidebar();
  // The conversation the page pinned (a Scenario Center scenario's); v2 reads the open scenario from it.
  const [v2ScopedChatId, setV2ScopedChatId] = useState(initialScopedChatId);
  const v2ScenarioId = scenarioIdFromChatId({
    chatId: v2ScopedChatId,
    organizationId: currentOrganizationId || selectedOrganizationId || organizationId,
    userId: uid,
  });
  // Another loan or scenario opens its own default conversation. An effect on the value, not the
  // parent's context messages: that listener's closure can hold a stale loan id and fire repeatedly.
  // Only on a real change, so a conversation asked for in the URL stays open.
  const openContextRef = useRef(`${currentLoanId || ""}|${v2ScenarioId || ""}`);
  useEffect(() => {
    const openContext = `${currentLoanId || ""}|${v2ScenarioId || ""}`;
    if (openContextRef.current === openContext) {
      return;
    }
    openContextRef.current = openContext;
    setV2ThreadId(null);
  }, [currentLoanId, v2ScenarioId]);
  // Opens a requested conversation once it belongs to the open loan. The page can send it just
  // before the new loan's context, so a request waits a few seconds for its loan, then lapses.
  // Declared after the reset above, so a loan change doesn't close the conversation it opens.
  useEffect(() => {
    if (!v2RequestedThreadId) {
      return;
    }
    if (Date.now() - v2RequestedThreadId.at > OPEN_THREAD_REQUEST_TTL_MS) {
      setV2RequestedThreadId(null);
      return;
    }
    const threadId = readOpenThreadId(v2RequestedThreadId.threadId, {
      organizationId: currentOrganizationId || selectedOrganizationId || organizationId,
      userId: uid,
      loanId: currentLoanId || null,
    });
    if (threadId) {
      setV2RequestedThreadId(null);
      setV2ThreadId(threadId);
      setV2View("chat");
    }
  }, [v2RequestedThreadId, currentLoanId, currentOrganizationId]); // eslint-disable-line -- the identity it is checked against
  // Loan-page member role drives role-specific Credit/Income/Assets dropdowns.
  // Keep the NewFi flag in sync with the parent for organization context.
  const initialMemberRole = urlParams.get("memberRole");
  const initialIsNewfi = urlParams.get("isNewfi") === "1";
  const [currentMemberRole, setCurrentMemberRole] = useState(initialMemberRole || null);
  const [currentIsNewfi, setCurrentIsNewfi] = useState(initialIsNewfi);
  const token =
    urlParams.get("mode") === "documentPortal" ? "" : urlParams.get("token");
  // Ask Addy v2 takes the loan officer from their sign-in token, not from the identity headers:
  // the URL's token when there is one, otherwise the embedding page's (the same as browser use).
  useEffect(() => {
    AskAddyV2.setTokenSource(() => resolveEmbeddedSidebarIdToken({ urlToken: token || "" }));
    return () => AskAddyV2.setTokenSource(null);
  }, [token]);
  const name = urlParams.get("name") || "You";
  const clientID = urlParams.get("clientID");
  const selectedAssistantID = urlParams.get("selectedAssistantID");
  const clientHostname = urlParams.get("clientHostname") || hostName;
  const data = urlParams.get("data") ? JSON.parse(urlParams.get("data")) : {};
  const userImageUrlParam = urlParams.get("userImageUrl");
  const userImageUrl =
    (typeof userImageUrlParam === "string" && userImageUrlParam.trim()) ||
    (typeof data?.userImageUrl === "string" ? data.userImageUrl.trim() : "");
  const assistantName =
    urlParams.get("assistantName") ||
    data?.assistantName ||
    getOrganizationWhiteLabelAssistantName(selectedOrganization) ||
    queryBrandSettings?.assistantName ||
    queryBrandSettings?.appName ||
    "";
  const organizationLogoUrl =
    resolveSidebarLogoUrl(
      getOrganizationAvatarUrl(selectedOrganization) ||
        queryBrandSettings?.logoUrl ||
        data?.organizationLogoUrl ||
        "",
    );

  // react-joyride (v2) does not reliably resolve CSS custom properties for its
  // `primaryColor` option, so the onboarding tour's bottom controls (Back / Next /
  // progress) fall back to the default brand purple. Resolve the brand color to an
  // actual hex so the tour follows white-label branding.
  const isHexColor = (value) =>
    typeof value === "string" && /^#[0-9a-fA-F]{6}$/.test(value.trim());
  const orgBrandSettings = selectedOrganization?.whiteLabelSettings || {};
  const resolvedJoyridePrimaryColor =
    [orgBrandSettings.primaryColor, selectedOrganization?.primaryColor].find(isHexColor)?.trim() ||
    (isHexColor(queryBrandSettings?.primaryColor) ? queryBrandSettings.primaryColor.trim() : "") ||
    (typeof window !== "undefined"
      ? getComputedStyle(document.documentElement).getPropertyValue("--primary-color").trim()
      : "") ||
    "#7150E0";
  const defaultSelectedAssistant = urlParams.get("assistant");
  const urlOverlayMode = urlParams.get("overlayMode");
  const restoreLastChat = urlParams.get("restoreLastChat");
  const currentURL = urlParams.get("currentURL"); // URL of the page where sidebar is embedded
  const mode = urlParams.get("mode"); // "documentPortal" when embedded in borrower portal
  const chatWithDocsCapability = urlParams.get("chatWithDocsEnabled");
  const isCompareGuidelinesEnabled = !isDocumentPortalMode(mode);

  // Debug log for URL params and authentication flow
  // console.log("[Chat Debug] URL params:", {
  //   currentURL,
  //   clientHostname,
  //   uid,
  //   organizationId,
  //   overlayMode: urlOverlayMode,
  //   fullURL: window.location.href,
  // });
  //
  // console.log("[Chat Debug] Auth flow conditions:", {
  //   includesResearch: currentURL?.includes('/research'),
  //   includesAddySo: clientHostname?.includes('addy.so'),
  //   includesLocalhost: clientHostname?.includes('localhost'),
  //   includes127: clientHostname?.includes('127.0.0.1'),
  //   willShowLoginPrompt: !clientHostname?.includes('addy.so') && !clientHostname?.includes('localhost') && !clientHostname?.includes('127.0.0.1'),
  // });

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  // Bumped when a chat is created so ChatHistoryDropdown refetches its list
  const [chatListVersion, setChatListVersion] = useState(0);
  const [isWideScreen, setIsWideScreen] = useState(isBrowserWideScreen);
  const [hasRoomForV2Rail, setHasRoomForV2Rail] = useState(() => window.innerWidth >= V2_RAIL_MIN_SIDEBAR_WIDTH);
  const [compareMode, setCompareMode] = useState(false);
  const [overlayMode, setOverlayMode] = useState(
    urlOverlayMode && urlOverlayMode === "true"
  );
  // v2's chats drawer (board 7) covers most of a narrow sidebar. With room for it, v2 keeps a rail of
  // icons on the left at all times; the chats or Lendy's profile open in a panel beside it, over the
  // chat, which dims behind the panel. Apps & MCP is a page in the chat's place.
  const isV2Rail = AskAddyV2.isEnabled() && hasRoomForV2Rail;
  // With the rail, search chats is a popup over the chat rather than the list's search field.
  const [isV2SearchOpen, setIsV2SearchOpen] = useState(false);
  const v2ClientChat = useClientChatLink(AskAddyV2.isEnabled());
  const internalNavigation = getInternalNavigationLayout({
    mode,
    isWideScreen,
    isDrawerOpen,
  });
  const hasV2Rail = isV2Rail && internalNavigation.isEnabled && !overlayMode;
  const v2Panel = !hasV2Rail
    ? null
    : v2View === "autopilot"
      ? "profile"
      : isDrawerOpen
        ? "chats"
        : null;
  // The rail's panel toggle reopens the panel that was open last.
  const [lastV2Panel, setLastV2Panel] = useState("chats");
  useEffect(() => {
    if (v2Panel) setLastV2Panel(v2Panel);
  }, [v2Panel]);
  // Picking a chat or a place closes the panel: it covers the chat.
  const closesV2PanelOnPick = !isWideScreen || hasV2Rail;
  // An open panel dims the chat: a click there or Escape closes it.
  const hasV2Scrim = Boolean(v2Panel);
  const isV2ProfileBeside = AskAddyV2.isEnabled() && v2View === "autopilot" && isWideSidebar && !hasV2Rail;
  const drawerWidth = !AskAddyV2.isEnabled() ? 240 : !hasV2Rail ? 352 : V2_RAIL_WIDTH + (v2Panel ? V2_PANEL_WIDTH : 0);

  const [searchParams, setSearchParams] = useSearchParams();

  const toggleDrawer = () => {
    if (!internalNavigation.isEnabled) {
      return;
    }

    setIsDrawerOpen((prev) => !prev);
  };

  // The v2 rail: each icon opens its panel beside the rail, and clicking it again closes it.
  const toggleV2Chats = () => {
    if (v2Panel === "chats") {
      setIsDrawerOpen(false);

      return;
    }

    setV2View("chat");
    setIsDrawerOpen(true);
  };

  // The profile (the assistant at the rail's foot) opens its own panel.
  const toggleV2View = (view, panel) => {
    if (v2Panel === panel) {
      setV2View("chat");

      return;
    }

    setIsDrawerOpen(false);
    setV2View(view);
  };

  const toggleV2Panel = () => {
    if (v2Panel) {
      closeV2Panel();

      return;
    }

    if (lastV2Panel === "chats") {
      setIsDrawerOpen(true);

      return;
    }

    setV2View("autopilot");
  };

  const closeV2Panel = () => {
    setIsDrawerOpen(false);
    setV2View("chat");
  };

  // The rail's Apps & MCP icon opens the page and a second click closes it.
  const toggleV2Apps = () => {
    if (v2View === "apps") {
      setV2View("chat");

      return;
    }

    setIsDrawerOpen(false);
    setV2View("apps");
  };

  const renderV2Apps = ({ backLabel, onBack }) => (
    <AppsPage
      organizationId={currentOrganizationId || selectedOrganizationId || organizationId}
      userId={uid}
      loanId={currentLoanId || loanId || ""}
      assistantName={v2Assistant?.name}
      landing={v2AppsLanding}
      backLabel={backLabel}
      onBack={onBack}
    />
  );

  // Lendy's profile: in the left panel, beside the chat on the right, or over the chat.
  const renderV2Profile = ({ isPanel, side }) => (
    <AutopilotPanel
      agentId={v2AgentAppId}
      initialTab={v2ProfileTab}
      organizationId={currentOrganizationId || selectedOrganizationId || organizationId}
      userId={uid}
      loanId={currentLoanId || loanId || ""}
      assistantName={v2Assistant?.name}
      assistantImageUrl={v2Assistant?.imageUrl}
      isPanel={isPanel}
      side={side}
      isCloseInRail={hasV2Rail && side === "left"}
      onTabChange={setV2ProfileTab}
      onClose={() => setV2View("chat")}
      onOpenThread={(threadId) => {
        setV2ThreadId(threadId);
        setV2View("chat");
      }}
    />
  );

  const [recording, setRecording] = useState(false);
  const [voiceMode, setVoiceMode] = useState(false);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const isCompareMode = urlParams.get("compareMode");
  const [isAllowedCompareMode, setIsAllowedCompareMode] = useState(
    isCompareMode || "false"
  );
  const isVoiceMode = urlParams.get("voiceMode");
  const [isAllowedVoiceMode, setIsAllowedVoiceMode] = useState(
    isVoiceMode || "false"
  );
  const [showUpgrade, setShowUpgrade] = useState(false);

  useEffect(() => {
    if (!isCompareGuidelinesEnabled) {
      setCompareMode(false);
    }
  }, [isCompareGuidelinesEnabled]);

  // Clarification state: tracks if we're waiting for clarification response (removed interactive buttons)
  // User now types their selection instead of clicking buttons
  
  // Banner status state
  const [agentStatus, setAgentStatus] = useState({ type: "", message: "" });
  const [hideSkeleton, setHideSkeleton] = useState(false);
  const [followUpSuggestions, setFollowUpSuggestions] = useState([]);
  const [isGeneratingFollowUps, setIsGeneratingFollowUps] = useState(false);
  const followUpRequestIdRef = useRef(0);

  function resetFollowUps() {
    followUpRequestIdRef.current += 1;
    setFollowUpSuggestions([]);
    setIsGeneratingFollowUps(false);
  }

  const [interactionLock, setInteractionLock] = useState(
    /** @type {any} */ (null)
  );
  const interactionLockRef = useRef(/** @type {any} */ (null));
  const [lockCountdown, setLockCountdown] = useState(null);
  const [clarificationPrompt, setClarificationPrompt] = useState(
    /** @type {any} */ (null)
  );
  const clarificationPromptRef = useRef(/** @type {any} */ (null));
  const [activeStreamingMessageId, setActiveStreamingMessageId] =
    useState(null);

  const streamWatchdog = useStreamStallWatchdog({ setAgentStatus });

  // Content mode state: controls whether to show chat UI or nested iframe
  const [contentMode, setContentMode] = useState('chat'); // 'chat' or 'iframe'
  const [iframeUrl, setIframeUrl] = useState('');
  const [iframeTitle, setIframeTitle] = useState('');
  // Force re-render key - increment to force IframeContainer remount
  const [iframeKey, setIframeKey] = useState(0);
  // Skip next auto URL check (to prevent race condition after manual redirect)
  const skipNextUrlCheckRef = useRef(false);
  // UID resolved from iframe after login (addy-session-uid postMessage) when sidebar URL has no uid
  const [resolvedUid, setResolvedUid] = useState(null);
  // Track last processed iframe session uid to avoid repeated recompute loops.
  const lastProcessedSessionUidRef = useRef(null);
  // Keep latest iframe target in refs so async handlers can avoid redundant updates.
  const iframeUrlRef = useRef('');
  const iframeTitleRef = useRef('');

  // Notify parent (chrome extension) when content mode changes
  // This allows the extension to hide/show its close and expand icons
  // to avoid overlap with the iframed content's own UI elements
  useEffect(() => {
    window?.parent?.postMessage({
      key: 'sidebar-iframe-mode',
      value: contentMode === 'iframe'
    }, '*');
  }, [contentMode]);

  useEffect(() => {
    iframeUrlRef.current = iframeUrl;
    iframeTitleRef.current = iframeTitle;
  }, [iframeUrl, iframeTitle]);

  useEffect(() => {
    // Portal identity and organization access are resolved by the backend from
    // the verified Firebase token, so this internal-only lookup is unnecessary.
    if (uid && mode !== "documentPortal") {
      getUserData(uid);
    }
  }, [uid, mode]);

  const getUserData = async (uid) => {
    const organizations = await User.getUserOrganizations(uid);
    // console.log("organizations", organizations);
    if (organizations?.length) {
      // check if any of the organizations have a subscription that is active
      const subscription = organizations.some(
        (org) => org.subscription && org.subscription.status === "active"
      );
      if (!subscription) {
        setIsAllowedCompareMode("false");
        setIsAllowedVoiceMode("false");
      } else {
        setIsAllowedCompareMode("true");
        setIsAllowedVoiceMode("true");
      }
    }
  };

  // NOTE: We no longer pre-check authentication due to third-party cookie restrictions.
  // Instead, we load the iframe directly and let the Login component inside handle auth.
  // When the user successfully logs in via the Login component's simplified iframe flow,
  // we receive a postMessage and reload the iframe to show the content.

  /**
   * Reload the iframe content (called when login is successful)
   * This is triggered by a postMessage from the Login component inside the iframe
   */
  const iframeRef = useRef(null);
  
  const reloadIframeContent = () => {
    // Simply reload the iframe src to trigger a fresh load with the new session
    const iframe = document.getElementById('nested-content-iframe');
    if (iframe && iframe.src) {
      console.log('[Chat] Reloading iframe after successful login');
      iframe.src = iframe.src;
    }
  };

  // Listen for login-related messages from the iframe
  // The Login component sends 'addy-login-success' when user successfully authenticates.
  // The client app sends 'addy-session-uid' when loaded in iframe with a session (so we can recompute LOS loan board URL).
  useEffect(() => {
    const handleLoginMessage = (event) => {
      const data = event.data;
      if (data && data.key === 'addy-login-success') {
        const incomingUid = data.uid ?? null;
        const incomingEmail = data.email ?? null;
        console.log('[Chat] addy-login-success received', { incomingUid, incomingEmail, currentUid: uid, lastProcessed: lastProcessedSessionUidRef.current });

        toastify('Successfully authenticated! Loading content...', true);

        // If the newly authenticated user is different from the uid this sidebar
        // was initialised with (i.e. the user switched providers or accounts),
        // update the resolved uid and recompute the loan board URL for the new account.
        // Otherwise just reload the existing iframe content.
        // NOTE: Login.tsx does NOT call window.location.reload() in iframe mode —
        // this handler is the single source of navigation after login.
        if (incomingUid && incomingUid !== uid && incomingUid !== lastProcessedSessionUidRef.current) {
          console.log('[Chat] addy-login-success: account/provider switch detected — recomputing loan board', { prev: uid, next: incomingUid });
          lastProcessedSessionUidRef.current = incomingUid;
          setResolvedUid(incomingUid);
          checkAndRedirectToLoanBoard(currentURL, null, incomingUid);
        } else {
          console.log('[Chat] addy-login-success: same account — reloading iframe content');
          setTimeout(() => {
            reloadIframeContent();
          }, 500);
        }
      }
      if (data && data.key === 'addy-session-uid' && data.value) {
        const uidFromIframe = data.value;
        if (lastProcessedSessionUidRef.current === uidFromIframe) {
          console.log('[Chat] addy-session-uid: already processed uid', uidFromIframe, '— skipping');
          return;
        }
        lastProcessedSessionUidRef.current = uidFromIframe;
        console.log('[Chat] addy-session-uid received — recomputing loan board target', { uidFromIframe, currentUid: uid });
        setResolvedUid(uidFromIframe);
        checkAndRedirectToLoanBoard(currentURL, null, uidFromIframe);
      }
      if (data && data.key === 'needs-addy-login') {
        console.log('[Chat] needs-addy-login received — iframe is showing login page');
      }
    };

    window.addEventListener('message', handleLoginMessage);
    return () => window.removeEventListener('message', handleLoginMessage);
  }, [currentURL, uid]);

  /** Timeout in ms for the loan-exists fetch so we never hang on auth check */
  const LOAN_LOOKUP_FETCH_TIMEOUT_MS = 15000;

  /**
   * Check if currentURL is an Arive, Finmo, MeridianLink, Encompass, or LendingPad loan page and redirect to loan board if:
   * 1. User has valid session token
   * 2. Loan exists in Addy AI
   * 
   * ENHANCED: Now always sets iframeUrl to enable toggle button on all pages
   * - If on Arive/Finmo/MeridianLink/Encompass/LendingPad page with existing loan: auto-redirects to specific loan board
   * - Otherwise: sets generic /loans URL (user can manually toggle)
   * 
   * Supported LOS URL patterns:
   * - Arive: https://{subdomain}.myarive.com/app/loans/{loanId}
   * - Finmo: https://app.finmo.ca/teams/{teamId}/deals/{dealId}
   * - MeridianLink: https://{subdomain}.mortgage.meridianlink.com/newlos/loanapp.aspx?loanid={guid}
   * - Encompass: https://{beta.}encompass.elliemae.io/pipeline/{loanGuid}/services
   * - Encompass ICE: https://{subdomain.}encompass.ice.com/pipeline/{loanGuid}/services
   * - Encompass LO Connect: https://{subdomain.}encompassloconnect.com/pipeline/{loanGuid}/services
   * - LendingPad: https://{subdomain}.lendingpad.com/web/#/company/loans/{loanGuid}
   * 
   * @param {string} urlToCheck - The URL to check (defaults to currentURL from URL params)
   * @param {AbortSignal} [abortSignal] - Optional signal to cancel the loan lookup fetch (e.g. when effect re-runs)
   * @param {string} [effectiveUid] - Optional uid override (e.g. from addy-session-uid after login when URL has no uid)
   */
  const checkAndRedirectToLoanBoard = async (urlToCheck = currentURL, abortSignal = null, effectiveUid = null) => {
    const uidToUse = effectiveUid ?? uid;
    console.log("[BACK-TO-LOAN] checkAndRedirectToLoanBoard START:", { urlToCheck, uidToUse, effectiveUid, uid });
    // Determine base URL based on environment
    const baseURL = GlobalVariables.getAppOrigin(clientHostname);
    
    console.log("[BACK-TO-LOAN] baseURL:", baseURL);
    
    // Default URL: generic loans page (shows all loans)
    const withBrandParams = (url) => appendBrandParamsToUrl(url, urlParams);
    let targetIframeUrl = withBrandParams(`${baseURL}/loans`);
    
    // If no URL provided, set default and return
    if (!urlToCheck) {
      console.log("[BACK-TO-LOAN] No urlToCheck provided, defaulting to loans page.");
      setIframeUrl(targetIframeUrl);
      setIframeTitle('Loans');
      return;
    }

    try {
      // Regex pattern to match Arive loan URLs
      const ariveRegex = /https:\/\/([^\.]+)\.myarive\.com\/app\/loans(?:\/(\d+))?/;
      const ariveMatch = urlToCheck.match(ariveRegex);
      
      // Regex pattern to match Finmo loan URLs
      const finmoRegex = /https:\/\/app\.(staging-)?finmo\.ca\/teams\/([a-f0-9-]+)\/deals\/([a-f0-9-]+)/i;
      const finmoMatch = urlToCheck.match(finmoRegex);
      
      // Regex pattern to match MeridianLink loan URLs
      // Example: https://secure.mortgage.meridianlink.com/newlos/loanapp.aspx?loanid=8c68f1b6-db23-48d2-9647-b3aa005c4ca1
      const meridianLinkRegex = /https:\/\/([^\/]+)\.mortgage\.meridianlink\.com\/[^?]*(?:\?.*loanid=([a-f0-9-]+))?/i;
      const meridianLinkMatch = urlToCheck.match(meridianLinkRegex);
      
      // Regex pattern to match Encompass loan URLs across EllieMae, ICE, and LO Connect hosts
      // Examples:
      // - https://beta.encompass.elliemae.io/pipeline/7a596187-faa0-41b3-bdaa-7b801485d312/services
      // - https://encompass.elliemae.io/pipeline/7a596187-faa0-41b3-bdaa-7b801485d312/services
      // - https://instance.encompass.ice.com/pipeline/7a596187-faa0-41b3-bdaa-7b801485d312/services
      // - https://encompassloconnect.com/pipeline/7a596187-faa0-41b3-bdaa-7b801485d312/services
      const encompassRegex = /https:\/\/(?:[^\/]+\.)?(?:encompass\.(?:elliemae\.io|ice\.com)|encompassloconnect\.com)\/pipeline\/([a-f0-9-]+)/i;
      const encompassMatch = urlToCheck.match(encompassRegex);

      // Regex pattern to match LendingPad loan URLs (hash-based routing)
      // Example: https://test.lendingpad.com/web/#/company/loans/8d83e282-cea0-4e99-8a22-7ef5a0809d6e
      const lendingPadRegex = /https:\/\/([^\/]+)\.lendingpad\.com\/web\/#\/company\/loans\/([a-f0-9-]+)/i;
      const lendingPadMatch = urlToCheck.match(lendingPadRegex);
            
      console.log("[BACK-TO-LOAN] Regex results:", {
        ariveMatch: ariveMatch ? ariveMatch.slice(0, 3) : null,
        finmoMatch: finmoMatch ? finmoMatch.slice(0, 4) : null,
        meridianLinkMatch: meridianLinkMatch ? meridianLinkMatch.slice(0, 3) : null,
        encompassMatch: encompassMatch ? encompassMatch.slice(0, 2) : null,
        lendingPadMatch: lendingPadMatch ? lendingPadMatch.slice(0, 3) : null,
      });
      
      // If not on Arive, Finmo, MeridianLink, Encompass, or LendingPad page, just show normal chat
      // Don't embed /research when already inside the Addy AI app - users can access /research directly via nav
      if (!ariveMatch && !finmoMatch && !meridianLinkMatch && !encompassMatch && !lendingPadMatch) {
        // Get the actual client hostname from URL param (not the fallback)
        const actualClientHostname = urlParams.get("clientHostname");
        
        // console.log('[Chat] External site detection:', {
        //   actualClientHostname,
        //   clientHostnameFallback: hostName,
        //   clientHostnameUsed: clientHostname,
        //   currentURL: urlToCheck,
        //   isAddySo: actualClientHostname?.includes('addy.so'),
        //   isLocalhost: actualClientHostname?.includes('localhost'),
        //   is127: actualClientHostname?.includes('127.0.0.1'),
        // });
        
        // Guard: If the CLIENT page (where sidebar is embedded) is addy.so or localhost, 
        // we're inside the Addy AI app - just show normal chat (avoids iframe nesting)
        // IMPORTANT: We use actualClientHostname (from URL param) to avoid false positives
        // when the sidebar itself is running on localhost but embedded in an external site
        const isInsideAddyApp = GlobalVariables.isAddyAppHostname(actualClientHostname);
        
        if (isInsideAddyApp) {
          // console.log('[Chat] Inside Addy AI app or localhost - showing normal chat');
          return;
        }
        
        // External site (not addy.so, not Arive, not Finmo, not MeridianLink, not Encompass)
        // Load the research page directly - the Login component inside will handle auth if needed
        // console.log('[Chat] External site detected, loading research page in iframe...');
        
        // Construct research page URL with all params
        const researchParams = new URLSearchParams();
        if (organizationId) researchParams.set('organizationId', organizationId);
        if (uidToUse) researchParams.set('uid', uidToUse);
        if (email) researchParams.set('email', email);
        if (name) researchParams.set('name', name);
        if (clientHostname) researchParams.set('clientHostname', clientHostname);
        if (selectedAssistantID) researchParams.set('assistant', selectedAssistantID);
        if (isAllowedCompareMode) researchParams.set('compareMode', isAllowedCompareMode);
        if (isAllowedVoiceMode) researchParams.set('voiceMode', isAllowedVoiceMode);
        researchParams.set('hideHotTip', 'true');
        
        const targetUrl = withBrandParams(`${baseURL}/research?${researchParams.toString()}`);
        
        // console.log('[Chat] Loading research page:', targetUrl);
        setIframeUrl(targetUrl);
        setIframeTitle('Research');
        setContentMode('iframe');
        return;
      }
      
      // We're on an Arive, Finmo, MeridianLink, or Encompass domain
      // Load the iframe directly - the Login component inside will handle auth if needed
      
      let loanLookupEndpoint;
      
      if (ariveMatch) {
        const subdomain = ariveMatch[1];
        const loanLosId = ariveMatch[2];
        const ariveDomain = `https://${subdomain}.myarive.com`;
        console.log("[BACK-TO-LOAN] Arive match:", { subdomain, loanLosId, ariveDomain });
        
        if (!uidToUse) {
          console.warn("[BACK-TO-LOAN] No uid available for Arive lookup. Showing generic loans page.");
          setIframeUrl(targetIframeUrl);
          setIframeTitle('Loans');
          setContentMode('iframe');
          return;
        }
        
        loanLookupEndpoint = `${GlobalVariables.getAPIURL()}/api/loan/arive-loan-exists?loanLosId=${loanLosId}&uid=${uidToUse}&ariveDomain=${encodeURIComponent(ariveDomain)}`;
        
      } else if (finmoMatch) {
        const isStaging = finmoMatch[1] === 'staging-';
        const teamId = finmoMatch[2];
        const dealId = finmoMatch[3];
        console.log("[BACK-TO-LOAN] Finmo match:", { isStaging, teamId, dealId });
        
        if (!uidToUse) {
          console.warn("[BACK-TO-LOAN] No uid available for Finmo lookup. Showing generic loans page.");
          setIframeUrl(targetIframeUrl);
          setIframeTitle('Loans');
          setContentMode('iframe');
          return;
        }
        
        loanLookupEndpoint = `${GlobalVariables.getAPIURL()}/api/loan/finmo-loan-exists?dealId=${dealId}&uid=${uidToUse}`;
      } else if (meridianLinkMatch) {
        const meridianLinkDomain = meridianLinkMatch[1]; // e.g., "secure"
        const loanGuid = meridianLinkMatch[2]; // e.g., "8c68f1b6-db23-48d2-9647-b3aa005c4ca1"
        console.log("[BACK-TO-LOAN] MeridianLink match:", { meridianLinkDomain, loanGuid });
        
        if (!uidToUse) {
          console.warn("[BACK-TO-LOAN] No uid available for MeridianLink lookup. Showing generic loans page.");
          setIframeUrl(targetIframeUrl);
          setIframeTitle('Loans');
          setContentMode('iframe');
          return;
        }
        
        // If no loan ID in URL, just show the loans page
        if (!loanGuid) {
          console.log("[BACK-TO-LOAN] MeridianLink: no loanGuid in URL. Showing generic loans page.");
          setIframeUrl(targetIframeUrl);
          setIframeTitle('Loans');
          setContentMode('iframe');
          return;
        }
        
        loanLookupEndpoint = `${GlobalVariables.getAPIURL()}/api/loan/meridianlink-loan-exists?loanGuid=${loanGuid}&uid=${uidToUse}`;
      } else if (encompassMatch) {
        const loanGuid = encompassMatch[1]; // e.g., "7a596187-faa0-41b3-bdaa-7b801485d312"
        let encompassHost = null;
        try {
          encompassHost = new URL(urlToCheck).hostname;
        } catch {
          encompassHost = null;
        }
        console.log("[BACK-TO-LOAN] Encompass match:", { encompassHost, loanGuid });
        
        if (!uidToUse) {
          console.warn("[BACK-TO-LOAN] No uid available for Encompass lookup. Showing generic loans page.");
          setIframeUrl(targetIframeUrl);
          setIframeTitle('Loans');
          setContentMode('iframe');
          return;
        }
        
        // If no loan ID in URL, just show the loans page
        if (!loanGuid) {
          console.log("[BACK-TO-LOAN] Encompass: no loanGuid in URL. Showing generic loans page.");
          setIframeUrl(targetIframeUrl);
          setIframeTitle('Loans');
          setContentMode('iframe');
          return;
        }
        
        loanLookupEndpoint = `${GlobalVariables.getAPIURL()}/api/loan/encompass-loan-exists?loanGuid=${loanGuid}&uid=${uidToUse}`;
      } else if (lendingPadMatch) {
        const lendingPadDomain = lendingPadMatch[1]; // e.g., "test" or "prod"
        const loanGuid = lendingPadMatch[2]; // e.g., "8d83e282-cea0-4e99-8a22-7ef5a0809d6e"
        console.log("[BACK-TO-LOAN] LendingPad match:", { lendingPadDomain, loanGuid });

        if (!uidToUse) {
          console.warn("[BACK-TO-LOAN] No uid available for LendingPad lookup. Showing generic loans page.");
          setIframeUrl(targetIframeUrl);
          setIframeTitle('Loans');
          setContentMode('iframe');
          return;
        }

        // If no loan ID in URL, just show the loans page
        if (!loanGuid) {
          console.log("[BACK-TO-LOAN] LendingPad: no loanGuid in URL. Showing generic loans page.");
          setIframeUrl(targetIframeUrl);
          setIframeTitle('Loans');
          setContentMode('iframe');
          return;
        }

        // The backend prefers the active organization when the loan is in several of the user's organizations.
        const lookupParams = new URLSearchParams({ loanGuid, uid: uidToUse });
        const activeOrganizationId = currentOrganizationId || selectedOrganizationId || organizationId;
        if (activeOrganizationId) {
          lookupParams.set('organizationId', activeOrganizationId);
        }
        loanLookupEndpoint = `${GlobalVariables.getAPIURL()}/api/loan/lendingpad-loan-exists?${lookupParams}`;
      }
      
      // Try to fetch loan info - if this fails or loan doesn't exist, we'll just load the default loans page
      // The Login component inside the iframe will handle authentication if needed
      console.log("[BACK-TO-LOAN] loanLookupEndpoint:", loanLookupEndpoint);
      const timeoutController = new AbortController();
      const timeoutId = setTimeout(() => {
        console.warn("[BACK-TO-LOAN] Loan lookup fetch TIMED OUT after", LOAN_LOOKUP_FETCH_TIMEOUT_MS, "ms");
        timeoutController.abort();
      }, LOAN_LOOKUP_FETCH_TIMEOUT_MS);
      const fetchSignal = abortSignal
        ? mergeSignals(abortSignal, timeoutController.signal)
        : timeoutController.signal;

      let response;
      try {
        console.log("[BACK-TO-LOAN] Fetching loan lookup endpoint...");
        response = await fetch(loanLookupEndpoint, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          signal: fetchSignal,
        });
        console.log("[BACK-TO-LOAN] Fetch completed. Status:", response.status, response.statusText);
      } catch (fetchError) {
        console.error("[BACK-TO-LOAN] Fetch FAILED:", fetchError.name, fetchError.message);
        clearTimeout(timeoutId);
        setIframeUrl(targetIframeUrl);
        setIframeTitle('Loans');
        setContentMode('iframe');
        return;
      } finally {
        clearTimeout(timeoutId);
      }
      
      if (!response.ok) {
        console.warn("[BACK-TO-LOAN] Response not OK:", response.status, response.statusText);
        setIframeUrl(targetIframeUrl);
        setIframeTitle('Loans');
        setContentMode('iframe');
        return;
      }
      
      const data = await response.json();
      console.log("[BACK-TO-LOAN] Loan lookup response data:", data);
      
      if (data?.loanExists && data?.loanDocId) {
        // Loan exists! Set specific loan board URL and auto-redirect
        targetIframeUrl = withBrandParams(`${baseURL}/loans?tab=board&loan=${data.loanDocId}`);
        console.log("[BACK-TO-LOAN] Loan FOUND! Redirecting to:", targetIframeUrl);

        // The web app switches to the loan's organization itself; keep the chat in that organization too.
        if (data.organizationId) {
          setCurrentOrganizationId(data.organizationId);
          if (setSelectedOrganizationId) {
            setSelectedOrganizationId(data.organizationId);
          }
        }

        // Always force remount. The iframeUrlRef can be stale (e.g. user navigated
        // away from the loan inside the iframe but the ref still holds the old loan URL),
        // so skipping remount would leave the user on the wrong page.
        skipNextUrlCheckRef.current = true;
        setIframeUrl(targetIframeUrl);
        setIframeTitle('Loan Board');
        setIframeKey((prev) => prev + 1);
        setContentMode('iframe');
        console.log("[BACK-TO-LOAN] Iframe remount triggered. Done.");
      } else {
        console.log("[BACK-TO-LOAN] Loan NOT found (loanExists:", data?.loanExists, "loanDocId:", data?.loanDocId, "). Showing generic loans page.");
        setIframeUrl(targetIframeUrl);
        setIframeTitle('Loans');
        setContentMode('iframe');
      }
      
    } catch (error) {
      console.error("[BACK-TO-LOAN] checkAndRedirectToLoanBoard CAUGHT ERROR:", error.name, error.message, error);
      // Timeout, abort, or network error: show loans page so user isn't stuck
      setIframeUrl(targetIframeUrl ?? appendBrandParamsToUrl(`${GlobalVariables.getAppOrigin(clientHostname)}/loans`, urlParams));
      setIframeTitle('Loans');
      setContentMode('iframe');
    }
  };

  /**
   * Combine two AbortSignals so the fetch aborts when either one aborts.
   * @param {AbortSignal} s1
   * @param {AbortSignal} s2
   * @returns {AbortSignal}
   */
  function mergeSignals(s1, s2) {
    const controller = new AbortController();
    if (s1?.aborted || s2?.aborted) {
      controller.abort();
      return controller.signal;
    }
    const abort = () => controller.abort();
    s1?.addEventListener?.('abort', abort);
    s2?.addEventListener?.('abort', abort);
    return controller.signal;
  }

  // Check URL and redirect to appropriate content on mount or when currentURL/uid changes
  useEffect(() => {
    // Skip if we just did a manual redirect (to prevent race condition)
    if (skipNextUrlCheckRef.current) {
      skipNextUrlCheckRef.current = false;
      return;
    }
    
    const abortController = new AbortController();
    checkAndRedirectToLoanBoard(currentURL, abortController.signal);
    
    return () => {
      abortController.abort();
    };
  }, [currentURL, uid]); // Run when currentURL or uid changes

  const isInIframe = (() => {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  })();

  const startRecording = async () => {
    // Voice mode available to all users
    setVoiceMode(true);
    if (currentView === "select-assistant") setCurrentView("chat");
    await startVoice();
  };

  const onCompareModeChange = (mode) => {
    if (!isCompareGuidelinesEnabled) {
      setCompareMode(false);

      return;
    }

    if (isAllowedCompareMode === "true") {
      setCompareMode(mode ?? false);
    } else {
      if (!isInIframe) {
        setShowUpgrade(true);
      } else {
        window?.parent?.postMessage("upgradeRequired", "*");
      }
    }
  };

  const stopRecording = () => {
    mediaRecorderRef.current.stop(); // triggers ondataavailable and onstop
    setRecording(false);
  };

  let hideHotTip = urlParams.get("hideHotTip") || "false";
  hideHotTip = hideHotTip === "true";

  let alignInputBottom = urlParams.get("alignInputBottom") || "false";
  alignInputBottom = alignInputBottom === "true";

  let showOnboarding = urlParams.get("showOnboarding");

  // eslint-disable-next-line no-undef
  if (
    sessionStorage.getItem("onboardingHasBeenShown") === null &&
    showOnboarding === "true"
  ) {
    // eslint-disable-next-line no-undef
    sessionStorage.setItem("onboardingHasBeenShown", "true");
  } else {
    showOnboarding = "false";
  }

  const activeOrganizationId =
    currentOrganizationId || selectedOrganizationId || organizationId;

  // Initialize a new user model
  const user = new UserModel(
    uid,
    token,
    email,
    clientHostname,
    activeOrganizationId
  );

  const [showDropdown, setShowDropdown] = useState(false);
  const [showChatHistory, setShowChatHistory] = useState(false);
  const [chatHistoryReferencedElementId, setChatHistoryReferencedElementId] =
    useState(null);
  const [referecedElementId, setReferencedElementId] = useState(null);
  const [assistants, setAssistants] = useState([]);
  const [selectedAssistant, setSelectedAssistant] = useState(
    /** @type {any} */ (null)
  );
  const selectedAssistantRef = useRef(/** @type {any} */ (null));
  // The classic chat's agent, as the organization names and pictures it.
  const assistantDisplayName = getWhiteLabeledAssistantName(selectedAssistant, assistantName) || "Addy AI";
  const assistantImageUrl = selectedAssistant?.imageUrl || organizationLogoUrl || "/assistant-icon.svg";
  const [pendingAskAddyQuery, setPendingAskAddyQuery] = useState(
    /** @type {any} */ (null)
  );
  const pendingAskAddyQueryRef = useRef(/** @type {any} */ (null));
  const [preparingAskAddyQuery, setPreparingAskAddyQuery] = useState(
    /** @type {any} */ (null)
  );
  const preparingAskAddyQueryRef = useRef(/** @type {any} */ (null));
  const [queuedAskAddyQueries, setQueuedAskAddyQueries] = useState(
    /** @type {any[]} */ ([])
  );
  const queuedAskAddyQueriesRef = useRef(/** @type {any[]} */ ([]));
  // When the parent app requests a brand-new conversation for an Ask Addy
  // query (startNewConversation: true), we stash the target chat id created
  // by onCreateNewChatClick so the pending-query effect only fires once the
  // new chat is actually active — never into the previously-restored loan
  // chat that the auto-restore effect just set up.
  const [pendingAskAddyTargetChatId, setPendingAskAddyTargetChatId] =
    useState(null);
  // On mount, restoreLoanChat() kicks off an async localStorage/backend
  // lookup that eventually lands a setChatID() via applyChatToView. When
  // Ask Addy requests a new conversation shortly after mount, that in-flight
  // restore can clobber the chat we just created. This ref tells
  // applyChatToView to skip any restore that arrives while a forced new
  // Ask Addy conversation is still pending.
  const askAddyNewChatPendingRef = useRef(false);
  const [defaultAssistant, setDefaultAssistant] = useState(null);
  const [organizationDefaultAssistant, setOrganizationDefaultAssistant] =
    useState(null);
  // The user's default agent as org settings resolve it: their own pick, else their role's
  // (e.g. the AEs' agent), else the organization's. Null when only the Addy fallback applies.
  const [v2DefaultAssistant, setV2DefaultAssistant] = useState(null);
  // The new Ask Addy answers as an agent: the one picked in the agent menu, else the user's
  // default agent (e.g. Lia); without either, as itself under the organization's
  // assistant name, then "Addy AI".
  const pickedV2Agent = v2AgentId ? assistants.find((agent) => getAgentId(agent) === v2AgentId) || null : null;
  const v2Agent = pickedV2Agent || v2DefaultAssistant;
  const v2AgentAppId = v2Agent && !getAgentId(v2Agent).startsWith(DEFAULT_AGENT_ID_PREFIX) ? getAgentId(v2Agent) : "";
  const getV2Identity = (agent) => ({
    name: getWhiteLabeledAssistantName(agent, assistantName) || String(assistantName || "").trim() || "Addy AI",
    imageUrl: agent?.imageUrl || organizationLogoUrl || "/assistant-icon.svg",
  });
  const { name: defaultV2Name, imageUrl: defaultV2ImageUrl } = getV2Identity(v2DefaultAssistant);
  // Until the default agent has loaded, the name and picture from the organization's last visit;
  // on a first visit, nothing (the header waits) rather than a fallback name that then changes.
  const [isOrganizationDefaultLoaded, setIsOrganizationDefaultLoaded] = useState(false);
  const cachedV2Assistant = useMemo(() => readCachedAssistant(activeOrganizationId), [activeOrganizationId]);
  const v2Assistant = isOrganizationDefaultLoaded ? getV2Identity(v2Agent) : cachedV2Assistant;

  useEffect(() => {
    if (isOrganizationDefaultLoaded) {
      cacheAssistant(activeOrganizationId, { name: defaultV2Name, imageUrl: defaultV2ImageUrl });
    }
  }, [isOrganizationDefaultLoaded, activeOrganizationId, defaultV2Name, defaultV2ImageUrl]);
  const [
    canManageOrganizationDefaultAssistant,
    setCanManageOrganizationDefaultAssistant,
  ] = useState(false);
  const [currentView, setCurrentView] = useState("select-assistant");
  const [messageTexts, setMessageTexts] = useState([]);
  const [CHAT_ID, setChatID] = useState(uuidv4());
  const [selectedChatHistory, setSelectedChatHistory] = useState(null);

  const formatChatName = clientHostname
    ? clientHostname.replace("www.", "")
    : getDateFormat();
  const [chatName, setChatName] = useState(formatChatName);

  const [tooltipRun, setTooltipRun] = useState(showOnboarding === "true");
  const [tooltipSteps, setTooltipSteps] = useState([]);
  const [currentlyTyping, setCurrentlyTyping] = useState(false);
  const currentlyTypingRef = useRef(false);
  const [isUserAtBottom, setIsUserAtBottom] = useState(true);
  const isUserAtBottomRef = useRef(true);
  const [hasNewContentBelow, setHasNewContentBelow] = useState(false);
  const browserTaskMessageIdRef = useRef(null);
  // The single "🧭 Guiding you on screen" status line, updated in place as the
  // host app reports guided-walkthrough progress.
  const guideStatusMessageIdRef = useRef(null);
  const browserTaskFirstDeltaRef = useRef(false);
  const localBrowserRunRef = useRef(null);
  const localBrowserRpcRef = useRef(null);
  const localBrowserConfirmationRef = useRef(null);
  // Ask Addy v2's browser card listens for the loop's confirmations too (see browserUseForV2).
  const v2BrowserConfirmListenerRef = useRef(null);
  if (!localBrowserConfirmationRef.current) {
    localBrowserConfirmationRef.current = createConfirmationGate({
      onRequest: ({ description }) => {
        v2BrowserConfirmListenerRef.current?.(description);
        setClarificationPrompt({
          kind: "local-browser-confirmation",
          question: description,
          options: [
            { label: "Confirm and continue", value: "confirm" },
            { label: "Cancel", value: "cancel" },
          ],
        });
        currentlyTypingRef.current = false;
        setCurrentlyTyping(false);
      },
      onClear: () => setClarificationPrompt(null),
    });
  }
  const [documentsContext, setDocumentsContext] = useState([]);
  const [documentsComparedContext, setDocumentsComparedContext] = useState([]);
  const [pricingResultsContext, setPricingResultsContext] = useState([]);
  const [loadingDocuments, setLoadingDocuments] = useState(false);
  const [files, setFiles] = useState([]);
  const [usedFiles, setUsedFiles] = useState([]);
  // Chat with your docs (DEV-6130): loan documents picked for each chat, keyed
  // by chat ID so they follow the chat through history and new chats. Their
  // extracted text is kept in memory only.
  const [chatDocsByChatId, setChatDocsByChatId] = useState(() => loadChatDocsByChatId());
  const chatDocTextRef = useRef({});
  const currentChatDocs = chatDocsByChatId[CHAT_ID] || [];

  // Another tab may have changed this chat's documents, so re-read them
  // whenever the chat changes.
  useEffect(() => {
    setChatDocsByChatId(loadChatDocsByChatId());
  }, [CHAT_ID]);

  /** Updates and saves only this chat's documents, so other tabs' chats stay intact. */
  const updateCurrentChatDocs = (nextDocs) => {
    saveChatDocsForChat(CHAT_ID, nextDocs);
    setChatDocsByChatId((previous) => setChatDocsForChat(previous, CHAT_ID, nextDocs));
  };

  const {
    isChatWithDocsEnabled,
    isChatWithDocsOpen: showDocsFlow,
    openChatWithDocs,
    closeChatWithDocs,
  } = useChatWithDocsCapability(chatWithDocsCapability, mode);

  // State for handling document requests
  const [emailThread, setEmailThread] = useState(null);
  const [documents, setDocuments] = useState(null);
  let generateRequestEmailForDocument = false;

  const startInteractionLock = useCallback((message, seconds = 60) => {
    const safeSeconds = Math.max(1, seconds || 60);
    const unlockAt = Date.now() + safeSeconds * 1000;
    setInteractionLock({
      type: "RATE_LIMIT",
      message,
      unlockAt,
    });
  }, []);

  useEffect(() => {
    if (!interactionLock?.unlockAt) {
      setLockCountdown(null);
      return;
    }

    const updateCountdown = () => {
      const remaining = Math.max(
        0,
        Math.ceil((interactionLock.unlockAt - Date.now()) / 1000)
      );
      setLockCountdown(remaining);
      if (remaining <= 0) {
        setInteractionLock(null);
        setLockCountdown(null);
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [interactionLock]);

  /** Opens the "Chat with your docs" flow (from the + menu). */
  const handleChatWithDocs = () => {
    openChatWithDocs();
  };

  /** Closes the picker and lets loan chats restore again (see "openChatWithDocs"). */
  const handleDocsFlowClose = () => {
    askAddyNewChatPendingRef.current = false;
    closeChatWithDocs();
  };

  /**
   * Called when the docs flow confirms a loan + document selection. The
   * documents are attached to the current chat (added to any picked earlier)
   * and Ask Addy answers with them, in this same window (DEV-6130).
   */
  const handleDocsFlowConfirm = ({ loanId, loanName, documents = [] }) => {
    handleDocsFlowClose();
    // An empty pick is allowed: it takes this loan's documents out of the chat.
    if (!isChatWithDocsEnabled || !loanId) {
      return;
    }

    const docsOrganizationId =
      currentOrganizationId || selectedOrganizationId || organizationId || "";
    const pickedDocs = documents.map((document) =>
      toChatDoc(document, { loanId, loanName, organizationId: docsOrganizationId })
    );
    const pickedText = Object.fromEntries(
      pickedDocs.map(({ key }, index) => [key, documents[index].textContent || ""])
    );
    chatDocTextRef.current = { ...chatDocTextRef.current, ...pickedText };
    // The picker opened with this chat's documents ticked, so its selection is
    // the loan's full set: ticked ones stay or join, unticked ones leave.
    updateCurrentChatDocs(replaceLoanChatDocs(currentChatDocs, loanId, pickedDocs));
  };

  const handleRemoveChatDoc = (docKey) => {
    updateCurrentChatDocs(removeChatDoc(currentChatDocs, docKey));
  };

  /** Loads text for this chat's documents that are not in memory yet (a chat reopened from history). */
  const loadMissingChatDocText = async (docs) => {
    const missingDocs = getDocsMissingText(docs, chatDocTextRef.current);
    if (missingDocs.length === 0) {
      return;
    }

    const loanGroups = Object.values(groupDocsByLoan(missingDocs));
    const loadedEntries = await Promise.all(
      loanGroups.map(async ({ loanId, organizationId: docsOrganizationId }) => {
        try {
          const loanDocs = await LoanDocs.getLoanDocuments(loanId, docsOrganizationId);

          return loanDocs.map(({ id, textContent }) => [
            getChatDocKey({ loanId, id }),
            textContent || "",
          ]);
        } catch {
          // Unreachable now: the chat continues with the documents that loaded.
          return [];
        }
      })
    );
    chatDocTextRef.current = {
      ...chatDocTextRef.current,
      ...Object.fromEntries(loadedEntries.flat()),
    };
  };

  /**
   * Opens a cited PDF in the host app's viewer at the cited page with the
   * passage highlighted (DEV-6130). MessageText previews every other citation.
   */
  const handleOpenCitation = (citation) => {
    const viewerRequest = buildCitationViewerRequest(citation);
    const hostAppOrigin = getCitationTargetOrigin();
    if (!viewerRequest.url || !hostAppOrigin) {
      return;
    }

    window.parent.postMessage(
      { key: "open-citation-pdf", value: viewerRequest },
      hostAppOrigin
    );
  };

  // const [currentMessage, setCurrentMessage] = useState(null);

  // Ref for dropdown wrapper
  const dropdownRef = useRef(null);
  const assistantTopSelectRef = useRef(null);
  const chatHistoryInfoRef = useRef(null);
  const bigAssistantsDropdownRef = useRef(null);
  const chatHistoryRef = useRef(null);
  const chatNameDropdownRef = useRef(null);
  const linkBufferRef = useRef("");
  // Map of short link references (addylink:N) -> real URLs, delivered by the
  // SSE `links` event. State drives re-renders so streamed placeholders
  // upgrade to clickable links in place; the ref gives the stream loop
  // synchronous access for baking URLs into the final message.
  const linkMapRef = useRef({});
  const [linkMap, setLinkMap] = useState({});
  const activeStreamAbortControllerRef = useRef(null);
  const closeTriggeredAbortRef = useRef(false);
  const closeButtonRef = useRef(null);
  const sidebarWindow = useSidebarWindow();

  const updateChatBottomState = useCallback((el) => {
    if (!el) return true;
    const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
    const atBottom = distanceFromBottom <= CHAT_BOTTOM_THRESHOLD_PX;
    isUserAtBottomRef.current = atBottom;
    setIsUserAtBottom(atBottom);
    if (atBottom) {
      setHasNewContentBelow(false);
    }
    return atBottom;
  }, []);

  const handleChatScroll = useCallback((event) => {
    updateChatBottomState(event.currentTarget);
  }, [updateChatBottomState]);

  const scrollChatToBottom = useCallback((behavior = "smooth") => {
    const el = chatHistoryRef.current;
    if (!el) return;
    el.scrollTo({
      top: el.scrollHeight,
      behavior,
    });
    isUserAtBottomRef.current = true;
    setIsUserAtBottom(true);
    setHasNewContentBelow(false);
  }, []);

  const abortActiveStream = useCallback(() => {
    const controller = activeStreamAbortControllerRef.current;
    if (controller && !controller.signal.aborted) {
      controller.abort();
      return true;
    }
    return false;
  }, []);

  const abortLocalBrowserRun = useCallback(() => {
    return abortLocalBrowserTask(
      localBrowserRunRef.current,
      localBrowserConfirmationRef.current
    );
  }, []);

  const stopActiveWork = useCallback(() => {
    const stoppedStream = abortActiveStream();
    const stoppedBrowser = abortLocalBrowserRun();

    return stoppedStream || stoppedBrowser;
  }, [abortActiveStream, abortLocalBrowserRun]);

  const requestSidebarClose = useCallback(() => {
    if (currentlyTypingRef.current) {
      closeTriggeredAbortRef.current = abortActiveStream();
    }
    abortLocalBrowserRun();
    window?.parent?.postMessage("close-sidebar", "*");
  }, [abortActiveStream, abortLocalBrowserRun]);

  const updatePendingAskAddyQuery = (query) => {
    pendingAskAddyQueryRef.current = query;
    setPendingAskAddyQuery(query);
  };

  const updatePreparingAskAddyQuery = (query) => {
    preparingAskAddyQueryRef.current = query;
    setPreparingAskAddyQuery(query);
  };

  useEffect(() => {
    selectedAssistantRef.current = selectedAssistant;
  }, [selectedAssistant]);

  useEffect(() => {
    interactionLockRef.current = interactionLock;
  }, [interactionLock]);

  useEffect(() => {
    clarificationPromptRef.current = clarificationPrompt;
  }, [clarificationPrompt]);

  const updatePendingAskAddyTargetChatId = (chatId) => {
    setPendingAskAddyTargetChatId(chatId);
  };

  const enqueueAskAddyQuery = (query) => {
    const nextQueuedQueries = [...queuedAskAddyQueriesRef.current, query];
    queuedAskAddyQueriesRef.current = nextQueuedQueries;
    setQueuedAskAddyQueries(nextQueuedQueries);
  };

  const dequeueAskAddyQuery = () => {
    const [nextQuery, ...remainingQueries] = queuedAskAddyQueriesRef.current;
    if (!nextQuery) return null;
    queuedAskAddyQueriesRef.current = remainingQueries;
    setQueuedAskAddyQueries(remainingQueries);
    return nextQuery;
  };

  const startExternalAskAddyQuery = (query) => {
    updatePreparingAskAddyQuery(null);

    if (query.startNewConversation) {
      askAddyNewChatPendingRef.current = true;
      const newChatId = onCreateNewChatClick();
      updatePendingAskAddyTargetChatId(newChatId);
    } else {
      updatePendingAskAddyTargetChatId(null);
    }

    updatePendingAskAddyQuery({
      query: query.query,
      displayQuery: query.displayQuery || query.query,
      contextDocuments: query.contextDocuments || [],
      pricingContext: !!query.pricingContext,
    });
  };

  // Started here, not in the message listener: its closure holds the loan id from when it was added.
  useEffect(() => {
    if (!v2AskAddyQuery?.startNewConversation) {
      return;
    }
    onCreateNewChatClick();
    setV2AskAddyQuery((query) => query && { ...query, startNewConversation: false });
  }, [v2AskAddyQuery]);

  const queueOrStartExternalAskAddyQuery = (query) => {
    if (
      currentlyTypingRef.current ||
      pendingAskAddyQueryRef.current ||
      queuedAskAddyQueriesRef.current.length > 0 ||
      preparingAskAddyQueryRef.current ||
      !selectedAssistantRef.current ||
      interactionLockRef.current ||
      clarificationPromptRef.current
    ) {
      if (preparingAskAddyQueryRef.current) {
        updatePreparingAskAddyQuery(null);
      }
      enqueueAskAddyQuery(query);
      return;
    }

    startExternalAskAddyQuery(query);
  };

  useEffect(() => {
    return () => {
      const controller = activeStreamAbortControllerRef.current;
      if (controller && !controller.signal.aborted) {
        controller.abort();
      }
    };
  }, []);

  useEffect(() => {
    const sendPosition = () => {
      if (closeButtonRef.current) {
        const rect = closeButtonRef.current.getBoundingClientRect();
        window?.parent?.postMessage({
          type: "close-button-position",
          position: {
            top: rect.top,
            left: rect.left,
            right: rect.right,
            bottom: rect.bottom,
            width: rect.width,
            height: rect.height,
          }
        }, "*");
      }
    };
    const handleCloseButtonPositionRequest = (event) => {
      if (event.data === "request-close-button-position") {
        sendPosition();
      }
    };
    // Re-send when the docs picker closes so the minimize control snaps back
    // to this screen's close button (the picker owns reporting while open).
    const timeoutId = setTimeout(sendPosition, 100);
    window.addEventListener("resize", sendPosition);
    window.addEventListener("message", handleCloseButtonPositionRequest);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", sendPosition);
      window.removeEventListener("message", handleCloseButtonPositionRequest);
    };
  }, [showDocsFlow, overlayMode]);

  // Event handler for click events
  const handleClickOutside = (event) => {
    // If user clicks outside or inside of dropdown ref
    // Close the dropdown
    if (
      (bigAssistantsDropdownRef.current &&
        !bigAssistantsDropdownRef.current.contains(event.target)) ||
      (dropdownRef.current && !dropdownRef.current.contains(event.target))
    ) {
      setShowDropdown(false);
      if (
        !(
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target) &&
          assistantTopSelectRef.current &&
          !assistantTopSelectRef.current.contains(event.target)
        )
      ) {
        setShowDropdown(true);
      }
    }
  };

  // Event handler for click events
  const handleClickOutsideChatHistoryDropdown = (event) => {
    // If user clicks outside or inside of dropdown ref
    // Close the dropdown
    if (
      chatNameDropdownRef.current &&
      !chatNameDropdownRef.current.contains(event.target)
    ) {
      setShowChatHistory(false);
      if (
        !(
          chatNameDropdownRef.current &&
          !chatNameDropdownRef.current.contains(event.target) &&
          chatHistoryInfoRef.current &&
          !chatHistoryInfoRef.current.contains(event.target)
        )
      ) {
        setShowChatHistory(true);
      }
    }
  };

  const bigAssistantChangeClick = () => {
    setReferencedElementId("addy-big-assistant-select");
    setShowDropdown(true);
    // Show
  };

  const onShowChatHistoryClick = () => {
    setChatHistoryReferencedElementId("addy-chat-history-select");
    setShowChatHistory(true);
  };

  useEffect(() => {
    setTooltipSteps([
      {
        target: ".tooltip-1",
        title: "Private and Secure Chat",
        content: "All chats are private, secure, and only available to you.",
        disableBeacon: true,
      },
      {
        target: ".tooltip-2",
        title: "Choose Assistant or Create New",
        content:
          "Select an assistant to chat with or create a new one. Each assistant can be trained on different data.",
      },
      {
        target: ".tooltip-3",
        title: "Manage Assistants or Close Chat",
        content:
          "Click the expand icon to open the portal. Here you can create and train custom AI assistants for your company. Close the chat by clicking the close icon.",
      },
      {
        target: ".tooltip-4",
        title: "Highlight Any Text on Your Web Page",
        content:
          "Press and hold the Control key, then highlight text on any web page. Your assistant can provide you with relevant information like a summary, explanation, or answer to questions about the text.",
      },
      {
        target: ".tooltip-5",
        title: "Suggested Prompts",
        content:
          "Need help getting started? Click on one of these prompt to start a conversation with your assistant.",
      },
      {
        target: ".tooltip-6",
        title: "Ask Your Assistant Anything",
        content:
          "Type your question or message here and click the send button to chat with your assistant.",
      },
    ]);
  }, []);

  useEffect(() => {
    const rpc = createLocalBrowserRpc({ targetWindow: window.parent });
    localBrowserRpcRef.current = rpc;

    return () => {
      abortLocalBrowserRun();
      rpc.cleanup();
      localBrowserRpcRef.current = null;
    };
  }, [abortLocalBrowserRun]);

  // Add event listener for clicks on the document
  useEffect(() => {
    // Initialize window post message listener
    windowListenForPostMessage();

    // eslint-disable-next-line no-undef
    document.addEventListener("click", handleClickOutside);
    document.addEventListener("click", handleClickOutsideChatHistoryDropdown);
    // Set assistants
    const assistantTokenPromise =
      mode === "documentPortal"
        ? requestDocumentPortalIdToken({ forceRefresh: true })
        : Promise.resolve(token || "");

    assistantTokenPromise
      .then((assistantToken) =>
        user.getAssistants(mode || "", loanId || "", "", assistantToken)
      )
      .catch(() => {
        user.resolvedPortalAssistantId = null;
        return user.defaultAssistants;
      })
      .then((assistants) => {
      setAssistants(assistants);
      if (mode === "documentPortal") {
        const resolvedPortalAssistant = assistants.find(
          (assistant) =>
            assistant.appID === user.resolvedPortalAssistantId
        );
        setSelectedAssistant(
          resolvedPortalAssistant ||
            resolvePreferredFallbackAssistant(assistants)
        );
        setOrganizationDefaultAssistant(resolvedPortalAssistant || null);
        setV2DefaultAssistant(resolvedPortalAssistant || null);
        setCanManageOrganizationDefaultAssistant(false);
        setIsOrganizationDefaultLoaded(true);
        return;
      }
      if (assistants.length && !selectedAssistant) {
        if (defaultSelectedAssistant) {
          let defaultAssistant = assistants.find(
            (assistant) => assistant.appID === defaultSelectedAssistant
          );
          if (defaultAssistant) {
            setSelectedAssistant(defaultAssistant);
          } else {
            defaultAssistant = assistants.find(
              (assistant) => assistant.defaultId === defaultSelectedAssistant
            );
            if (defaultAssistant) {
              setSelectedAssistant(defaultAssistant);
            } else {
              setSelectedAssistant(resolvePreferredFallbackAssistant(assistants));
            }
          }
        }
      }
      if (assistants.length && selectedAssistantID) {
        // Set the selected assistant
        const assistant = assistants.find(
          (assistant) => assistant.appID === selectedAssistantID
        );
        setSelectedAssistant(assistant);
      }
      if (
        assistants.length &&
        !defaultSelectedAssistant &&
        !selectedAssistantID &&
        mode !== "documentPortal"
      ) {
        // If no assistant was supplied in the URL params, get it from backend
        // Initialize the default assistant from backend.
        // Document portal sessions use a synthetic "borrower-<id>" uid scoped
        // to the borrower, which never matches a real user record, so
        // GET /default-assistant would throw. Skip it (see getUserData above).
        initializeDefaultAssistant(assistants);
      }
      if (assistants.length) {
        initializeOrganizationDefaultAssistant(assistants);
      }
      });

    // Scroll to the bottom of the chat
    if (chatHistoryRef.current) {
      chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
      updateChatBottomState(chatHistoryRef.current);
    }

    // Clean up by removing the event listener on unmount
    return () => {
      // eslint-disable-next-line no-undef
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener(
        "click",
        handleClickOutsideChatHistoryDropdown
      );
      // Remove window message event listener
      window.removeEventListener("message", handlePostMessage);
    };
  }, []);

  useEffect(() => {
    if (!assistants.length || !activeOrganizationId) return;

    if (mode === "documentPortal") return;

    initializeOrganizationDefaultAssistant(assistants);
    if (
      !defaultSelectedAssistant &&
      !selectedAssistantID &&
      mode !== "documentPortal"
    ) {
      initializeDefaultAssistant(assistants);
    }
  }, [activeOrganizationId, assistants]);

  // For drawer open and close
  useEffect(() => {
    const handleResize = () => {
      const wideScreen = window.innerWidth >= 768;
      setIsWideScreen(wideScreen);
      setHasRoomForV2Rail(window.innerWidth >= V2_RAIL_MIN_SIDEBAR_WIDTH);

      if (!internalNavigation.isEnabled) {
        setIsDrawerOpen(false);

        return;
      }

      // Automatically close the drawer if switching to a small screen. With v2's rail, the chat
      // keeps the screen until a panel is asked for.
      if (!wideScreen || isV2Rail) {
        setIsDrawerOpen(false);
      } else {
        setIsDrawerOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check
    return () => window.removeEventListener("resize", handleResize);
  }, [internalNavigation.isEnabled, isV2Rail]);

  useEffect(() => {
    if (!hasV2Scrim) {
      return undefined;
    }

    const closeOnEscape = (event) => {
      if (event.key !== "Escape") {
        return;
      }

      setIsDrawerOpen(false);
      setV2View("chat");
    };
    window.addEventListener("keydown", closeOnEscape);

    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [hasV2Scrim]);

  // The new chat's avatar opens the profile when what's new is in there.
  useEffect(() => {
    // A "View scheduled task" button sends the tab to open with the event.
    const openProfile = (event) => {
      setIsDrawerOpen(false);
      if (event?.detail?.tab) setV2ProfileTab(event.detail.tab);
      setV2View("autopilot");
    };
    window.addEventListener(OPEN_PROFILE_EVENT, openProfile);

    return () => window.removeEventListener(OPEN_PROFILE_EVENT, openProfile);
  }, []);

  // Cmd/Ctrl+K opens search chats wherever the rail is.
  useEffect(() => {
    if (!hasV2Rail) {
      return undefined;
    }

    const openSearch = (event) => {
      if (event.key.toLowerCase() !== "k" || !(event.metaKey || event.ctrlKey)) {
        return;
      }

      event.preventDefault();
      setIsDrawerOpen(false);
      setV2View("chat");
      setIsV2SearchOpen(true);
    };
    window.addEventListener("keydown", openSearch);

    return () => window.removeEventListener("keydown", openSearch);
  }, [hasV2Rail]);

  // Add scroll padding only for composer growth beyond the default input
  // reservation (follow-ups), so Copy/Export stay reachable without a dead gap.
  useEffect(() => {
    const chatHistory = document.getElementById("addy-chat-history");
    const buttonInstance = document.querySelector(".button-instance");
    if (!chatHistory || !buttonInstance) {
      return;
    }

    const updateOverlapPadding = () => {
      const hasMessages = messageTexts.length > 0;
      const overlapPadding = getComposerOverlapPaddingPx({
        composerHeight: buttonInstance.getBoundingClientRect().height,
        hasMessages,
        isEmptyStateCentered: buttonInstance.classList.contains(
          "empty-state-vcenter",
        ),
      });
      const basePadding = overlayMode ? 50 : 0;
      const padding = basePadding + overlapPadding;
      const wasAtBottom = isUserAtBottomRef.current;

      chatHistory.style.paddingBottom = padding ? `${padding}px` : "";

      if (wasAtBottom && hasMessages && overlapPadding > 0) {
        requestAnimationFrame(() => {
          scrollChatToBottom("auto");
        });
      }
    };

    updateOverlapPadding();
    const observer = new ResizeObserver(updateOverlapPadding);
    observer.observe(buttonInstance);

    return () => {
      observer.disconnect();
      chatHistory.style.paddingBottom = "";
    };
  }, [
    followUpSuggestions,
    isGeneratingFollowUps,
    messageTexts.length,
    currentlyTyping,
    overlayMode,
    scrollChatToBottom,
  ]);

  // Soft auto-scroll: when the user submits a new question, smoothly bring their
  // message bubble to the top of the viewport so the answer streams into view
  // beneath it. We do NOT scroll during streaming chunks or on chat-history
  // hydration; once the initial snap completes the user retains full control.
  const lastScrolledUserMessageIdRef = useRef(null);

  useEffect(() => {
    // Only react to fresh submissions, not chat-history loads or streaming chunks.
    if (!currentlyTypingRef.current) return;

    let latestUserMessage = null;
    for (let i = messageTexts.length - 1; i >= 0; i--) {
      if (messageTexts[i].type === "user") {
        latestUserMessage = messageTexts[i];
        break;
      }
    }
    if (!latestUserMessage) return;

    if (lastScrolledUserMessageIdRef.current === latestUserMessage.messageId) {
      return;
    }
    lastScrolledUserMessageIdRef.current = latestUserMessage.messageId;

    requestAnimationFrame(() => {
      // eslint-disable-next-line no-undef
      const el = document.getElementById(latestUserMessage.messageId);
      if (el && typeof el.scrollIntoView === "function") {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        requestAnimationFrame(() => updateChatBottomState(chatHistoryRef.current));
      }
    });
  }, [messageTexts, updateChatBottomState]);

  useEffect(() => {
    if (currentView !== "chat" || messageTexts.length === 0) return;

    requestAnimationFrame(() => {
      const chatEl = chatHistoryRef.current;
      if (!chatEl) return;

      if (isUserAtBottomRef.current) {
        chatEl.scrollTop = chatEl.scrollHeight;
        updateChatBottomState(chatEl);
        return;
      }

      if (currentlyTypingRef.current) {
        setHasNewContentBelow(true);
      }
    });
  }, [messageTexts, currentView, updateChatBottomState]);

  // Auto-save chat when messageTexts changes
  useEffect(() => {
    if (messageTexts.length > 0) {
      saveCurrentChatLocally();
    }
  }, [messageTexts]);

  // Process pending Ask Addy query when assistant is ready.
  // If Ask Addy requested a brand-new conversation, wait until that chat is
  // the active one before sending — otherwise the query would be posted into
  // the loan chat that restoreLoanChat() just restored.
  useEffect(() => {
    if (!pendingAskAddyQuery || !selectedAssistant) {
      return;
    }
    // A pending query with no usable text can never be sent; drop it so it does
    // not wedge the pending slot and block later queries.
    if (!pendingAskAddyQuery.query || !pendingAskAddyQuery.query.trim()) {
      updatePendingAskAddyQuery(null);
      updatePendingAskAddyTargetChatId(null);
      askAddyNewChatPendingRef.current = false;
      return;
    }
    if (currentlyTypingRef.current || interactionLock) {
      return;
    }
    if (pendingAskAddyTargetChatId && CHAT_ID !== pendingAskAddyTargetChatId) {
      return;
    }
    updatePreparingAskAddyQuery(null);
    onSendButtonClick(
      pendingAskAddyQuery.query,
      "",
      false,
      pendingAskAddyQuery.contextDocuments || [],
      false,
      null,
      null,
      pendingAskAddyQuery.displayQuery,
      { pricingContext: !!pendingAskAddyQuery.pricingContext }
    );
    // onSendButtonClick sets currentlyTypingRef synchronously the moment it
    // accepts a send. If a lock slipped in and it bailed instead, keep the
    // pending query so a later effect run retries it rather than silently
    // dropping the user's click.
    if (!currentlyTypingRef.current) {
      return;
    }
    updatePendingAskAddyQuery(null);
    updatePendingAskAddyTargetChatId(null);
    // Release the restore-block once the forced-new Ask Addy chat has
    // actually received its query.
    askAddyNewChatPendingRef.current = false;
  }, [pendingAskAddyQuery, pendingAskAddyTargetChatId, selectedAssistant, CHAT_ID, interactionLock]);

  useEffect(() => {
    if (queuedAskAddyQueries.length === 0) {
      return;
    }
    if (
      currentlyTypingRef.current ||
      pendingAskAddyQueryRef.current ||
      preparingAskAddyQueryRef.current ||
      !selectedAssistant ||
      interactionLock ||
      clarificationPrompt
    ) {
      return;
    }

    const nextQuery = dequeueAskAddyQuery();
    if (nextQuery) {
      startExternalAskAddyQuery(nextQuery);
    }
  }, [
    queuedAskAddyQueries,
    currentlyTyping,
    pendingAskAddyQuery,
    preparingAskAddyQuery,
    selectedAssistant,
    interactionLock,
    clarificationPrompt,
  ]);

  // Track if we've already handled the initial loan context from URL
  const initialLoanContextHandled = useRef(false);
  const previousLoanIdRef = useRef(currentLoanId);

  // Auto-restore loan-specific chat on loan pages; start fresh elsewhere.
  useEffect(() => {
    // Handle initial load
    if (!initialLoanContextHandled.current) {
      initialLoanContextHandled.current = true;
      previousLoanIdRef.current = currentLoanId;

      if (currentLoanId) {
        restoreLoanChat(currentLoanId);
      } else if (initialScopedChatId) {
        restoreScopedChat(initialScopedChatId);
      }
      // Otherwise start fresh. The component's default state (new CHAT_ID,
      // empty messageTexts, select-assistant view) already represents a new
      // chat — no action needed. We intentionally do NOT auto-restore the last
      // general chat because that chat may be from an unrelated page or loan
      // context, which is confusing UX.
      return;
    }

    // Handle subsequent loan context changes (user navigating between loans)
    if (currentLoanId !== previousLoanIdRef.current) {
      previousLoanIdRef.current = currentLoanId;

      if (currentLoanId) {
        restoreLoanChat(currentLoanId);
      } else {
        // Navigating away from a loan to a non-loan page: start a fresh chat
        onCreateNewChatClick();
      }
    }
  }, [currentLoanId]);

  const playVoiceResponseSequential = (() => {
    let lastPromise = Promise.resolve();

    return (text) => {
      lastPromise = lastPromise.then(
        () =>
          new Promise((resolve, reject) => {
            playVoiceResponse(text)
              .then((audioElement) => {
                audioElement.onended = resolve;
                audioElement.onerror = reject;
              })
              .catch(reject);
          })
      );
      return lastPromise;
    };
  })();

  const updateLocalBrowserMessage = (messageId, message) => {
    setMessageTexts((previousMessages) =>
      previousMessages.map((chatMessage) =>
        chatMessage.messageId === messageId
          ? { ...chatMessage, message, action: "response" }
          : chatMessage
      )
    );
  };

  const getLocalBrowserHost = (observation) => {
    const candidate =
      observation?.url ||
      observation?.origin ||
      observation?.page?.url ||
      observation?.tab?.url;
    if (!candidate || typeof candidate !== "string") {
      return "";
    }

    try {
      return new URL(candidate).host;
    } catch {
      return observation?.host || "";
    }
  };

  const runLocalBrowserTask = async ({
    goal,
    organizationId: taskOrganizationId,
    userId,
    idToken,
    assistantMessageId,
    // Ask Addy v2 runs this loop for its use_my_browser tool: progress and the outcome go to
    // `report` instead of a legacy chat message.
    report,
  }) => {
    const say = (text, outcome) =>
      report ? report(text, outcome) : updateLocalBrowserMessage(assistantMessageId, text);
    if (
      typeof taskOrganizationId !== "string" ||
      !taskOrganizationId.trim() ||
      typeof userId !== "string" ||
      !userId.trim() ||
      typeof idToken !== "string" ||
      !idToken.trim()
    ) {
      say(
        "Local browser control is unavailable because this chat is not authenticated. Reload Addy, sign in, and try again.", { done: true, ok: false }
      );
      currentlyTypingRef.current = false;
      setCurrentlyTyping(false);

      return;
    }

    const rpc = localBrowserRpcRef.current;
    if (!rpc) {
      say("The local browser extension is unavailable. Reload the extension and try again.", { done: true, ok: false });
      currentlyTypingRef.current = false;
      setCurrentlyTyping(false);

      return;
    }

    const runId = uuidv4();
    const controller = new AbortController();
    const run = { controller, runId };
    localBrowserRunRef.current = run;
    let history = [];
    let memory = null;
    let observedHost = "";
    let memoryLoaded = false;
    let consecutiveFailures = 0;
    let challengeAsks = 0;
    let diversionAsks = 0;
    let consecutiveScrolls = 0;
    let consecutiveSameClicks = 0;
    let lastClickRef = "";
    let listingObservations = [];
    let started = false;
    let stopped = false;
    let pendingVisualRepair = false;

    const stopRun = async (keepTab = true, keepOverlay = false) => {
      if (stopped || !started) {
        return;
      }
      stopped = true;
      try {
        await rpc.request(
          buildLocalBrowserRunCommand("stop", runId, { keepTab, keepOverlay }),
          { timeoutMs: 5000 }
        );
      } catch {
        // The extension may already have detached the tab.
      }
    };

    const showOverlay = (caption, asking, handoff) => {
      rpc
        .request(
          buildLocalBrowserRunCommand("ask", runId, {
            caption,
            ask: asking === true,
            handoff: handoff === true || asking === true,
          }),
          { signal: controller.signal }
        )
        .catch(() => {});
    };

    try {
      say("Starting local browser task…");
      let liveCaption = "Starting in your browser…";
      const startResult = await rpc.request(
        buildLocalBrowserRunCommand("start", runId),
        { signal: controller.signal }
      );
      started = true;
      assertLocalBrowserResult(startResult);
      if (startResult?.runId !== runId) {
        throw new Error("The browser extension returned an invalid run identifier.");
      }

      for (let stepNumber = 1; stepNumber <= 60; stepNumber += 1) {
        const observeDetails = {
          caption: liveCaption,
          ...(pendingVisualRepair ? { includeScreenshot: true } : {}),
        };
        pendingVisualRepair = false;
        let observation = await rpc.request(
          buildLocalBrowserRunCommand("observe", runId, observeDetails),
          { signal: controller.signal }
        );
        if (
          !observation?.ok &&
          /already attached|timed out/i.test(observation?.error || "")
        ) {
          await new Promise((resolve) => setTimeout(resolve, 300));
          observation = await rpc.request(
            buildLocalBrowserRunCommand("observe", runId, observeDetails),
            { signal: controller.signal }
          );
        }
        observation = assertLocalBrowserResult(observation);
        listingObservations = collectListingObservation(
          listingObservations,
          observation
        );

        observedHost = getLocalBrowserHost(observation) || observedHost;
        if (observedHost && !memoryLoaded) {
          memoryLoaded = true;
          const memoryResult = assertLocalBrowserResult(
            await rpc.request(
              buildLocalBrowserMemoryCommand("memory.get", observedHost),
              { signal: controller.signal }
            )
          );
          memory = memoryResult?.skill ?? null;
        }

        let step = await requestLocalBrowserStep({
          baseUrl: GlobalVariables.getSSEAPIURL(),
          goal,
          organizationId: taskOrganizationId,
          userId,
          idToken,
          observation,
          history,
          memory,
          signal: controller.signal,
        });

        let actionType = step?.type || "";

        if (actionType === "observe_visual") {
          observation = assertLocalBrowserResult(
            await rpc.request(
              buildLocalBrowserRunCommand("observe", runId, {
                includeScreenshot: true,
                caption: liveCaption,
              }),
              { signal: controller.signal }
            )
          );
          listingObservations = collectListingObservation(
            listingObservations,
            observation
          );
          step = await requestLocalBrowserStep({
            baseUrl: GlobalVariables.getSSEAPIURL(),
            goal,
            organizationId: taskOrganizationId,
            userId,
            idToken,
            observation,
            history,
            memory,
            signal: controller.signal,
          });
          actionType = step?.type || "";
        }

        const progressText =
          step?.status ||
          `Working in your browser (${stepNumber}/60)…`;
        liveCaption = String(progressText).slice(0, 240);
        say(liveCaption);
        showOverlay(liveCaption, false);

        if (
          actionType === "ask_user" ||
          /captcha|mfa|multi-factor|verification code|manual[- ]?login|sign in manually|log in manually/i.test(
            `${step?.reason || ""} ${step?.question || ""}`
          )
        ) {
          if (isChallengeAsk(step) && challengeAsks < 2) {
            challengeAsks += 1;
            history = appendLocalBrowserHistory(history, { type: "ask_user" }, {
              ok: false,
              error: CHALLENGE_ALTERNATE_ERROR,
            });
            liveCaption = "This site is challenged. Trying a public alternative…";
            say(liveCaption);
            showOverlay(liveCaption, false);
            continue;
          }
          if (!isChallengeAsk(step) && diversionAsks < 1) {
            diversionAsks += 1;
            history = appendLocalBrowserHistory(history, { type: "ask_user" }, {
              ok: false,
              error:
                "Do not ask the user. Open a different live public URL that still satisfies the goal, or call done with the facts already observed.",
            });
            liveCaption = "Trying another public page instead of asking…";
            say(liveCaption);
            showOverlay(liveCaption, false);
            continue;
          }
          const manualInterventionError = new Error(
            step?.question ||
              "The site needs your input (such as CAPTCHA or MFA). Complete it in the browser, then ask me to continue."
          );
          manualInterventionError.keepTab = true;
          showOverlay(manualInterventionError.message, false, true);

          throw manualInterventionError;
        }

        if (actionType === "done") {
          const unverifiedCartError = getUnverifiedCartDoneError(
            goal,
            observation
          );
          const unverifiedCompareError = getUnverifiedCompareDoneError(
            goal,
            observation,
            listingObservations,
            step?.summary
          );
          const unverifiedFilingError = getUnverifiedFilingDoneError(
            goal,
            observation
          );
          const unverifiedEmailDraftError = getUnverifiedEmailDraftDoneError(
            goal,
            observation
          );
          if (unverifiedCartError) {
            history = appendLocalBrowserHistory(
              history,
              { type: "done" },
              { ok: false, error: unverifiedCartError }
            );
            liveCaption = unverifiedCartError;
            say(liveCaption);
            showOverlay(liveCaption, false);
            continue;
          }
          if (unverifiedCompareError) {
            history = appendLocalBrowserHistory(
              history,
              { type: "done" },
              { ok: false, error: unverifiedCompareError }
            );
            liveCaption = unverifiedCompareError;
            say(liveCaption);
            showOverlay(liveCaption, false);
            continue;
          }
          if (unverifiedFilingError) {
            history = appendLocalBrowserHistory(
              history,
              { type: "done" },
              { ok: false, error: unverifiedFilingError }
            );
            liveCaption = unverifiedFilingError;
            say(liveCaption);
            showOverlay(liveCaption, false);
            continue;
          }
          if (unverifiedEmailDraftError) {
            history = appendLocalBrowserHistory(
              history,
              { type: "done" },
              { ok: false, error: unverifiedEmailDraftError }
            );
            liveCaption = unverifiedEmailDraftError;
            say(liveCaption);
            showOverlay(liveCaption, false);
            continue;
          }
          if (observedHost && step?.memory) {
            assertLocalBrowserResult(
              await rpc.request(
                buildLocalBrowserMemoryCommand(
                  "memory.put",
                  observedHost,
                  step.memory
                ),
                { signal: controller.signal }
              )
            );
          }
          await stopRun();
          say(step?.summary || "Browser task completed.", { done: true, ok: true });

          return;
        }

        if (actionType === "remember") {
          memory = step?.notes || memory;
          consecutiveScrolls = 0;
          consecutiveSameClicks = 0;
          lastClickRef = "";
          history = appendLocalBrowserHistory(
            history,
            { type: "remember" },
            { ok: true, remembered: true }
          );
          consecutiveFailures = 0;
          showOverlay(liveCaption, false);

          continue;
        }

        const action = getLocalBrowserExecutorAction(step);
        const blockedAddToCartScroll = getBlockedAddToCartScrollError(
          goal,
          observation,
          action
        );
        const blockedDraftSend = getBlockedDraftSendError(goal, step);
        let executeResult = blockedDraftSend
          ? { ok: false, error: blockedDraftSend }
          : blockedAddToCartScroll
          ? { ok: false, error: blockedAddToCartScroll }
          : action.type === "scroll" && consecutiveScrolls >= 3
            ? {
                ok: false,
                error:
                  "Three consecutive scrolls produced no recorded evidence. Do not scroll again. Use page text already visible, a fragment URL, a visible control, or a different source.",
              }
            : action.type === "click" &&
                action.ref === lastClickRef &&
                consecutiveSameClicks >= 3
              ? {
                  ok: false,
                  error:
                    "The same control was clicked three times with no new progress. Use a different control, a native option, or navigate to a direct URL.",
                }
              : null;
        let confirmed = false;
        if (!executeResult) {
          if (step?.requiresConfirmation) {
            const confirmMessage =
              step?.confirmationMessage ||
              "This browser action needs your confirmation.";
            liveCaption = confirmMessage;
            showOverlay(confirmMessage, true);
            confirmed = await localBrowserConfirmationRef.current.request({
              description: confirmMessage,
            });
            if (!confirmed) {
              throw new Error("Browser task canceled. No further action was taken.");
            }
            currentlyTypingRef.current = true;
            setCurrentlyTyping(true);
          }

          executeResult = await rpc.request(
            buildLocalBrowserRunCommand("execute", runId, {
              action,
              confirmed,
              caption: liveCaption,
            }),
            { signal: controller.signal }
          );

          if (executeResult?.requiresConfirmation === true) {
            const confirmMessage =
              executeResult?.confirmationMessage ||
              executeResult?.message ||
              "The extension needs confirmation for this browser action.";
            liveCaption = confirmMessage;
            showOverlay(confirmMessage, true);
            confirmed = await localBrowserConfirmationRef.current.request({
              description: confirmMessage,
            });
            if (!confirmed) {
              throw new Error("Browser task canceled. No further action was taken.");
            }
            currentlyTypingRef.current = true;
            setCurrentlyTyping(true);
            executeResult = await rpc.request(
              buildLocalBrowserRunCommand("execute", runId, {
                action,
                confirmed: true,
                caption: liveCaption,
              }),
              { signal: controller.signal }
            );
          }
        }

        if (isRetryableLocalBrowserFailure(executeResult)) {
          history = appendLocalBrowserHistory(history, action, executeResult);
          pendingVisualRepair = lastActionNeedsVisual(executeResult);
          consecutiveFailures += 1;
          const rawFailure = executeResult?.error;
          const failureMessage =
            typeof rawFailure === "string"
              ? rawFailure
              : rawFailure?.message ||
                rawFailure?.code ||
                executeResult?.message ||
                "The browser action could not be completed.";
          if (consecutiveFailures >= 3) {
            throw new Error(
              `The browser action failed three times. Last error: ${failureMessage}`
            );
          }
          liveCaption = "That action could not complete. Observing and replanning…";
          say(liveCaption);
          showOverlay(liveCaption, false);

          continue;
        }

        executeResult = assertLocalBrowserResult(executeResult);
        if (
          executeResult?.type === "ask_user" ||
          executeResult?.requiresUserInput === true ||
          /captcha|mfa|multi-factor|verification code|manual[- ]?login|sign in manually|log in manually/i.test(
            `${executeResult?.reason || ""} ${executeResult?.message || ""}`
          )
        ) {
          const manualInterventionError = new Error(
            executeResult?.message ||
              "The site needs your input (such as CAPTCHA or MFA). Complete it in the browser, then ask me to continue."
          );
          manualInterventionError.keepTab = true;
          showOverlay(manualInterventionError.message, false, true);

          throw manualInterventionError;
        }

        history = appendLocalBrowserHistory(history, action, executeResult);
        pendingVisualRepair = lastActionNeedsVisual(executeResult);
        consecutiveScrolls =
          action.type === "scroll" ? consecutiveScrolls + 1 : 0;
        if (action.type === "click") {
          consecutiveSameClicks =
            action.ref === lastClickRef ? consecutiveSameClicks + 1 : 1;
          lastClickRef = action.ref;
        } else {
          consecutiveSameClicks = 0;
          lastClickRef = "";
        }
        consecutiveFailures = 0;
      }

      throw new Error(
        "I stopped after 60 browser steps. Check the page and ask me to continue if needed."
      );
    } catch (error) {
      await stopRun(true, error?.keepTab === true);
      if (controller.signal.aborted) {
        say("Stopped.", { done: true, ok: false, stopped: true });
      } else {
        say(
          error?.message || "The local browser task stopped. Check the browser and try again.", { done: true, ok: false }
        );
      }
    } finally {
      localBrowserConfirmationRef.current?.cancel();
      if (localBrowserRunRef.current === run) {
        localBrowserRunRef.current = null;
      }
      currentlyTypingRef.current = false;
      setCurrentlyTyping(false);
    }
  };

  /**
   * Ask Addy v2's use_my_browser tool: the v2 chat hands a goal here and the existing browser-use
   * loop runs it in the LO's own browser (extension + planner + its confirmations). Resolves with
   * { status: done | failed | stopped, summary } for the agent.
   */
  const browserUseForV2 = {
    run: async ({ goal, onProgress, onConfirm }) => {
      const available = await probeLocalBrowserAgent(localBrowserRpcRef.current);
      if (!available) {
        return { status: "failed", summary: "The Addy browser extension isn't available or needs updating. Reload the extension and try again." };
      }
      const idToken = await resolveEmbeddedSidebarIdToken({ urlToken: token || "" }).catch(() => "");
      v2BrowserConfirmListenerRef.current = onConfirm || null;
      try {
        return await new Promise((resolve) => {
          runLocalBrowserTask({
            goal,
            organizationId: currentOrganizationId || selectedOrganizationId || organizationId || "",
            userId: uid || "",
            idToken: idToken || "",
            report: (text, outcome) => {
              onProgress?.(text);
              if (outcome?.done) resolve({ status: outcome.ok ? "done" : outcome.stopped ? "stopped" : "failed", summary: text });
            },
          });
        });
      } finally {
        v2BrowserConfirmListenerRef.current = null;
      }
    },
    confirm: (yes) => localBrowserConfirmationRef.current?.respond(Boolean(yes)),
    stop: () => localBrowserRunRef.current?.controller.abort(),
  };

  const onSendButtonClick = async (
    prompt,
    selectedText,
    compareMode,
    files,
    isVoiceMode = false,
    playVoiceResponse = null,
    retryContext = null, // { attempt: number, userMessageId: string }
    displayPromptOverride = null,
    sendOptions = {} // { pricingContext?: boolean }
  ) => {
    if (!prompt || prompt === "" || prompt.trim === "") {
      // eslint-disable-next-line no-undef
      alert("Prompt cannot be empty");
      return;
    }

    const effectiveCompareMode = normalizeCompareGuidelinesMode(compareMode, mode);

    if (interactionLock) {
      toastify(
        interactionLock.message ||
          "Please wait a moment before sending another request.",
        false,
        true
      );
      return;
    }

    if (clarificationPrompt?.kind === "local-browser-confirmation") {
      toastify("Choose Confirm and continue or Cancel for the browser action.", false, true);

      return;
    }

    if (currentlyTypingRef.current) return;
    currentlyTypingRef.current = true;
    resetFollowUps();

    // Change the view to chat to show the chat messages
    if (currentView === "select-assistant") setCurrentView("chat");

    // Check if using legacy agent and strip prefix for display
    const useLegacyAgent = prompt.toLowerCase().startsWith("old-ask-addy-ai");
    const isComputerUse = prompt.toLowerCase().startsWith("computer-use ");
    const localBrowserIntent = useLegacyAgent || isComputerUse
      ? { isLocalBrowserTask: false, goal: prompt }
      : getLocalBrowserTaskIntent(prompt);
    const displayPrompt = useLegacyAgent
      ? prompt.replace(/^old-ask-addy-ai\s*/i, "").trim()
      : isComputerUse
      ? prompt.replace(/^computer-use\s*/i, "").trim()
      : localBrowserIntent.isLocalBrowserTask
      ? localBrowserIntent.goal
      : displayPromptOverride || prompt;
    const actualPrompt = useLegacyAgent
      ? prompt.replace(/^old-ask-addy-ai\s*/i, "").trim()
      : isComputerUse
      ? prompt.replace(/^computer-use\s*/i, "").trim()
      : prompt;

    // computer-use stays on the remote computer.addy.so viewer.
    if (isComputerUse) {
      const taskMessage = displayPrompt;
      const effectiveUid = uid || "";
      const effectiveOrgId = currentOrganizationId || organizationId || "";

      const userMsgId = uuidv4();
      const userMsgText = userMessage(taskMessage, "", userMsgId);
      setMessageTexts((prev) => [...prev, userMsgText]);

      const assistantMsgId = uuidv4();
      browserTaskMessageIdRef.current = assistantMsgId;
      browserTaskFirstDeltaRef.current = false;
      const thinkingMsg = assistantMessage(
        "Starting AI Computer task... Opening live viewer so you can watch the agent work and step in if needed.",
        "response",
        assistantMsgId
      );
      setMessageTexts((prev) => [...prev, thinkingMsg]);
      currentlyTypingRef.current = true;
      setCurrentlyTyping(true);

      window.parent.postMessage({
        key: "start-browser-task",
        value: {
          message: taskMessage,
          uid: effectiveUid,
          organizationId: effectiveOrgId,
        },
      }, "*");

      return;
    }

    // browser-use is explicit only. There is no natural-language auto-detect.
    if (localBrowserIntent.isLocalBrowserTask) {
      const localBrowserAvailable = await probeLocalBrowserAgent(
        localBrowserRpcRef.current
      );
      if (!localBrowserAvailable) {
        toastify(
          "Local browser control needs the updated Addy extension. Reload the extension and try again.",
          false,
          true
        );
        currentlyTypingRef.current = false;

        return;
      }

      const taskMessage = displayPrompt;
      const effectiveUid = uid || "";
      const effectiveOrgId = currentOrganizationId || organizationId || "";

      const userMsgId = uuidv4();
      const userMsgText = userMessage(taskMessage, "", userMsgId);
      setMessageTexts((prev) => [...prev, userMsgText]);

      const assistantMsgId = uuidv4();
      const thinkingMsg = assistantMessage(
        "Starting local browser task…",
        "response",
        assistantMsgId
      );
      setMessageTexts((prev) => [...prev, thinkingMsg]);
      setCurrentlyTyping(true);

      void resolveEmbeddedSidebarIdToken({ urlToken: token || "" })
        .catch(() => "")
        .then((plannerToken) =>
          runLocalBrowserTask({
            goal: taskMessage,
            organizationId: effectiveOrgId,
            userId: effectiveUid,
            idToken: plannerToken || "",
            assistantMessageId: assistantMsgId,
          }),
        );

      return;
    }

    // Append the user's message to the chat (using cleaned prompt for display).
    // On auto-retry we reuse the existing user bubble instead of pushing a new one.
    let userMessageId;
    if (retryContext?.userMessageId) {
      userMessageId = retryContext.userMessageId;
    } else {
      userMessageId = uuidv4();
      const userMessageText = userMessage(displayPrompt, selectedText, userMessageId);
      setMessageTexts((prevMessageTexts) => [
        ...prevMessageTexts,
        userMessageText,
      ]);
    }
    const pendingClarificationSessionKey = clarificationPrompt?.sessionKey || null;
    setClarificationPrompt(null);
    // Create Thinking Text and append to messageTexts
    const assistantMessageId = uuidv4();
    // A chat with picked documents sends them with the question and shows citations.
    const isChatWithDocsMessage =
      !useLegacyAgent && isChatWithDocsEnabled && currentChatDocs.length > 0;
    const assistantMessageTextBuffer = assistantMessage(
      "",
      "thinking",
      assistantMessageId
    );
    setMessageTexts((prevMessageTexts) => [
      ...prevMessageTexts,
      assistantMessageTextBuffer,
    ]);
    setAgentStatus({
      type: "thinking",
      message: retryContext ? "Retrying due to invalid response..." : "Thinking...",
    });
    setActiveStreamingMessageId(assistantMessageId);
    setHideSkeleton(!useLegacyAgent);
    linkBufferRef.current = "";

    // Get the assistant's response
    // console.log("Selected assistant", selectedAssistant);

    let requestParams = {
      language: "english",
      tone: "neutral",
      name: name,
      user_prompt: actualPrompt,
      selected_text: selectedText,
      isComparison: effectiveCompareMode,
    };

    if (files && files.length && files.length > 0) {
      // map files and usedFiles to the request params (uasedfiles that have different file names)
      if (usedFiles && usedFiles.length > 0) {
        // Flatten all files from all objects in the usedFiles array
        const allUsedFiles = usedFiles.flatMap((obj) => obj.files || []);

        const usedFilesWithDifferentNames = allUsedFiles.filter(
          (usedFile) => !files.some((file) => file.name === usedFile.name)
        );

        requestParams.attachmentListBase64 = [
          ...files.map((file) => ({
            name: file.name,
            textContent: file.textContent,
          })),
          ...usedFilesWithDifferentNames.map((file) => ({
            name: file.name,
            textContent: file.textContent,
          })),
        ];
      } else {
        requestParams.attachmentListBase64 = files.map((file) => ({
          name: file.name,
          textContent: file.textContent,
        }));
      }

      setUsedFiles((prevUsedFiles) => [
        ...prevUsedFiles,
        {
          files: files,
          messageId: userMessageId,
        },
      ]);
    } else {
      if (usedFiles && usedFiles.length && usedFiles.length > 0) {
        requestParams.attachmentListBase64 = usedFiles.flatMap((obj) =>
          obj.files.map((file) => ({
            name: file.name,
            textContent: file.textContent,
          }))
        );
      }
    }

    // put on the used files and relate it to the current message id

    if (!retryContext) {
      notifyScenarioChatMessage({
        chatId: CHAT_ID,
        text: displayPrompt,
        files,
      });
    }

    setFiles([]);

    setLoadingDocuments(true);

    const inlineAttachmentsForAgent =
      requestParams.attachmentListBase64 &&
      requestParams.attachmentListBase64.length > 0
        ? requestParams.attachmentListBase64
        : undefined;
    
    let responses;
    const streamAbortController = new AbortController();
    activeStreamAbortControllerRef.current = streamAbortController;
    closeTriggeredAbortRef.current = false;
    
    if (!useLegacyAgent) {
      
      // Transform chat history to new format: {role, content, timestamp}
      const transformedChatHistory = messageTexts.map((msg) => ({
        role: msg.name === name ? "user" : "assistant",
        content: msg.message,
        timestamp: msg.timestamp || Date.now(),
      }));

      // Call new agent with proper parameters (NO await - it's a generator!)
      // CRA requires REACT_APP_ prefix for env vars
      const fallbackOrgId = process.env.REACT_APP_TEST_ORG_ID;
      const fallbackUserId = process.env.REACT_APP_TEST_USER_ID;
      
      // Request current loan context from parent (chrome extension) before sending query
      // This ensures we always use the most up-to-date loan when user navigates
      let latestLoanId = currentLoanId || null;
      let latestOrganizationId = currentOrganizationId || selectedOrganizationId || organizationId || null;
      
      // Request current context from parent via postMessage (handles cross-origin)
      // Use a promise to wait for the response
      const getCurrentLoanContext = () => {
        return new Promise((resolve) => {
          // Set up a one-time listener for the response
          let resolved = false;
          const responseHandler = (event) => {
            // Handle both message formats: { key, value } and direct data
            const messageKey = event.data?.key;
            const messageValue = event.data?.value || event.data;
                        
            if (messageKey === "currentLoanContext" || (event.data && event.data.loanId !== undefined)) {
              const contextData = messageKey === "currentLoanContext" ? messageValue : event.data;
              
              let resolvedLoanId = latestLoanId;
              let resolvedOrgId = latestOrganizationId;
                            
              if (contextData) {
                const parentLoanId = contextData.loanId || null;
                const parentOrgId = contextData.organizationId || null;
                
                if (parentLoanId) {
                  resolvedLoanId = parentLoanId;
                }
                if (parentOrgId) {
                  resolvedOrgId = parentOrgId;
                }
              }
              
              // Only resolve once
              if (!resolved) {
                resolved = true;
                window.removeEventListener("message", responseHandler);
                resolve({ loanId: resolvedLoanId, organizationId: resolvedOrgId });
              } else {
                // Response arrived late, but still update state for next message
                if (resolvedLoanId && resolvedLoanId !== currentLoanId) {
                  setCurrentLoanId(resolvedLoanId);
                }
                if (resolvedOrgId && resolvedOrgId !== currentOrganizationId) {
                  setCurrentOrganizationId(resolvedOrgId);
                  if (setSelectedOrganizationId && resolvedOrgId) {
                    setSelectedOrganizationId(resolvedOrgId);
                  }
                }
              }
            }
          };
          
          window.addEventListener("message", responseHandler);
          
          // Request context from parent
          if (window.parent && window.parent !== window) {
            window.parent.postMessage({ key: "getCurrentLoanContext" }, "*");
          }
          
          // Timeout after 2 seconds - give enough time for API call to fetch orgId
          setTimeout(() => {
            if (!resolved) {
              resolved = true;
              window.removeEventListener("message", responseHandler);
              resolve({ loanId: latestLoanId, organizationId: latestOrganizationId });
            }
          }, 2000);
        });
      };
      
      // Wait for context (with timeout) before proceeding
      const contextResult = await getCurrentLoanContext();
      
      // Use the resolved context values - prioritize the fresh context from parent
      if (contextResult.loanId) {
        latestLoanId = contextResult.loanId;
      }
      if (contextResult.organizationId) {
        latestOrganizationId = contextResult.organizationId;
      }
      
      // Also update state so it persists for next message
      if (latestLoanId && latestLoanId !== currentLoanId) {
        setCurrentLoanId(latestLoanId);
      }
      if (latestOrganizationId && latestOrganizationId !== currentOrganizationId) {
        setCurrentOrganizationId(latestOrganizationId);
        if (setSelectedOrganizationId && latestOrganizationId) {
          setSelectedOrganizationId(latestOrganizationId);
        }
      }
      
      // Use latest values or fall back to defaults
      const effectiveLoanId = latestLoanId;
      const effectiveOrgId = latestOrganizationId || selectedOrganizationId || organizationId || fallbackOrgId;
      const finalOrgId = effectiveOrgId;
      const finalUserId = uid || fallbackUserId;

      let requestAuthToken = token || "";
      let portalAuthUnavailable = false;
      if (mode === "documentPortal") {
        try {
          requestAuthToken = await requestDocumentPortalIdToken({
            forceRefresh: true,
          });
        } catch {
          portalAuthUnavailable = true;
        }
      }

      // Chat with your docs: every picked document goes with the question,
      // ahead of any files uploaded to the chat (DEV-6130).
      if (isChatWithDocsMessage) {
        await loadMissingChatDocText(currentChatDocs);
      }
      const chatDocInlineDocuments = isChatWithDocsMessage
        ? toInlineChatDocuments(currentChatDocs, chatDocTextRef.current)
        : [];
      const inlineDocumentsForAgent =
        chatDocInlineDocuments.length > 0
          ? [...chatDocInlineDocuments, ...(inlineAttachmentsForAgent || [])]
          : inlineAttachmentsForAgent;

      // Send query to agent (user responses to clarifications are sent as regular queries)
      responses = portalAuthUnavailable
        ? (async function* portalAuthErrorResponse() {
            yield {
              type: "error",
              content:
                "Your document portal session could not be verified. Please sign in again and retry.",
            };
          })()
        : pendingClarificationSessionKey
        ? Assistant.resumeAgentClarification({
            clarificationResponse: actualPrompt,
            sessionKey: pendingClarificationSessionKey,
            organizationId: finalOrgId || "",
            userId: finalUserId || "",
            loanId: effectiveLoanId || "",
            appID: selectedAssistant?.appID || "",
            kbID: "",
            mode: mode || "",
            email: email || "",
            token: requestAuthToken,
            abortSignal: streamAbortController.signal,
          })
        : Assistant.getAgentChatResponse({
            query: actualPrompt,
            displayQuery: displayPrompt,
            isRetry: !!retryContext,
            threadId: CHAT_ID === "new" ? undefined : CHAT_ID,
            organizationId: finalOrgId || "",
            userId: finalUserId || "",
            loanId: effectiveLoanId || "",
            appID: selectedAssistant?.appID || "",
            kbID: "",
            mode: mode || "",
            email: email || "",
            inlineDocuments: inlineDocumentsForAgent,
            compareMode: effectiveCompareMode,
            pricingContext: !!sendOptions?.pricingContext,
            token: requestAuthToken,
            abortSignal: streamAbortController.signal,
            chatWithDocs: chatDocInlineDocuments.length > 0,
          });
    } else {
      // Use OLD METHOD when explicitly requested (EMAIL FEATURES USE THIS)
      
      responses = await Assistant.getEmailReplyChat(
        selectedOrganizationId || null,
        selectedAssistant?.appID,
        selectedAssistant?.publicId,
        uid,
        hostName,
        CHAT_ID,
        actualPrompt,
        selectedText,
        name,
        clientHostname,
        selectedChatHistory,
        requestParams,
        email,
        "addy-assistant-001",
        [],
        [],
        true,
        messageTexts.map((msg) => ({ message: msg.message, name: msg.name })),
        voiceMode,
        streamAbortController.signal
      );
    }

    // Get the last assistant message which was thinking
    let assistantMessageElement = document.getElementById(
      `${assistantMessageId}`
    );
    if (!assistantMessageElement) {
      await sleep(10); // wait for the assistant message to render
      assistantMessageElement = document.getElementById(
        `${assistantMessageId}`
      );
    }

    // Type in the assistant's response
    const messageText = assistantMessageElement?.querySelector(
      ".model-response-text"
    );
    const feedbackContainer = assistantMessageElement?.querySelector(
      ".feedback-container"
    );
    let firstChunk = true;
    let clarificationHandled = false;
    setCurrentlyTyping(true);
    let fullResponse = "";
    let buffer = "";
    let encounteredError = false;
    // Authoritative final text from the server (final_response event): link
    // refs resolved AND document names enforced as correct links. When it
    // arrives, it replaces the accumulated streamed text at completion.
    let serverFinalText = "";

    // Reset the link reference map for this stream. Earlier messages already
    // have real URLs baked in, and reference numbers restart per session, so
    // a stale map could resolve refs to the wrong URLs.
    linkMapRef.current = {};
    setLinkMap({});

    streamWatchdog.start();

    try {
      for await (const response of responses) {
        streamWatchdog.trackActivity(getStreamEventKind(response));

        // Handle object-based events from the agent stream
        if (typeof response === "object") {
          if (response.type === "insight") {
            let insightQuestion = "";
            try {
              const insightPayload =
                typeof response.content === "string"
                  ? JSON.parse(response.content)
                  : response.content;
              insightQuestion =
                insightPayload?.question ||
                insightPayload?.content ||
                insightPayload?.message ||
                "";
            } catch (_) {
              insightQuestion = "";
            }
            if (insightQuestion) {
              setAgentStatus({ type: "insight", message: insightQuestion });
            }
            continue;
          }

          if (response.type === "error") {
            const friendlyMessage = handleAgentError(response);
            fullResponse = friendlyMessage;
            encounteredError = true;
            break;
          }

          if (response.type === "progress") {

            const progressMessage =
              response.message || "Processing your query...";

            setAgentStatus({
              type: "progress",
              message: progressMessage,
            });

            continue; // Continue to next event
          }

          if (response.type === "refresh_loan") {
            // A loan-mutating tool (e.g. update_loan_details) succeeded.
            // Notify the parent window so it can reload the loan page.
            window.parent.postMessage({ key: "agent-refresh-loan" }, "*");
            continue;
          }

          if (response.type === "links") {
            // Short link references (addylink:N) -> real URLs. Arrives as
            // soon as tool results produce links — usually before the model
            // streams the text that uses them, so links render clickable
            // immediately; otherwise the placeholder upgrades in place.
            linkMapRef.current = {
              ...linkMapRef.current,
              ...(response.links || {}),
            };
            setLinkMap(linkMapRef.current);
            continue;
          }

          if (response.type === "final_text") {
            serverFinalText = response.content || "";
            continue;
          }

          if (response.type === "citations") {
            // Citation pills belong to Chat with your docs; other chats are
            // left exactly as they were.
            if (!isChatWithDocsMessage) {
              continue;
            }
            // Match each citation back to the picked document holding the cited
            // value, for its name, link, readable excerpt and highlight text.
            const citations = enrichCitations(
              response.citations,
              toCitationSourceDocuments(currentChatDocs, chatDocTextRef.current)
            );
            setMessageTexts((prevMessageTexts) =>
              prevMessageTexts.map((message) =>
                message.messageId === assistantMessageId
                  ? { ...message, citations: mergeCitations(message.citations, citations) }
                  : message
              )
            );
            continue;
          }

          if (response.type === "pricing_results") {
            setPricingResultsContext((prev) => [
              ...prev,
              {
                pricingResults: response.pricingUi,
                messageId: messageTexts.length + 1,
              },
            ]);
            continue;
          }

          if (response.type === "clarification") {
            currentlyTypingRef.current = false;
            setCurrentlyTyping(false);
            setLoadingDocuments(false);
            setClarificationPrompt({
              question: response.question,
              options: response.options || [],
              sessionKey: response.sessionKey,
            });

            const messageLines = [
              response.question,
              "",
              ...(response.options || []).map((option, index) => {
                const label =
                  option?.label || option?.value || `Option ${index + 1}`;
                return `${index + 1}. ${label}`;
              }),
              "",
              "Please type the number or name of your selection.",
            ];

            const clarificationText = messageLines.join("\n");

            finalizeThinkingMessage();
            linkBufferRef.current = "";
            setAgentStatus({ type: "", message: "" });

            setMessageTexts((prev) => {
              const newMessages = [...prev];
              for (let i = newMessages.length - 1; i >= 0; i--) {
                const msg = newMessages[i];
                if (msg.type === "assistant") {
                  newMessages[i] = {
                    ...msg,
                    action: "response",
                    message: clarificationText,
                  };
                  break;
                }
              }
              return newMessages;
            });

            clarificationHandled = true;
            break;
          }
        }

        // Handle normal text responses (STRING FORMAT)
        let text = "";
        let textWithoutMardown = "";
        if (typeof response === "string") {
          if (response.startsWith("Error:")) {
            const normalizedErrorMessage = response
              .replace(/^Error:\s*/i, "")
              .trim();
            const derivedErrorType = isRequestTimeoutMessage(
              normalizedErrorMessage
            )
              ? "REQUEST_TIMEOUT"
              : "UNKNOWN";
            const friendlyMessage = handleAgentError({
              errorType: derivedErrorType,
              message: normalizedErrorMessage,
            });
            fullResponse = friendlyMessage;
            encounteredError = true;
            break;
          }
          if (response.includes("documents-fetched-")) {
            const documents = JSON.parse(
              response.split("documents-fetched-")[1]
            );
            const docObj = {
              documents: documents,
              messageId: messageTexts.length + 1,
            };
            // console.log("Documents fetched", docObj);
            setDocumentsContext([...documentsContext, docObj]);
            text = "";
          } else if (response.includes("documents-compared-")) {
            // console.log("Documents compared", response);
            const documents = JSON.parse(
              response.split("documents-compared-")[1]
            );
            const docObj = {
              documentsCompared: documents,
              messageId: messageTexts.length + 1,
            };
            // console.log("Documents compared", docObj);
            setDocumentsComparedContext([...documentsComparedContext, docObj]);
            text = "";
          } else {
            // New agent returns clean chunks without "data: " prefix
            text = response;
            textWithoutMardown = text
              .replace(/(\*\*|\*|`|#+|>|\[|\]|\(|\)|~|_|-)/g, "")
              .replace(
                /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF])/g,
                ""
              );
          }
        } else {
          // console.error("Response is not a string:", response);
          continue; // Skip the current iteration as response isn't a string.
        } // Produce a typing effect for the text

        text = formatChunkWithLinks(text);

        // if(response && typeof response === "string" && response.split("data: ") && response.split("data: ").length > 1) {
        //   text = response.split("data: ")[1];
        // } else {
        //   text = response;
        // }
        // Produce a typing effect for the text
        if (firstChunk) {
          finalizeThinkingMessage();
          messageText?.classList.remove("hide");
          firstChunk = false;
        }

        fullResponse += text;
        setMessageTexts((prevMessageTexts) => {
          const messageIndex = prevMessageTexts.findIndex(
            (message) => message.messageId === assistantMessageId
          );
          if (messageIndex === -1) return prevMessageTexts;

          const newMessageTexts = [...prevMessageTexts];
          const currentMessage = newMessageTexts[messageIndex];
          newMessageTexts[messageIndex] = {
            ...currentMessage,
            message: (currentMessage.message || "") + text,
          };

          return newMessageTexts;
        });

        // Replace with this improved code:
        if (voiceMode) {
          // Clean markdown and special characters
          buffer += textWithoutMardown;

          // Match all full sentences in the buffer
          const sentenceEndRegex = /[^.?!]*[.?!]/g;
          let match;
          let lastCompleteIndex = 0;
          let sentencesToSpeak = [];

          // Extract all sentences
          while ((match = sentenceEndRegex.exec(buffer)) !== null) {
            const sentence = match[0].trim();
            if (sentence.length > 0) {
              sentencesToSpeak.push(sentence);
              lastCompleteIndex = sentenceEndRegex.lastIndex;
            }
          }

          // Group short sentences if needed
          const processedSentences = [];
          let currentGroup = "";

          for (const sentence of sentencesToSpeak) {
            if (currentGroup.length + sentence.length < 100) {
              currentGroup += (currentGroup ? " " : "") + sentence;
            } else {
              if (currentGroup) processedSentences.push(currentGroup);
              currentGroup = sentence;
            }
          }
          if (currentGroup) processedSentences.push(currentGroup);

          // Speak each processed sentence
          for (const sentence of processedSentences) {
            try {
              await playVoiceResponse(sentence);
            } catch (error) {
              if (error.message === "Audio playback error.") {
                // Audio was stopped, continue with the next sentence
                continue;
              }
              throw error; // Re-throw other errors
            }
          }

          // Keep the remainder (incomplete sentence) in the buffer
          buffer = buffer.slice(lastCompleteIndex);
        }

        // Create a typing effect
        //for (let i = 0; i < text.length; i++) {
        // Append messageText message attribute to text at character i
        //setMessageTexts((prevMessageTexts) => {
        //const newMessageTexts = [...prevMessageTexts];
        //newMessageTexts[newMessageTexts.length - 1].message += text.charAt(i);
        //return newMessageTexts;
        //});

        //await sleep(5); // Sleep for 5 milliseconds to create typing effect
        // Scroll to the bottom of the chat
        //if (chatHistoryRef.current) {
        //chatHistoryRef.current.scrollTop =
        //chatHistoryRef.current.scrollHeight;
        // }
        //}
      }
      if (streamAbortController.signal.aborted && firstChunk) {
        finalizeThinkingMessage();
        setMessageTexts(markLatestResponseCanceled);
      }

      if (!encounteredError && !clarificationHandled) {
        if (serverFinalText) {
          // Replace the accumulated streamed text with the server's
          // authoritative final text: every addylink ref is resolved and
          // every known document name links to its correct URL, fixing any
          // missing, wrong, or partially typed links the model streamed.
          if (firstChunk) {
            finalizeThinkingMessage();
            messageText?.classList.remove("hide");
            firstChunk = false;
          }
          linkBufferRef.current = "";
          // Client-side pass is a safety net for any ref the server could
          // not resolve (it strips unknown refs to plain labels).
          fullResponse = resolveLinkReferences(
            serverFinalText,
            linkMapRef.current
          );
          setMessageTexts((prevMessageTexts) => {
            const messageIndex = prevMessageTexts.findIndex(
              (message) => message.messageId === assistantMessageId
            );
            if (messageIndex === -1) return prevMessageTexts;

            const newMessages = [...prevMessageTexts];
            newMessages[messageIndex] = {
              ...newMessages[messageIndex],
              action: "response",
              message: fullResponse,
            };
            return newMessages;
          });
        } else {
          const leftoverFormatted = flushLinkBuffer();
          if (leftoverFormatted) {
            setMessageTexts((prevMessageTexts) => {
              const messageIndex = prevMessageTexts.findIndex(
                (message) => message.messageId === assistantMessageId
              );
              if (messageIndex === -1) return prevMessageTexts;

              const newMessages = [...prevMessageTexts];
              const currentMessage = newMessages[messageIndex];
              newMessages[messageIndex] = {
                ...currentMessage,
                message: (currentMessage.message || "") + leftoverFormatted,
              };
              return newMessages;
            });
            fullResponse += leftoverFormatted;
          }

          // Bake resolved link references into the final message so persisted
          // history (localStorage / Firestore) contains real URLs — the link
          // map is transient and only lives for the duration of the stream.
          const finalLinkMap = linkMapRef.current;
          if (Object.keys(finalLinkMap).length > 0) {
            fullResponse = resolveLinkReferences(fullResponse, finalLinkMap);
            setMessageTexts((prevMessageTexts) => {
              const newMessages = [...prevMessageTexts];
              const lastMessage = newMessages[newMessages.length - 1];
              if (lastMessage && lastMessage.type === "assistant") {
                newMessages[newMessages.length - 1] = {
                  ...lastMessage,
                  message: resolveLinkReferences(
                    lastMessage.message,
                    finalLinkMap,
                  ),
                };
              }
              return newMessages;
            });
          }
        }
      } else {
        linkBufferRef.current = "";
      }

      if (streamAbortController.signal.aborted && !firstChunk) {
        setMessageTexts((prevMessageTexts) =>
          appendCanceledNotice(prevMessageTexts, assistantMessageId)
        );
      }

      setLoadingDocuments(false);

      if (!encounteredError && voiceMode && buffer.trim().length > 0) {
        try {
          await playVoiceResponse(buffer.trim());
        } catch (error) {
          if (error.message !== "Audio playback error.") {
            throw error;
          }
        }
      }
    } catch (error) {
      // console.error("Error processing reduceResult:", error);
      setLoadingDocuments(false);
      currentlyTypingRef.current = false;
      setCurrentlyTyping(false);
      setAgentStatus({ type: "", message: "" });
      setHideSkeleton(false);
    } finally {
      streamWatchdog.stop();
      setHideSkeleton(false);
      linkBufferRef.current = "";
      setActiveStreamingMessageId(null);
      if (activeStreamAbortControllerRef.current === streamAbortController) {
        activeStreamAbortControllerRef.current = null;
      }
      closeTriggeredAbortRef.current = false;
    }

    // Auto-retry gobbled responses (up to AUTO_RETRY_MAX_ATTEMPTS times).
    // Only retries clean "successful" streams that produced garbage text —
    // errors, clarifications, aborts, legacy paths, and voice mode are
    // intentionally excluded.
    const currentRetryAttempt = retryContext?.attempt || 0;
    const shouldAutoRetry =
      currentRetryAttempt < AUTO_RETRY_MAX_ATTEMPTS &&
      !encounteredError &&
      !clarificationHandled &&
      !streamAbortController.signal.aborted &&
      !useLegacyAgent &&
      !pendingClarificationSessionKey &&
      !voiceMode &&
      looksLikeGibberishResponse(fullResponse);

    if (shouldAutoRetry) {
      console.warn("[AskAddy] Detected corrupted response, retrying...", {
        attempt: currentRetryAttempt + 1,
        maxAttempts: AUTO_RETRY_MAX_ATTEMPTS,
        responseLength: fullResponse?.length,
      });

      // Remove only the failed assistant message; keep the user's bubble.
      setMessageTexts((prev) =>
        prev.filter((m) => m.messageId !== assistantMessageId),
      );

      // Reset currentlyTyping so the recursive call's guard passes.
      currentlyTypingRef.current = false;
      setCurrentlyTyping(false);

      return onSendButtonClick(
        prompt,
        selectedText,
        effectiveCompareMode,
        files,
        isVoiceMode,
        playVoiceResponse,
        { attempt: currentRetryAttempt + 1, userMessageId },
      );
    }

    // Set currently typing to be false
    currentlyTypingRef.current = false;
    setCurrentlyTyping(false);
    if (feedbackContainer) {
      feedbackContainer.classList.remove("hide");
    }

    if (
      shouldGenerateFollowUps({
        encounteredError,
        clarificationHandled,
        aborted: streamAbortController.signal.aborted,
        fullResponse,
      })
    ) {
      const requestId = followUpRequestIdRef.current;
      const lastUserQuestion = displayPrompt || actualPrompt;
      setIsGeneratingFollowUps(true);

      const previousQuestions = extractPreviousUserQuestions(
        [
          ...messageTexts,
          { type: "user", message: lastUserQuestion },
        ],
        4
      );

      AskAddyFollowUpModel.generateFollowUps({
        previousQuestions,
        lastUserQuestion,
        lastResponse: fullResponse,
        loanId: currentLoanId || loanId || null,
        memberRole: currentMemberRole || null,
      })
        .then((suggestions) => {
          if (followUpRequestIdRef.current !== requestId) {
            return;
          }

          setFollowUpSuggestions(suggestions);
        })
        .finally(() => {
          if (followUpRequestIdRef.current === requestId) {
            setIsGeneratingFollowUps(false);
          }
        });
    }

    // Chat will be auto-saved by useEffect when messageTexts updates
    //return fullMessageText;
    return fullResponse;
  };

  const saveCurrentChatLocally = (messagesToSave = messageTexts) => {
    if (messagesToSave.length && selectedAssistant?.appID) {
      // Name the chat after its first message rather than the host page. The hostname
      // was a leftover from the browser-extension era and reads as "localhost" in dev.
      // ChatHistoryDropdown replaces this with an AI-generated title once history exists.
      const provisionalChatName = getProvisionalChatName(messagesToSave[0]?.message);
      const isPlaceholderName = !chatName || chatName === formatChatName;
      const resolvedChatName =
        isPlaceholderName && provisionalChatName ? provisionalChatName : chatName;

      const locallyStoredChat = {
        chatID: CHAT_ID,
        messages: messagesToSave,
        appID: selectedAssistant.appID,
        publicId: selectedAssistant?.publicId,
        chatName: resolvedChatName,
        loanId: currentLoanId || null, // Associate chat with loan if in loan context
      };
      localStorage.setItem(CHAT_ID, JSON.stringify(locallyStoredChat));
      // Save a map of the save chats and their local storage keys
      const savedChats =
        JSON.parse(localStorage.getItem("addy-ai-sidebar-chats")) || {};
      if (!savedChats[CHAT_ID]) {
        savedChats[CHAT_ID] = {
          chatName: resolvedChatName,
          chatID: CHAT_ID,
          clientHostname: clientHostname,
          publicId: selectedAssistant?.publicId,
          appID: selectedAssistant.appID,
          dateStarted: Date.now(), // Epoch time in milliseconds
          lastActive: Date.now(), // Epoch time in milliseconds
          loanId: currentLoanId || null, // Associate with loan in chat index
        };
        localStorage.setItem(
          "addy-ai-sidebar-chats",
          JSON.stringify(savedChats)
        );
        // Runs once per chat, so the history list refetches on creation only
        setChatListVersion((previousVersion) => previousVersion + 1);
      } else {
        // Chat exists, update the last active time and loan association
        savedChats[CHAT_ID].lastActive = Date.now();
        savedChats[CHAT_ID].loanId = currentLoanId || savedChats[CHAT_ID].loanId || null;
        localStorage.setItem(
          "addy-ai-sidebar-chats",
          JSON.stringify(savedChats)
        );
      }

      // Save the current chat as the last active chat (for non-loan contexts)
      localStorage.setItem("addy-ai-sidebar-last-chat-id", CHAT_ID);
      
      // If in loan context, also update the loan-to-chat mapping
      if (currentLoanId) {
        saveLoanChatMapping(currentLoanId, CHAT_ID);
      }

      // Persist to backend for cross-device sync (fire-and-forget)
      if (uid) {
        const savedChats =
          JSON.parse(localStorage.getItem("addy-ai-sidebar-chats")) || {};
        const meta = savedChats[CHAT_ID] || {};
        const chatDataForBackend = {
          ...locallyStoredChat,
          clientHostname,
          dateStarted: meta.dateStarted || Date.now(),
          lastActive: meta.lastActive || Date.now(),
        };
        SidebarChatHistoryModel.saveChat(uid, chatDataForBackend).catch(
          () => {}
        );
      }
    }
  };

  async function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const onAssistantClick = (assistant) => {
    // If switching to a different assistant while a chat with messages is in progress,
    // persist the current chat to history and start a fresh one for the new agent.
    const isSwitchingAssistant = selectedAssistant && selectedAssistant.appID !== assistant.appID;
    if (isSwitchingAssistant && messageTexts.length > 0) {
      // The current chat is already auto-saved by the useEffect on messageTexts,
      // so we only need to reset state to open a clean slate.
      setChatID(uuidv4());
      setMessageTexts([]);
      setChatName(clientHostname ? clientHostname.replace("www.", "") : getDateFormat());
      setSelectedChatHistory(null);
      setCurrentView("chat");
    }

    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set('assistant', assistant.defaultId ? assistant.defaultId : assistant.appID);
    setSearchParams(currentParams);
    setSelectedAssistant(assistant);
    setShowDropdown(false);
  };

  // Only agents ready to answer: trained ones and Addy's built-ins (plus the one in use, so its check shows).
  const agentOptions = (assistants || [])
    .filter((agent) => agent.trained || getAgentId(agent).startsWith(DEFAULT_AGENT_ID_PREFIX) || getAgentId(agent) === getAgentId(v2Agent))
    .map((agent) => ({
      id: getAgentId(agent),
      name: getWhiteLabeledAssistantName(agent, assistantName) || agent.appName,
      description: agent.description || "",
      imageUrl: agent.imageUrl || "",
    }));
  const activeAgentId = getAgentId(v2Agent) || ADDY_DEFAULT_AGENT_ID;

  // The agent menu only renders when it opens: its pictures download with the agent list instead.
  const agentImageUrls = [v2Assistant?.imageUrl, ...agentOptions.map(({ imageUrl }) => imageUrl)].join("\n");
  useEffect(() => {
    preloadImages(agentImageUrls.split("\n"));
  }, [agentImageUrls]);

  const toggleAgentMenu = useCallback((event) => {
    const { currentTarget } = event;
    setAgentMenuAnchor((anchor) => (anchor ? null : currentTarget));
  }, []);

  // The new Ask Addy answers as the picked agent from the next question on, in a new chat, so a
  // conversation never changes agent halfway through.
  const pickAgent = (agentId) => {
    setAgentMenuAnchor(null);
    if (agentId === activeAgentId) {
      return;
    }

    setV2AgentId(agentId);
    onCreateNewChatClick();
  };

  const userMessage = (message, selectedText, messageId) => {
    return {
      message: message,
      selectedText: selectedText,
      name: name,
      type: "user",
      messageId: messageId,
      imageURL: userImageUrl,
    };
  };

  useEffect(() => {
    const onMessage = (event) => {
      if (event.data?.key !== "local-browser-overlay-choice") {
        return;
      }
      const choice = event.data?.value?.choice;
      if (choice !== "confirm" && choice !== "cancel") {
        return;
      }
      const gate = localBrowserConfirmationRef.current;
      if (!gate?.hasPending()) {
        return;
      }
      const confirmed = choice === "confirm";
      setMessageTexts((previousMessages) => [
        ...previousMessages,
        userMessage(
          confirmed ? "Confirm and continue" : "Cancel",
          "",
          uuidv4()
        ),
      ]);
      gate.respond(confirmed);
    };
    window.addEventListener("message", onMessage);

    return () => window.removeEventListener("message", onMessage);
  }, [name, userImageUrl]);

  const assistantMessage = (message, action, messageId) => {
    return {
      message: message,
      name: assistantDisplayName,
      type: "assistant",
      messageId: messageId,
      action: action || "none",
      imageURL: assistantImageUrl,
      statusMessage: undefined,
      // Timestamp is set when the message is first created so it persists in localStorage
      timestamp: Date.now(),
    };
  };

  // ── Voice mode message helpers ──────────────────────────────────
  const updateMessageById = useCallback((messageId, textChunk) => {
    setMessageTexts((prev) => {
      const idx = prev.findIndex((m) => m.messageId === messageId);
      if (idx === -1) return prev;
      const updated = [...prev];
      updated[idx] = { ...updated[idx], message: (updated[idx].message || "") + textChunk };
      return updated;
    });
  }, []);

  const replaceMessageById = useCallback((messageId, text) => {
    setMessageTexts((prev) => {
      const idx = prev.findIndex((m) => m.messageId === messageId);
      if (idx === -1) return prev;
      const updated = [...prev];
      updated[idx] = { ...updated[idx], message: text };
      return updated;
    });
  }, []);

  const finalizeMessageById = useCallback((messageId) => {
    setMessageTexts((prev) => {
      const idx = prev.findIndex((m) => m.messageId === messageId);
      if (idx === -1) return prev;
      const updated = [...prev];
      if (!updated[idx].message?.trim()) {
        updated.splice(idx, 1);
        return updated;
      }
      updated[idx] = { ...updated[idx], action: "response" };
      return updated;
    });
  }, []);

  const addVoiceUserMessage = useCallback((messageId) => {
    const msg = userMessage("", "", messageId);
    setMessageTexts((prev) => [...prev, msg]);
  }, [name]); // eslint-disable-line

  const addVoiceAssistantMessage = useCallback((messageId) => {
    const msg = assistantMessage("", "thinking", messageId);
    setMessageTexts((prev) => [...prev, msg]);
  }, [selectedAssistant]); // eslint-disable-line

  const {
    isVoiceActive,
    isConnecting: voiceConnecting,
    isSpeaking,
    isListening: voiceListening,
    toolStatus: voiceToolStatus,
    startVoice,
    endVoice,
    stopAudio,
  } = useVoiceSession({
    organizationId: currentOrganizationId,
    loanId: currentLoanId,
    uid,
    email,
    name,
    chatHistory: messageTexts,
    addUserMessage: addVoiceUserMessage,
    addAssistantMessage: addVoiceAssistantMessage,
    updateMessageById,
    replaceMessageById,
    finalizeMessageById,
    setActiveStreamingMessageId,
  });

  const updateLatestThinkingMessage = (updater) => {
    setMessageTexts((prevMessages) => {
      const newMessages = [...prevMessages];
      for (let i = newMessages.length - 1; i >= 0; i--) {
        const message = newMessages[i];
        if (message.type === "assistant" && message.action === "thinking") {
          const updatedMessage = updater(message);
          if (!updatedMessage) {
            return prevMessages;
          }
          newMessages[i] = updatedMessage;
          return newMessages;
        }
      }
      return prevMessages;
    });
  };

  const finalizeThinkingMessage = () => {
    updateLatestThinkingMessage((message) => {
      if (message.action === "response" && !message.statusMessage) {
        return null;
      }
      const { statusMessage: _ignored, ...rest } = message;
      return { ...rest, action: "response" };
    });
  };

  /**
   * Convert a raw URL to a clickable markdown link with smart labeling
   * @param {string} url - The URL to convert
   * @returns {string} Markdown link format [label](url)
   */
  const convertUrlToMarkdown = (url) => {
    let label = "Click here";
    
    try {
      const parsed = new URL(url);
      const hostname = parsed.hostname.replace(/^www\./i, "");
      const pathname = parsed.pathname || "";
      
      // Smart labeling for common URL patterns
      if (hostname.includes("help.addy.so")) {
        // Help Center URLs - extract meaningful title from path
        const pathParts = pathname.split("/").filter(Boolean);
        if (pathParts.length >= 2) {
          // Use the last meaningful path segment as label
          const lastSegment = pathParts[pathParts.length - 1]
            .replace(/-/g, " ")
            .replace(/_/g, " ")
            .replace(/%20/g, " ");
          label = lastSegment.length > 3 ? `Help: ${lastSegment}` : "Addy Help Center";
        } else {
          label = "Addy Help Center";
        }
      } else if (hostname.includes("storage.googleapis.com") || 
                 hostname.includes("firebasestorage.googleapis.com")) {
        // Storage URLs (documents) - try to extract filename
        const pathSegments = pathname.split("/").filter(Boolean);
        const lastSegment = pathSegments[pathSegments.length - 1] || "";
        // Decode and extract potential filename
        try {
          const decoded = decodeURIComponent(lastSegment);
          // Check if it looks like a filename (has extension)
          if (decoded.includes(".") && decoded.length > 5) {
            const filename = decoded.split("?")[0]; // Remove query params
            label = filename.length > 40 ? `${filename.slice(0, 37)}...` : filename;
          } else {
            label = "View Document";
          }
        } catch (_) {
          label = "View Document";
        }
      } else if (hostname.includes("addy.so") || hostname.includes("addy.ai") || hostname === "app.addy.com" || hostname === "devmail.addy.com") {
        // Addy platform URLs
        if (pathname.includes("/loan") || pathname.includes("/board")) {
          label = "Open Loan";
        } else if (pathname.includes("/document")) {
          label = "View Document";
        } else {
          label = hostname;
        }
      } else {
        // Generic URL - use hostname
        label = hostname || label;
      }
    } catch (_) {
      // leave default label
    }
    
    // Truncate very long labels
    if (label.length > 45) {
      label = `${label.slice(0, 42)}...`;
    }
    
    return `[${label}](${url})`;
  };

  /**
   * Characters that indicate a URL has ended
   * URLs typically end before whitespace, newlines, or certain punctuation
   */
  const URL_TERMINATORS = /[\s\n\r<>"\[\](){}|\\^`]/;
  
  /**
   * Check if a character is a URL terminator
   * @param {string} char - Single character to check
   * @returns {boolean} True if the character terminates a URL
   */
  const isUrlTerminator = (char) => {
    if (!char) return true;
    return URL_TERMINATORS.test(char);
  };

  /**
   * Format a streaming chunk to handle malformed markdown links and buffer URLs
   * 
   * This function:
   * - Buffers URLs (http:// or https://) until they're complete
   * - Fixes malformed markdown links where URL field contains non-URL text
   * - Preserves valid markdown links
   * - Passes through regular text unchanged
   * 
   * URL buffering prevents partial URLs from being displayed character-by-character,
   * which creates a poor UX. Instead, URLs are collected until a terminator is found.
   * 
   * @param {string} chunk - The incoming text chunk
   * @returns {string} Formatted chunk with complete URLs and malformed links fixed
   */
  const formatChunkWithLinks = (chunk) => {
    if (!chunk) {
      return "";
    }
    
    let result = "";
    let i = 0;
    
    // Combine any existing buffer with the new chunk
    const textToProcess = linkBufferRef.current + chunk;
    linkBufferRef.current = "";
    
    while (i < textToProcess.length) {
      // Check if we're at the start of a URL (http:// or https://)
      const remainingText = textToProcess.slice(i);
      const urlMatch = remainingText.match(/^(https?:\/\/)/i);
      
      if (urlMatch) {
        // Found start of URL - collect the entire URL
        const urlStart = i;
        i += urlMatch[1].length; // Move past http:// or https://
        
        // Continue collecting URL characters until we hit a terminator
        while (i < textToProcess.length && !isUrlTerminator(textToProcess[i])) {
          i++;
        }
        
        const potentialUrl = textToProcess.slice(urlStart, i);
        
        // Check if we've reached the end of the chunk without finding a terminator
        // This means the URL might continue in the next chunk
        if (i >= textToProcess.length) {
          // Buffer the incomplete URL for the next chunk
          linkBufferRef.current = potentialUrl;
        } else {
          // URL is complete - add it to result
          result += potentialUrl;
        }
      } else {
        // Not a URL - just add the character
        result += textToProcess[i];
        i++;
      }
    }
    
    // Fix malformed markdown links where the URL field contains label text instead of actual URL
    // Pattern: [label](non-url text) should become just "label" (plain text)
    // This handles cases where AI generates incorrect markdown links like:
    // [Upload Documents Guide](Help: uploading documents) -> Upload Documents Guide
    // [Help Center](Addy Help Center) -> Help Center
    result = result.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (match, label, url) => {
      const trimmedUrl = url.trim();
      
      // Check if the "url" is actually a URL (starts with http:// or https://)
      if (/^https?:\/\//.test(trimmedUrl)) {
        // Valid URL, return the markdown link as-is
        return match;
      }

      // Short link references (addylink:N) are valid targets — they are
      // resolved to real URLs at render time via the SSE `links` event map.
      if (/^<?addylink:\d+>?$/.test(trimmedUrl)) {
        return match;
      }
      
      // The URL field contains non-URL text (like "Help: uploading documents" or "Addy Help Center")
      // Convert to plain text to avoid broken links
      return label;
    });
    
    return result;
  };

  /**
   * Flush any remaining buffered URL content at end of stream
   * This is called when the stream ends to output any buffered URL that was waiting for a terminator
   * @returns {string} Formatted leftover content (the complete URL)
   */
  const flushLinkBuffer = () => {
    if (!linkBufferRef.current) {
      return "";
    }
    const leftover = linkBufferRef.current;
    linkBufferRef.current = "";
    
    // Return the buffered URL as-is (it's complete now that the stream ended)
    // The URL was being buffered because we hadn't seen a terminator yet,
    // but end-of-stream is also a valid terminator
    return leftover;
  };

  const getFriendlyErrorMessage = (errorPayload = {}) => {
    const normalizedMessage =
      typeof errorPayload?.message === "string"
        ? errorPayload.message.trim()
        : "";

    if (
      errorPayload?.errorType === "REQUEST_TIMEOUT" ||
      isRequestTimeoutMessage(normalizedMessage)
    ) {
      return REQUEST_TIMEOUT_MESSAGE;
    }

    switch (errorPayload?.errorType) {
      case "RATE_LIMIT":
        return "I'm temporarily handling too many requests. Please wait a moment before trying again.";
      case "NETWORK":
        return "I couldn't reach the agent service. Please check your connection and try again.";
      case "HTTP_ERROR":
        return "The agent service returned an unexpected response. Let's try that again.";
      case "AGENT_ERROR":
        return "The agent ran into an issue completing that task.";
      default:
        return (
          normalizedMessage ||
          "Something unexpected happened. Please try again."
        );
    }
  };

  const handleAgentError = (errorPayload = {}) => {
    const normalizedMessage =
      typeof errorPayload?.message === "string"
        ? errorPayload.message.trim()
        : "";
    const normalizedErrorType = (() => {
      if (
        errorPayload?.errorType === "REQUEST_TIMEOUT" ||
        isRequestTimeoutMessage(normalizedMessage)
      ) {
        return "REQUEST_TIMEOUT";
      }
      return errorPayload?.errorType;
    })();

    const friendlyMessage = getFriendlyErrorMessage({
      ...errorPayload,
      errorType: normalizedErrorType,
      message: normalizedMessage,
    });
    linkBufferRef.current = "";

    setMessageTexts((prevMessages) => {
      const newMessages = [...prevMessages];
      let updated = false;

      for (let i = newMessages.length - 1; i >= 0; i--) {
        const currentMessage = newMessages[i];
        if (
          currentMessage.type === "assistant" &&
          currentMessage.action === "thinking"
        ) {
          newMessages[i] = {
            ...currentMessage,
            action: "response",
            statusMessage: undefined,
            message: friendlyMessage,
          };
          updated = true;
          break;
        }
      }

      if (!updated) {
        newMessages.push(
          assistantMessage(friendlyMessage, "response", uuidv4())
        );
      }

      return newMessages;
    });

    currentlyTypingRef.current = false;
    setCurrentlyTyping(false);
    setLoadingDocuments(false);
    setAgentStatus({ type: "", message: "" });
    setHideSkeleton(false);

    if (normalizedErrorType === "RATE_LIMIT") {
      const retrySeconds = errorPayload?.retryAfterSeconds || 60;
      const lockMessage =
        errorPayload?.userMessage ||
        "We're hitting our usage limit. Please wait a few seconds and try again.";
      startInteractionLock(lockMessage, retrySeconds);
    } else if (friendlyMessage) {
      toastify(friendlyMessage, false, true);
    }

    return friendlyMessage;
  };

  const initializeDefaultAssistant = (assistants) => {
    user.getDefaultAssistantDetails().then((result) => {
      // Get the default assistant from backend if available, or else use Addy AI as default
      const effectiveDefaultAssistantId = result?.defaultAssistant;
      const effectiveDefaultAssistant = assistants.find(
        (assistant) => assistant.appID === effectiveDefaultAssistantId
      );
      const personalDefaultAssistant = assistants.find(
        (assistant) => assistant.appID === result?.personalDefaultAssistant
      );
      setDefaultAssistant(personalDefaultAssistant || null);

      if (effectiveDefaultAssistant) {
        // Set default assistant on frontened
        setSelectedAssistant(effectiveDefaultAssistant);
      } else if (assistants.length) {
        // Set default assistant on frontend (Addy AI preferred over first in list)
        const fallback = resolvePreferredFallbackAssistant(assistants);
        setSelectedAssistant(fallback);
      }
    });
  };

  const updateDefaultAssistant = (assistant, e) => {
    // Click event did not come form the item
    if (!e) return;

    const previousDefaultAssistant = defaultAssistant || null;
    const previousSelectedAssistant = selectedAssistant || null;
    const isCurrentPersonalDefault =
      defaultAssistant?.appID && assistant?.appID === defaultAssistant.appID;
    const nextDefaultAssistant = isCurrentPersonalDefault ? null : assistant;

    setDefaultAssistant(nextDefaultAssistant);
    if (nextDefaultAssistant) {
      // Set the selected assistant when choosing a new personal default.
      setSelectedAssistant(nextDefaultAssistant);
    }

    user.setDefaultAssistant(nextDefaultAssistant?.appID || "").then((success) => {
      if (!success) {
        setDefaultAssistant(previousDefaultAssistant);
        setSelectedAssistant(previousSelectedAssistant);
        toastify("Failed to update personal default agent", false);
        return;
      }

      if (!nextDefaultAssistant && assistants.length) {
        initializeDefaultAssistant(assistants);
      }
      initializeOrganizationDefaultAssistant(assistants);
      toastify(
        nextDefaultAssistant
          ? "Personal default agent updated successfully"
          : "Personal default agent cleared successfully",
        true
      );
    });
    // eslint-disable-next-line max-len
    // if (assistant.appID !== "addy-default-assistant-c66e0609-371e-49b2-bb4a-5186526b2a9d") {
    //     // Update the default assistant in the backend
    //     user.setDefaultAssistant(assistant.appID);
    // }
  };

  const initializeOrganizationDefaultAssistant = (assistants) => {
    Promise.all([
      user.getOrganizationDefaultAssistant(),
      user.getDefaultAssistantDetails(),
    ]).then(([result, userDefault]) => {
      setCanManageOrganizationDefaultAssistant(result?.canManage === true);
      const organizationDefaultAssistant = assistants.find(
        (assistant) => assistant.appID === result?.defaultAssistant
      );
      setOrganizationDefaultAssistant(organizationDefaultAssistant || null);
      const resolvedDefaultAssistant =
        userDefault?.defaultAssistantSource !== "fallback"
          ? assistants.find((assistant) => assistant.appID === userDefault?.defaultAssistant)
          : null;
      setV2DefaultAssistant(resolvedDefaultAssistant || organizationDefaultAssistant || null);
      setIsOrganizationDefaultLoaded(true);
    });
  };

  const updateOrganizationDefaultAssistant = async (assistant) => {
    const appID = assistant?.appID || "";
    const success = await user.setOrganizationDefaultAssistant(appID);
    if (success) {
      setOrganizationDefaultAssistant(assistant || null);
      // A role or personal default still wins over the organization's, so re-resolve it.
      initializeOrganizationDefaultAssistant(assistants);
      if (assistant && !defaultAssistant) {
        setSelectedAssistant(assistant);
      }
      toastify(
        assistant
          ? "Organization default agent updated successfully"
          : "Organization default agent cleared successfully",
        true
      );
      return true;
    }

    toastify("Failed to update organization default agent", false);
    return false;
  };

  const getDateFormat = () => {
    const date = Date.now();
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    return new Date(date).toLocaleDateString("en-US", options);
  };

  const handlePostMessage = (event) => {
    const origin = event.origin || event.originalEvent.origin;

    const data = event.data;
    if (data && data.key) {
      const action = data.key;
      const value = data.value;
      switch (action) {
        case "emailThread":
          setEmailThread(value);
          break;
        case "document":
          setDocuments(value);
          break;
        case "documentToRequest":
          generateRequestEmailForDocument = true;
          if (value && value.category) {
            const prompt =
              "Write an email to " +
              (value?.recipientInfo
                ? value?.recipientInfo
                : "{{recipient_Name}}") +
              " requesting the following missing loan documents: -.-." +
              value.category;
            // Trigger the chat with the document request prompt
            onSendButtonClick(prompt, "", false, []);
          }
          break;
        case "askAddyQuery":
          if (AskAddyV2.isEnabled()) {
            const askAddyQuery = !value?.preparing && normalizeExternalAskAddyQueryPayload(value);
            if (askAddyQuery) {
              setV2AskAddyQuery(askAddyQuery);
              setV2View("chat");
            }
            break;
          }
          if (value?.preparing) {
            updatePreparingAskAddyQuery({
              query: value.displayQuery || value.query,
              status: value.preparingStatus || "Preparing Ask Addy...",
            });
            break;
          }

          {
            const askAddyQuery = normalizeExternalAskAddyQueryPayload(value);
            if (!askAddyQuery) {
              break;
            }

            queueOrStartExternalAskAddyQuery(askAddyQuery);
          }
          break;
        case "attachmentListBase64":
          // Handle attachment data if needed
          if (value && value.length) {
            // Convert attachments to files format expected by Chat component
            const attachmentFiles = value.map((attachment) => ({
              name: attachment.name || "attachment",
              textContent: attachment.textContent || attachment.content || "",
            }));
            setFiles((prev) => [...prev, ...attachmentFiles]);
          }
          break;
        case "openChatWithDocs":
          // The web app's loan page "Chat with your docs" opens this same
          // picker in a new chat, like questions asked from the loan page.
          askAddyNewChatPendingRef.current = true;
          onCreateNewChatClick();
          openChatWithDocs();
          break;
        case "selectedText":
          // If in iframe mode and user selects text, optionally switch back to chat
          if (contentMode === 'iframe') {
            // Option: Switch back to chat automatically when text is selected
            // Uncomment the lines below to enable auto-switch:
            // setContentMode('chat');
            // setIframeUrl('');
            // setIframeTitle('');
          }
          // Handle selected text in chat mode (if needed in the future)
          break;
        case "redirectToLoanBoard":
            const url = value?.currentURL;
            console.log("[BACK-TO-LOAN] Chat.js received 'redirectToLoanBoard' message:", { url, valueRaw: value });
            if (url && typeof url === 'string') {
                console.log("[BACK-TO-LOAN] Chat.js calling checkAndRedirectToLoanBoard with:", url);
                checkAndRedirectToLoanBoard(url);
            } else {
                console.warn("[BACK-TO-LOAN] Chat.js: url is missing or not a string. Ignoring.", { url, typeofUrl: typeof url });
            }
            break;
        case "updateLoanContext":
            // Update loan context when parent page navigates to a different loan
            const contextData = value;
            if (contextData) {
              
              // Check if loan context is changing
              const isLoanChanging = contextData.loanId !== undefined && contextData.loanId !== currentLoanId;
              
              if (isLoanChanging) {
                
                // Save current chat before switching (if we have messages)
                if (messageTexts.length > 0) {
                  saveCurrentChatLocally();
                }
                
                // Update the loan context state
                setCurrentLoanId(contextData.loanId);
                
                // Switch to the chat for the new loan, or start fresh when leaving loan context
                if (contextData.loanId) {
                  restoreLoanChat(contextData.loanId);
                } else {
                  onCreateNewChatClick();
                }
              } else if (contextData.loanId !== undefined) {
                // Same loan, just update state if needed
                setCurrentLoanId(contextData.loanId);
              }
              
              // Handle organization context updates
              if (contextData.organizationId !== undefined) {
                setCurrentOrganizationId(contextData.organizationId);
                // Also update OrganizationContext
                if (setSelectedOrganizationId && contextData.organizationId) {
                  setSelectedOrganizationId(contextData.organizationId);
                }
              }

              // Keep member role and NewFi organization context in sync with
              // the parent client as the user navigates between loans.
              if (contextData.memberRole !== undefined) {
                setCurrentMemberRole(contextData.memberRole || null);
              }
              if (contextData.isNewfi !== undefined) {
                setCurrentIsNewfi(!!contextData.isNewfi);
              }
            }
            break;
        case "scopedChat": {
          // The parent page moved to another pinned conversation, such as
          // another Scenario Center scenario, while the sidebar stayed open.
          const scopedChatId = readScopedChatId(value?.chatId);
          // Null when the page let go of it (the user left the scenario).
          setV2ScopedChatId(scopedChatId);
          if (scopedChatId) {
            restoreScopedChat(scopedChatId);
          }
          break;
        }
        case "openThread": {
          // The web app opened a notification about one of the person's conversations while the
          // sidebar stayed open. Only from the page hosting this sidebar, and only their own.
          // Checked against the open loan below: this listener's closure holds stale state.
          if (event.source === window.parent && typeof value?.threadId === "string") {
            setV2RequestedThreadId({ threadId: value.threadId, at: Date.now() });
          }
          break;
        }
        case "openApps": {
          // An app's sign-in sent the person back to the web app while the sidebar stayed open.
          const landing = event.source === window.parent ? readConnectedAppLanding(value) : null;
          if (landing && AskAddyV2.isEnabled()) {
            setV2AppsLanding(landing);
            setIsDrawerOpen(false);
            setV2View("apps");
          }
          break;
        }
        case "scenarioQuestions":
          // Only the page hosting this sidebar owns the follow-ups, and only it hears the answers.
          if (event.source === window.parent) {
            setV2ScenarioQuestions(readScenarioQuestions(value, origin));
          }
          break;
        case "syncBrandColors":
          if (value && typeof value === "object") {
            applyQueryBrandCssVariables(value);
          }
          break;
        case "side-mode-change":
            // Forward to Chrome extension to hide/show close icon when in side mode
            // console.log("[Chat] 📩 Received side-mode-change:", value);
            // console.log("[Chat] 📩 isSideMode:", value, "| Will hide close icon:", value);
            // Use window.top to reach the topmost window (Chrome extension) in case of nested iframes
            if (window.top && window.top !== window) {
                // console.log("[Chat] 📤 Forwarding to TOP window: hide-extension-close-icon =", value);
                window.top.postMessage({ key: "hide-extension-close-icon", value: value }, "*");
            } else if (window.parent && window.parent !== window) {
                // console.log("[Chat] 📤 Forwarding to parent: hide-extension-close-icon =", value);
                window.parent.postMessage({ key: "hide-extension-close-icon", value: value }, "*");
            } else {
                // console.log("[Chat] ⚠️ No parent/top window to forward message to");
            }
            break;
        case GUIDE_PROGRESS_MESSAGE_KEY: {
          const progressText = formatGuideProgressMessage(value);
          if (!progressText) {
            break;
          }
          const existingId =
            value?.status === "started" ? null : guideStatusMessageIdRef.current;
          if (existingId) {
            setMessageTexts((prev) =>
              prev.map((msg) =>
                msg.messageId === existingId
                  ? { ...msg, message: progressText, action: "response" }
                  : msg
              )
            );
          } else {
            const statusId = uuidv4();
            guideStatusMessageIdRef.current = statusId;
            setMessageTexts((prev) => [
              ...prev,
              assistantMessage(progressText, "response", statusId),
            ]);
          }
          if (value?.status === "done" || value?.status === "stopped" || value?.status === "failed") {
            guideStatusMessageIdRef.current = null;
          }
          break;
        }
        case "browser-task-delta": {
          const deltaText = value?.text || "";
          const targetMsgId = browserTaskMessageIdRef.current;
          if (targetMsgId && deltaText) {
            const isFirst = !browserTaskFirstDeltaRef.current;
            if (isFirst) browserTaskFirstDeltaRef.current = true;
            setMessageTexts((prev) =>
              prev.map((msg) => {
                if (msg.messageId !== targetMsgId) return msg;
                return {
                  ...msg,
                  message: isFirst ? deltaText : (msg.message || "") + deltaText,
                  action: "response",
                };
              })
            );
          }
          break;
        }
        case "browser-task-complete": {
          const targetId = browserTaskMessageIdRef.current;
          if (targetId) {
            setMessageTexts((prev) =>
              prev.map((msg) => {
                if (msg.messageId !== targetId) return msg;
                const finalText = value?.message;
                return {
                  ...msg,
                  message: finalText && !msg.message ? finalText : msg.message,
                  action: "response",
                };
              })
            );
          }
          browserTaskMessageIdRef.current = null;
          browserTaskFirstDeltaRef.current = false;
          currentlyTypingRef.current = false;
          setCurrentlyTyping(false);
          break;
        }
        case "browser-task-error": {
          const errorReason = value?.reason || "Browser task failed";
          const targetErrId = browserTaskMessageIdRef.current;
          if (targetErrId) {
            setMessageTexts((prev) =>
              prev.map((msg) => {
                if (msg.messageId !== targetErrId) return msg;
                return {
                  ...msg,
                  message: `Browser task failed: ${errorReason}`,
                  action: "response",
                };
              })
            );
          } else {
            const errorMsgId = uuidv4();
            const errorMsg = assistantMessage(
              `Browser task failed: ${errorReason}`,
              "response",
              errorMsgId
            );
            setMessageTexts((prev) => [...prev, errorMsg]);
          }
          browserTaskMessageIdRef.current = null;
          browserTaskFirstDeltaRef.current = false;
          currentlyTypingRef.current = false;
          setCurrentlyTyping(false);
          break;
        }
        default:
          break;
      }
    }
  };

  const windowListenForPostMessage = () => {
    window.addEventListener("message", handlePostMessage);
    if (parent) {
      parent.postMessage("addy-iframe-loaded", "*");
    }
  };

  const handleJoyrideCallback = (data) => {
    // eslint-disable-next-line no-unused-vars
    const { status, type } = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Need to set our running state to false
      // so we can restart if we click start again.
      setTooltipRun(false);
    }
  };

  const toastify = (message, success, yellowWarning = false) => {
    if (success) {
      toast.success(message, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      if (yellowWarning) {
        toast.warning(message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        toast.error(message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }
  };

  const onCreateNewChatClick = () => {
    // End voice session if active
    if (voiceMode) { endVoice(); setVoiceMode(false); }
    if (AskAddyV2.isEnabled()) {
      // v2 keeps conversations server-side: a new chat is a new thread for this loan.
      const threadId = newThreadId({
        organizationId: currentOrganizationId || selectedOrganizationId || organizationId,
        userId: uid,
        loanId: currentLoanId || loanId || "",
        scenarioId: v2ScenarioId,
      });
      setV2ThreadId(threadId);
      setV2View("chat");
      setShowChatHistory(false);
      setShowDropdown(false);
      return threadId;
    }
    // Create a new chat without associating it with the current loan context
    // This allows users to start a fresh chat even when viewing a loan
    const newChatId = uuidv4();
    
    setChatID(newChatId);
    setMessageTexts([]);
    resetFollowUps();
    setChatName(clientHostname ? clientHostname.replace("www.", "") : getDateFormat());
    setCurrentView("select-assistant");
    setShowChatHistory(false);
    setShowDropdown(false);
    setSelectedChatHistory(null);
    
    // Note: We intentionally do NOT save a loan-to-chat mapping here
    // This new chat is independent of any loan context
    return newChatId;
  };

  const onNewChatButtonClick = () => {
    const stoppedStream = abortActiveStream();
    abortLocalBrowserRun();

    // The aborted stream unwinds after the chat switches, so record the
    // cancellation on the chat being left, like the Stop button does.
    if (stoppedStream) {
      saveCurrentChatLocally(markLatestResponseCanceled(messageTexts));
    }

    onCreateNewChatClick();
  };

  const autoRestoreLastChat = () => {
    const lastChatId = localStorage.getItem("addy-ai-sidebar-last-chat-id");
    if (!lastChatId || lastChatId === CHAT_ID) return;

    const lastChatData = JSON.parse(localStorage.getItem(lastChatId));
    if (
      !lastChatData ||
      !lastChatData.messages ||
      lastChatData.messages.length === 0
    ) {
      return; // No valid chat to restore
    }

    // Restore the last chat
    onChatTitleClickInChatHistoryDropdown(lastChatId);
  };

  /**
   * Get the chat ID associated with a specific loan, or create a new one if none exists
   * @param {string} loanIdToFind - The loan ID to look up
   * @returns {string|null} The chat ID for this loan, or null if creating new
   */
  const getOrCreateLoanChat = (loanIdToFind) => {
    if (!loanIdToFind) return null;
    
    const loanChats = JSON.parse(localStorage.getItem(LOAN_CHATS_KEY)) || {};
    
    if (loanChats[loanIdToFind]) {
      return loanChats[loanIdToFind]; // Return existing chatId
    }
    
    // No existing chat for this loan - will create new one
    return null;
  };

  /**
   * Restore or create a chat for a specific loan
   * If a chat exists for this loan, restore it. Otherwise, create a new fresh chat for this loan.
   * @param {string} loanIdToRestore - The loan ID to restore chat for
   */
  const restoreLoanChat = (loanIdToRestore) => {
    if (!loanIdToRestore) {
      return;
    }

    const existingChatId = getOrCreateLoanChat(loanIdToRestore);
    
    if (existingChatId) {
      // There's an existing chat ID for this loan
      const chatData = JSON.parse(localStorage.getItem(existingChatId));
      
      if (chatData && chatData.messages && chatData.messages.length > 0) {
        // Chat has messages - restore it
        if (existingChatId === CHAT_ID) {
          // Already on this chat, just make sure messages are displayed
          setMessageTexts(chatData.messages);
          setChatName(chatData.chatName || "Chat");
          setCurrentView("chat");
          return;
        }
        onChatTitleClickInChatHistoryDropdown(existingChatId);
        return;
      }
    }
    
    // No existing chat for this loan - create a NEW fresh chat
    const newChatId = uuidv4();
    
    // Update state to use the new chat
    setChatID(newChatId);
    setMessageTexts([]);
    setChatName(clientHostname ? clientHostname.replace("www.", "") : getDateFormat());
    setCurrentView("select-assistant");
    setSelectedChatHistory(null);
    
    // Save the loan-to-chat mapping immediately
    saveLoanChatMapping(loanIdToRestore, newChatId);
  };

  /**
   * Opens the conversation the parent page pinned, from the user's saved
   * chats, or starts it fresh under that id so its first message saves there.
   * @param {string} scopedChatId
   */
  const restoreScopedChat = async (scopedChatId) => {
    if (scopedChatId === CHAT_ID) {
      return;
    }

    if (messageTexts.length > 0) {
      saveCurrentChatLocally();
    }

    const savedChat = uid
      ? await SidebarChatHistoryModel.getChat(uid, scopedChatId)
      : null;
    const cachedChat = JSON.parse(localStorage.getItem(scopedChatId));
    if (savedChat?.messages?.length > 0 || cachedChat?.messages?.length > 0) {
      onChatTitleClickInChatHistoryDropdown(scopedChatId);
      return;
    }

    setChatID(scopedChatId);
    setMessageTexts([]);
    setChatName(clientHostname ? clientHostname.replace("www.", "") : getDateFormat());
    setCurrentView("select-assistant");
    setSelectedChatHistory(null);
  };

  /**
   * Save the mapping between a loan ID and a chat ID
   * @param {string} loanIdToSave - The loan ID
   * @param {string} chatIdToSave - The chat ID to associate with this loan
   */
  const saveLoanChatMapping = (loanIdToSave, chatIdToSave) => {
    if (!loanIdToSave || !chatIdToSave) return;
    
    const loanChats = JSON.parse(localStorage.getItem(LOAN_CHATS_KEY)) || {};
    loanChats[loanIdToSave] = chatIdToSave;
    localStorage.setItem(LOAN_CHATS_KEY, JSON.stringify(loanChats));
  };

  const applyChatToView = (chatMessages, chatId) => {
    // If Ask Addy just forced a brand-new conversation, ignore any
    // auto-restore that was already in flight when the request arrived —
    // it would otherwise overwrite the freshly-created chat id.
    if (askAddyNewChatPendingRef.current) return;
    // End voice session if active
    if (voiceMode) { endVoice(); setVoiceMode(false); }
    const chatMessageTexts = chatMessages.messages;
    if (!chatMessageTexts) return;
    setChatID(chatId);
    setSelectedChatHistory(chatMessages);
    for (let i = 0; i < chatMessageTexts.length; i++) {
      if (
        chatMessageTexts[i].type === "assistant" &&
        chatMessageTexts[i].message.length > 0
      ) {
        chatMessageTexts[i].action = "response";
      }
    }
    setMessageTexts(chatMessageTexts);
    setChatName(chatMessages.chatName ? chatMessages.chatName : "Chat");
    const assistant = assistants.find(
      (a) => a.appID === (chatMessages.appID || chatMessages.appId)
    );
    setSelectedAssistant(assistant);
    setCurrentView("chat");
    setShowChatHistory(false);
    setShowDropdown(false);
    if (chatHistoryRef.current) {
      chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
    }
  };

  const onChatTitleClickInChatHistoryDropdown = async (chatID) => {
    if (chatID === CHAT_ID) {
      setCurrentView("chat");
      setShowChatHistory(false);
      setShowDropdown(false);
      return;
    }
    // Try backend first (DB), then fall back to localStorage (legacy)
    if (uid) {
      const dbChat = await SidebarChatHistoryModel.getChat(uid, chatID);
      if (dbChat && dbChat.messages && dbChat.messages.length > 0) {
        const chatMessages = {
          chatID: dbChat.chatId,
          messages: dbChat.messages,
          chatName: dbChat.chatName,
          appID: dbChat.appID,
          publicId: dbChat.publicId,
          loanId: dbChat.loanId,
        };
        applyChatToView(chatMessages, chatID);
        // Lazy migration: cache in localStorage for offline resilience
        const cached = { ...chatMessages, chatID };
        localStorage.setItem(chatID, JSON.stringify(cached));
        return;
      }
    }
    const chatMessages = JSON.parse(localStorage.getItem(chatID));
    if (chatMessages && chatMessages.messages) {
      applyChatToView(chatMessages, chatID);
      // Lazy migration: save legacy localStorage chat to DB for cross-device sync
      if (uid) {
        const savedChats =
          JSON.parse(localStorage.getItem("addy-ai-sidebar-chats")) || {};
        const meta = savedChats[chatID] || {};
        const chatDataForBackend = {
          ...chatMessages,
          clientHostname: meta.clientHostname || clientHostname,
          dateStarted: meta.dateStarted || Date.now(),
          lastActive: meta.lastActive || Date.now(),
        };
        SidebarChatHistoryModel.saveChat(uid, chatDataForBackend).catch(
          () => {}
        );
      }
    }
  };

  /**
   * Handles a chat rename triggered from the sidebar history dropdown.
   * If the renamed chat is the currently active one, also updates the
   * in-memory chatName state so the header reflects the new name immediately.
   */
  const onRenameChatInHistory = (chatID, newName) => {
    if (chatID === CHAT_ID) {
      setChatName(newName);
    }
  };


  // Debug: Log render state
  // console.log('[Chat] Rendering with state:', {
  //   contentMode,
  //   showLoginPrompt,
  //   isCheckingAuth,
  //   isAuthenticated,
  //   iframeUrl: iframeUrl?.substring(0, 50) + '...',
  // });

  return (
    <Box className="chat-page-parent">
      
      {/* IframeContainer Mode - Shows external content in nested iframe */}
      {/* key forces React to completely remount when URL or key changes */}
      {contentMode === 'iframe' && (
        <IframeContainer
          key={`${iframeUrl}-${iframeKey}`}
          url={iframeUrl}
          title={iframeTitle}
        />
      )}

      {/* Chat Mode - Shows normal chat UI */}
      {contentMode === 'chat' && (
        <>
      {/* Drawer */}
      <Drawer
        variant={isWideScreen || isV2Rail ? "persistent" : "temporary"}
        open={hasV2Rail ? drawerWidth > 0 : internalNavigation.isOpen || (isV2Rail && internalNavigation.isEnabled)}
        onClose={hasV2Rail ? closeV2Panel : toggleDrawer}
        style={{
          display:
            overlayMode || !internalNavigation.isEnabled ? "none" : "block",
        }}
        // Match the drawer's fixed header row (ChatHistoryDropdown .frameGroup),
        // which paints --surface-card; MUI's dark paper is a lighter shade.
        PaperProps={{
          sx: {
            backgroundColor: "var(--surface-card)",
            borderColor: "var(--border-subtle)",
            ...(v2Panel ? { boxShadow: "0 12px 32px -12px rgba(13, 13, 37, 0.28)" } : {}),
          },
        }}
      >
        <Box width={drawerWidth} maxWidth="100vw" role="presentation">
          <div className={hasV2Rail ? `aav2-shell${v2Panel ? " aav2-shell--over" : ""}` : undefined} style={hasV2Rail ? { "--aav2-panel-width": `${V2_PANEL_WIDTH}px` } : undefined}>
            {hasV2Rail && (
              <V2ChatsRail
                activePanel={v2Panel}
                onTogglePanel={toggleV2Panel}
                onToggleChats={toggleV2Chats}
                onNewChat={() => {
                  onNewChatButtonClick();
                  if (closesV2PanelOnPick) closeV2Panel();
                }}
                onSearch={() => {
                  closeV2Panel();
                  setIsV2SearchOpen(true);
                }}
                isAppsOpen={v2View === "apps"}
                onOpenApps={toggleV2Apps}
                assistant={v2Assistant}
                assistantDot={v2StatusTone}
                onOpenProfile={() => toggleV2View("autopilot", "profile")}
                clientChat={v2ClientChat}
                onOpenClientChat={() => {
                  v2ClientChat.open();
                  if (!isWideScreen) setIsDrawerOpen(false);
                }}
              />
            )}
            {v2Panel === "profile" && (
              <div className="aav2-shell-panel">
                {renderV2Profile({ isPanel: true, side: "left" })}
              </div>
            )}
            {(!hasV2Rail || v2Panel === "chats") && (
              <div className={hasV2Rail ? "aav2-shell-panel" : undefined}>
                <ChatHistoryDropdown
                  displayPosition="bottom"
                  referencedElementId={chatHistoryReferencedElementId}
                  onCreateNewChatClick={() => {
                    onNewChatButtonClick();
                    if (AskAddyV2.isEnabled() && !isWideScreen) setIsDrawerOpen(false);
                  }}
                  onChatTitleClick={onChatTitleClickInChatHistoryDropdown}
                  onRenameChat={onRenameChatInHistory}
                  ref={chatNameDropdownRef}
                  toggleDrawer={hasV2Rail ? undefined : toggleDrawer}
                  uid={uid}
                  organizationId={currentOrganizationId || organizationId}
                  isDrawerOpen={isDrawerOpen}
                  v2LoanId={currentLoanId || loanId || ""}
                  v2ScenarioId={v2ScenarioId}
                  v2ThreadId={v2ThreadId}
                  onV2ThreadClick={(id) => {
                    setV2ThreadId(id);
                    setV2OpenCount((count) => count + 1);
                    setV2View("chat");
                    if (closesV2PanelOnPick) setIsDrawerOpen(false);
                  }}
                  // The rail has Apps & MCP of its own. Elsewhere the page opens over the chat, with a back button.
                  onOpenV2Apps={
                    hasV2Rail
                      ? undefined
                      : () => {
                          setV2View("apps");
                          if (!isWideScreen) setIsDrawerOpen(false);
                        }
                  }
                  // The rail has its own client chat and the assistant at its foot.
                  v2Assistant={v2Assistant}
                  onOpenV2Profile={
                    hasV2Rail
                      ? undefined
                      : () => {
                          setV2View("autopilot");
                          if (!hasV2Rail && !isWideScreen) setIsDrawerOpen(false);
                        }
                  }
                  v2ClientChat={hasV2Rail ? undefined : v2ClientChat}
                  onOpenV2ClientChat={() => {
                    v2ClientChat.open();
                    if (closesV2PanelOnPick) setIsDrawerOpen(false);
                  }}
                  chatListVersion={chatListVersion}
                />
              </div>
            )}
          </div>
        </Box>
      </Drawer>

      {hasV2Rail && isV2SearchOpen && (
        <V2ChatSearch
          // Another user's sign-in searches their own chats.
          key={uid}
          uid={uid}
          organizationId={currentOrganizationId || organizationId}
          loanId={currentLoanId || loanId || ""}
          scenarioId={v2ScenarioId}
          activeThreadId={v2ThreadId}
          railWidth={V2_RAIL_WIDTH}
          onThreadClick={(id) => {
            setV2ThreadId(id);
            setV2OpenCount((count) => count + 1);
            setV2View("chat");
          }}
          onClose={() => setIsV2SearchOpen(false)}
        />
      )}
      {hasV2Scrim && <div className="aav2-scrim" style={{ left: V2_RAIL_WIDTH }} aria-hidden="true" onClick={closeV2Panel} />}

      {/*Page Content*/}

      <div
        className="chat"
        style={{
          flexGrow: 1,
          // Ask Addy v2's header is taller: the assistant sits in the middle of it.
          paddingTop: AskAddyV2.isEnabled() ? "72px" : "25px",
          marginLeft:
            overlayMode || !(internalNavigation.shouldOffsetContent || (isV2Rail && internalNavigation.isEnabled))
              ? "0"
              : `${hasV2Rail ? V2_RAIL_WIDTH : drawerWidth}px`,
          background: overlayMode ? "transparent" : "var(--surface-card)",
        }}
      >
        <Joyride
          callback={handleJoyrideCallback}
          continuous
          run={tooltipRun}
          scrollToFirstStep
          showProgress
          steps={tooltipSteps}
          styles={{
            options: {
              // this styles the overlay color
              overlayColor: "rgba(0, 0, 0, 0.4)",
              primaryColor: resolvedJoyridePrimaryColor,
            },
          }}
        />

        {AskAddyV2.isEnabled() ? (
          // Local testing: Ask Addy v2, on assistant-ui, replaces the message list and composer.
          <div
            style={{
              height: "100%",
              width: "100%",
              boxSizing: "border-box",
              paddingRight: isV2ProfileBeside ? "var(--lendy-panel-width, 380px)" : 0,
            }}
          >
            {v2View === "autopilot" && !hasV2Rail && renderV2Profile({ isPanel: isWideSidebar, side: "right" })}
            {v2View === "apps" && renderV2Apps({ backLabel: "Back to chat", onBack: hasV2Rail ? undefined : () => setV2View("chat") })}
            {v2View === "apps" || (!hasV2Rail && v2View === "autopilot" && !isWideSidebar) ? null : (
            <AskAddyV2Chat
              organizationId={currentOrganizationId || selectedOrganizationId || organizationId}
              userId={uid}
              userName={name}
              loanId={currentLoanId || loanId || ""}
              scenarioId={v2ScenarioId}
              threadId={v2ThreadId}
              agentId={v2AgentAppId}
              assistantName={v2Assistant?.name}
              assistantImageUrl={v2Assistant?.imageUrl}
              isAgentMenuOpen={Boolean(agentMenuAnchor)}
              onOpenAgentMenu={toggleAgentMenu}
              onEmptyChange={setIsV2NewChat}
              browserUse={browserUseForV2}
              onRunChange={setV2Run}
              pendingQuestion={v2AskAddyQuery?.startNewConversation ? null : v2AskAddyQuery}
              onPendingQuestionSent={() => setV2AskAddyQuery(null)}
              scenarioQuestions={v2ScenarioQuestions}
              openCount={v2OpenCount}
            />
            )}
          </div>
        ) : (
        <section
          ref={chatHistoryRef}
          onScroll={handleChatScroll}
          className={`top addy-custom-scroll ${
            overlayMode ? "overlay-mode-chat-history" : ""
          }`}
          style={{
            position: "relative",
          }}
        >
          {currentView === "chat" && messageTexts?.length > 0 && (
            <div
              style={{
                position: "absolute",
                top: 40,
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  borderRadius: 20,
                  background: overlayMode ? "transparent" : "var(--surface-app)",
                  padding: "5px 15px",
                  zIndex: 3,
                }}
              >
                <EmailActionNavigationBreadCrumbs
                  overlayMode={overlayMode}
                  currentEmailAction={"Chat"}
                  breadCrumbsHomeClick={() => {
                    setMessageTexts([]);
                  }}
                />
              </div>
            </div>
          )}

          <div
            className={overlayMode ? "overlay-mode-chat-history" : ""}
            style={
              overlayMode
                ? {
                    paddingBottom: 160,
                  }
                : {}
            }
          >
            <div
              id="chat-history-parent"
              className={`chat-message`}
              style={
                overlayMode
                  ? {
                      paddingTop: 5,
                      overflow: "hidden",
                    }
                  : {
                      paddingTop: 40,
                    }
              }
            >
              {overlayMode && messageTexts.length > 0 && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "22px",
                    paddingRight: "6px",
                  }}
                >
                  <div>
                    {/* New chat button */}
                    {messageTexts.length > 0 && <div className="new-chat-button" onClick={() => {
                      onNewChatButtonClick();
                    }}>
                      New chat &nbsp;&nbsp;+
                    </div>}
                  </div>

                  <div
                    style={{
                      background: "var(--surface-card)",
                      padding: "10px",
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={requestSidebarClose}
                    >
                      <CloseIcon
                        sx={{
                          fontSize: "14px",
                        }}
                      />
                    </IconButton>
                  </div>
                </div>
              )}
              {currentView == "chat" && (
                <div
                  id="addy-chat-history"
                  className="text-field"
                  style={
                    overlayMode
                      ? {
                          height: "100%",
                          paddingLeft: "0px",
                          paddingRight: "0px",
                          paddingBottom: "50px",
                        }
                      : {}
                  }
                >
                  {messageTexts.map((item, index) => {
                    return (
                      <MessageText
                        overlayMode={overlayMode}
                        usedFiles={usedFiles.filter(
                          (file) => file.messageId === item.messageId
                        )}
                        documents={
                          documentsContext.filter(
                            (doc) => doc.messageId === index
                          )[0]?.documents
                        }
                        documentsCompared={
                          documentsComparedContext.filter(
                            (doc) => doc.messageId === index
                          )[0]?.documentsCompared
                        }
                        pricingResults={
                          pricingResultsContext.filter(
                            (pricing) => pricing.messageId === index
                          )[0]?.pricingResults
                        }
                        loadingDocuments={loadingDocuments}
                        message={item}
                        onOpenCitation={handleOpenCitation}
                        previousUserMessage={
                          item.type === "user"
                            ? ""
                            : messageTexts
                                .slice(0, index)
                                .reverse()
                                .find((prior) => prior.type === "user")?.message || ""
                        }
                        linkMap={linkMap}
                        key={item.messageId || uuidv4()}
                        clientID={clientID}
                        isFirstMessage={index == 0}
                        isLastMessage={index == messageTexts.length - 1}
                        thinkingStatements={
                          compareMode
                            ? compareGuidelinesLoadingStatements
                            : null
                        }
                        compareMode={compareMode}
                        status={
                          index === messageTexts.length - 1 ? agentStatus : null
                        }
                        hideSkeleton={index === messageTexts.length - 1 && hideSkeleton}
                        showTypingCursor={
                          item.type === "assistant" &&
                          item.messageId === activeStreamingMessageId
                        }
                        organizationId={currentOrganizationId || organizationId}
                        loanId={currentLoanId || loanId}
                        organizationLogoUrl={organizationLogoUrl}
                      />
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </section>
        )}

        {!AskAddyV2.isEnabled() && hasNewContentBelow && !isUserAtBottom && (
          <button
            type="button"
            className="new-content-below-button"
            onClick={() => scrollChatToBottom()}
            aria-label="Scroll to new chat content"
          >
            <KeyboardArrowDown sx={{ fontSize: 16 }} />
            <span>New content below</span>
          </button>
        )}

        {/* Close button for overlay mode when 0 messages.
            Hidden while chat-with-docs is open — that flow renders its own
            identical close control and owns position reporting until closed. */}
        {overlayMode && messageTexts.length === 0 && !showDocsFlow && (
          <div
            id="addy-chat-close-button"
            ref={closeButtonRef}
            style={{
              position: "absolute",
              top: "20px",
            //   bottom: "80%",
              right: "20px",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                background: "var(--surface-card)",
                padding: "10px",
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              <IconButton
                size="small"
                onClick={requestSidebarClose}
              >
                <CloseIcon
                  sx={{
                    fontSize: "14px",
                  }}
                />
              </IconButton>
            </div>
          </div>
        )}
        
        {/* Full screen and Close for embedded Addy app domains (except /research pages); the web app draws no buttons of its own. */}
        {!overlayMode && GlobalVariables.isAddyAppHostname(clientHostname) &&
         (!currentURL || !currentURL.includes('/research')) && !showDocsFlow && (
          <WindowControls
            ref={closeButtonRef}
            isFullScreen={sidebarWindow.isFullScreen}
            canToggleFullScreen={sidebarWindow.canToggleFullScreen}
            onToggleFullScreen={sidebarWindow.toggleFullScreen}
            onClose={requestSidebarClose}
          />
        )}

        {isChatWithDocsEnabled && (
          <ChatWithDocsFlow
            isOpen={showDocsFlow}
            uid={uid}
            organizationId={
              currentOrganizationId || selectedOrganizationId || organizationId
            }
            initialLoanId={currentLoanId || null}
            initialLoanName={null}
            onClose={handleDocsFlowClose}
            onConfirm={handleDocsFlowConfirm}
            overlayMode={overlayMode}
            preselectedDocIdsByLoan={getChatDocIdsByLoan(currentChatDocs)}
          />
        )}

        {!AskAddyV2.isEnabled() && (
        <ButtonInstance
          overlayMode={overlayMode}
          startRecording={startRecording}
          stopRecording={stopRecording}
          recording={recording}
          toastify={toastify}
          files={files}
          setFiles={setFiles}
          usedFiles={usedFiles}
          setUsedFiles={setUsedFiles}
          chatDocs={isChatWithDocsEnabled ? currentChatDocs : []}
          onRemoveChatDoc={handleRemoveChatDoc}
          alignInputBottom={alignInputBottom || false}
          hideHotTipContainer={hideHotTip || true}
          data={data}
          clientID={clientID}
          maxCharsPerLine={30}
          uid={uid}
          currentlyTyping={currentlyTyping}
          clarificationPrompt={clarificationPrompt}
          onClarificationChoice={(value, option) => {
            const label = option?.label || value || "";
            const isConfirm =
              /^(yes|confirm|proceed|send|approve|ok|sure)/i.test(label);
            if (clarificationPrompt?.kind === "local-browser-confirmation") {
              setMessageTexts((previousMessages) => [
                ...previousMessages,
                userMessage(
                  isConfirm ? "Confirm and continue" : "Cancel",
                  "",
                  uuidv4()
                ),
              ]);
              localBrowserConfirmationRef.current?.respond(isConfirm);
              return;
            }
            onSendButtonClick(value, "", false, []);
          }}
          hideSuggestedPrompts={messageTexts.length > 0 || mode === "documentPortal"}
          followUpSuggestions={followUpSuggestions}
          isGeneratingFollowUps={isGeneratingFollowUps}
          mode={mode || ""}
          numberOfMessagesInChat={messageTexts.length}
          loanRoleSuggestions={getLoanRoleSuggestions({
            memberRole: currentMemberRole,
            loanId: currentLoanId,
            isNewfi: currentIsNewfi,
          })}
          onClick={(
            prompt,
            selectedText,
            compareModeT,
            isItComparison,
            files,
            displayPromptOverride
          ) => {
            onSendButtonClick(
              prompt,
              selectedText,
              compareModeT,
              files,
              undefined,
              undefined,
              undefined,
              displayPromptOverride
            );
          }}
          selectedAssistant={selectedAssistant}
          assistantName={assistantName}
          assistants={assistants}
          defaultAssistant={defaultAssistant}
          organizationDefaultAssistant={organizationDefaultAssistant}
          canManageOrganizationDefaultAssistant={
            canManageOrganizationDefaultAssistant
          }
          onAssistantClick={onAssistantClick}
          updateDefaultAssistant={updateDefaultAssistant}
          updateOrganizationDefaultAssistant={updateOrganizationDefaultAssistant}
          currentView={currentView}
          isDocumentChat={false}
          clientHostname={clientHostname}
          compareMode={compareMode}
          compareGuidelinesEnabled={isCompareGuidelinesEnabled}
          onCompareModeChange={
            isCompareGuidelinesEnabled ? onCompareModeChange : undefined
          }
          hideFeedbackRequestText={
            clientHostname !== "app.addy.so" &&
            clientHostname !== "app.addy.com" &&
            clientHostname !== "devmail.addy.so" &&
            clientHostname !== "devmail.addy.com"
              ? true
              : false
          }
          animatedPlaceholders={true}
          inputDisabled={!!interactionLock || !!preparingAskAddyQuery}
          inputDisabledMessage={
            preparingAskAddyQuery?.status ||
            interactionLock?.message ||
            "Please wait a moment before sending another request."
          }
          preparingExternalQuery={preparingAskAddyQuery}
          queuedExternalQueries={queuedAskAddyQueries}
          queuedExternalQueryMessage={ASK_ADDY_QUERY_QUEUED_MESSAGE}
          lockCountdownSeconds={lockCountdown}
          onStopStreaming={stopActiveWork}
          voiceMode={voiceMode}
          isSpeaking={isSpeaking}
          onEndVoice={async () => {
            await endVoice();
            setVoiceMode(false);
          }}
          onStopAudio={stopAudio}
          onChatWithDocs={handleChatWithDocs}
          chatWithDocsEnabled={isChatWithDocsEnabled}
        />
        )}
        <header
          className={`top-bar-new-message${
            AskAddyV2.isEnabled()
              ? ` lendy-v2-header${isV2ProfileBeside ? " lendy-v2-header--beside-panel" : ""}${isV2NewChat ? " lendy-v2-header--new-chat" : ""}`
              : ""
          }`}
          style={
            overlayMode
              ? {
                  padding: "16px",
                  display: "none",
                }
              : {
                  padding: AskAddyV2.isEnabled() ? "12px" : "16px",
                }
          }
        >
          <div className="f-r-a-m-e">
            {/* On a wide sidebar the toggle lives on the rail; a narrow one has no rail to open it from. */}
            {AskAddyV2.isEnabled() && internalNavigation.isEnabled && !isV2Rail && (
              <Tooltip title={isDrawerOpen ? "Collapse chats" : "Chats"} arrow>
                <button
                  type="button"
                  className="lendy-v2-icon-button"
                  aria-label={isDrawerOpen ? "Collapse chats" : "Show chats"}
                  aria-expanded={isDrawerOpen}
                  onClick={toggleDrawer}
                >
                  <LendyIcon name="menu" />
                </button>
              </Tooltip>
            )}
            {!AskAddyV2.isEnabled() && internalNavigation.isEnabled && !isDrawerOpen && (
              <Tooltip key={"toggle-sidebar-1"} title={"Toggle sidebar"} arrow>
                <div
                  className="drawer-button dropdown-button"
                  style={{
                    marginRight: "30px",
                  }}
                  onClick={toggleDrawer}
                >
                  <img
                    width="20"
                    height="20"
                    alt="Toggle sidebar"
                    src="/open-left-drawer.svg"
                  />
                </div>
              </Tooltip>
            )}

            {AskAddyV2.isEnabled() && (
              <LendyHeader
                organizationId={currentOrganizationId || selectedOrganizationId || organizationId}
                userId={uid}
                loanId={currentLoanId || loanId || ""}
                assistantName={v2Assistant?.name}
                assistantImageUrl={v2Assistant?.imageUrl}
                run={v2Run}
                isProfileOpen={v2View === "autopilot"}
                isAgentMenuOpen={Boolean(agentMenuAnchor)}
                onOpenAgentMenu={toggleAgentMenu}
                onOpenProfile={() => setV2View((view) => (view === "autopilot" ? "chat" : "autopilot"))}
                onStatusChange={setV2StatusTone}
              />
            )}
            {!AskAddyV2.isEnabled() && (
            <Tooltip
              key={"chat-private-tooltip-1"}
              title={"Your chat is private, secure, and only visible to you"}
              arrow
            >
              <img
                className="addy-check-security tooltip-1"
                width="18"
                height="16"
                src="/lock-icon-24.png"
              />
            </Tooltip>
            )}

            {/* With Ask Addy v2 on, the assistant (above) replaces the classic assistant picker. */}
            {!AskAddyV2.isEnabled() && (
            <div id="addy-header-assistant-select-parent">
              <Tooltip
                key={"assistant-tooltip-top"}
                title={"Select your assistant or create a new one"}
                arrow
              >
                <div
                  ref={assistantTopSelectRef}
                  className="button dropdown-button no-border-and-space-between"
                  id="addy-header-assistant-select"
                  onClick={() => {
                    setReferencedElementId(
                      "addy-header-assistant-select-parent"
                    );
                    setShowDropdown(true);
                  }}
                >
                  <div className="addy-assistant">
                    {selectedAssistant
                      ? truncateAssistantName(
                          getWhiteLabeledAssistantName(selectedAssistant, assistantName),
                          17
                        )
                      : "Loading..."}
                  </div>

                  {/* <img className="plus-icon" alt="" src="/plus.svg" /> */}
                  <img
                    className="expand-icon tooltip-2"
                    alt=""
                    src="/expand.svg"
                  />
                </div>
              </Tooltip>
            </div>
            )}

            {agentMenuAnchor && (
              <AgentMenu
                anchor={agentMenuAnchor}
                agents={agentOptions}
                activeId={activeAgentId}
                onPick={pickAgent}
                onClose={() => setAgentMenuAnchor(null)}
              />
            )}

            {/* Show assistants drop down */}
            {showDropdown && (
              <div>
                <ChatAssistantDropDown2
                  displayPosition="bottom"
                  assistants={assistants}
                  portalMode={mode === "documentPortal"}
                  hideAvatar={true}
                  selectedAssistant={selectedAssistant}
                  assistantName={assistantName}
                  referencedElementId={referecedElementId}
                  defaultAssistant={defaultAssistant}
                  organizationDefaultAssistant={organizationDefaultAssistant}
                  canManageOrganizationDefaultAssistant={
                    canManageOrganizationDefaultAssistant
                  }
                  onAssistantClick={onAssistantClick}
                  updateDefaultAssistant={updateDefaultAssistant}
                  updateOrganizationDefaultAssistant={
                    updateOrganizationDefaultAssistant
                  }
                  headerText="Agents"
                  createNewLink={GlobalVariables.getAppOrigin(clientHostname)}
                  ref={dropdownRef}
                  marginRight={
                    referecedElementId === "addy-header-assistant-select"
                      ? "0px"
                      : ""
                  }
                />
              </div>
            )}
          </div>
          <div className="button-parent">
            {/* <Tooltip
                            key={"chat-history-tooltip"}
                            title={"Switch chats or create a new chat"}
                            arrow
                        >
                            <div
                                ref={chatHistoryInfoRef}
                                className="addy-chat-history-select-buton button dropdown-button no-border-and-space-between"
                                id="addy-chat-history-select"
                                onClick={onShowChatHistoryClick}
                            >
                                <div className="addy-assistant chat-history-name-text">
                                    {chatName === "sidebar.addy.so"
                                        ? "New chat"
                                        : chatName.length > 15
                                            ? `${chatName.substring(0, 12)}...`
                                            : chatName}
                                </div>
                                <img className="expand-icon" alt="" src="/expand.svg" />
                            </div>
                        </Tooltip> */}

            {clientID && (
              <div className="open-in-full-parent tooltip-3">
                {/* These images are being added
                                from the chrome extension
                                page to close and expand the sidebar chat */}
                {/* <img
                    className="open-in-full"
                    loading="lazy"
                    alt=""
                    src="/open-in-full.svg"/>
                    <img
                        className="close-icon"
                        loading="lazy"
                        alt=""
                        src="/close.svg"/> 
                */}
              </div>
            )}
          </div>
        </header>
        <ToastContainer />
      </div>

      {showUpgrade && (
        <RequireUpgradeModal
          open={showUpgrade}
          onClose={() => setShowUpgrade(false)}
          uid={uid}
          organizationID={organizationId || ""}
        />
      )}
        </>
      )}

      {/* Floating Toggle Button - Hidden for now since research page is the default */}
      {false && iframeUrl && clientHostname && !clientHostname.includes('addy.so') && (
        <Tooltip 
          title={contentMode === 'iframe' ? 'Switch to Chat' : 'Switch to Processing Checklist'} 
          arrow 
          placement="left"
          componentsProps={{
            tooltip: {
              sx: {
                zIndex: 10001,
              }
            },
            popper: {
              sx: {
                zIndex: 10001,
              }
            }
          }}
        >
          <IconButton
            aria-label="toggle view"
            onClick={() => {
              const newMode = contentMode === 'iframe' ? 'chat' : 'iframe';
              setContentMode(newMode);
            }}
            style={{
              position: 'fixed',
              top: '8px',
              right: '85px',
              zIndex: 10000,
              color: "var(--text-muted)",
            }}
            size="small"
          >
            {contentMode === 'iframe' ? <ChatBubbleOutline /> : <GradingOutlined />}
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default Chat;
